import { styled, SvgIcon } from "@mui/material";
import React from "react";


export function KSWordPressIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };
  return (
    <MuiSvgIcon {...props}>
      <path
        color={props.color}
        d="M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0z M1.2,12c0-1.6,0.3-3,0.9-4.4l5.1,14.1  C3.7,20,1.2,16.3,1.2,12z M12,22.8c-1.1,0-2.1-0.2-3-0.4l3.2-9.4l3.3,9.1c0,0,0,0.1,0.1,0.1C14.5,22.6,13.3,22.8,12,22.8z M13.5,6.9  c0.6,0,1.2-0.1,1.2-0.1c0.6-0.1,0.5-0.9-0.1-0.9c0,0-1.8,0.1-2.9,0.1c-1.1,0-2.8-0.1-2.8-0.1c-0.6,0-0.6,0.9-0.1,0.9  c0,0,0.6,0.1,1.1,0.1l1.7,4.6l-2.4,7.1L5.4,6.9c0.6,0,1.2-0.1,1.2-0.1C7.2,6.8,7.1,5.9,6.6,6c0,0-1.8,0.1-2.9,0.1  c-0.2,0-0.4,0-0.7,0c1.9-2.9,5.3-4.9,9-4.9c2.8,0,5.4,1.1,7.3,2.8c0,0-0.1,0-0.1,0C18.1,4,17.3,5,17.3,6c0,0.9,0.5,1.6,1.1,2.5  c0.4,0.7,0.9,1.6,0.9,3c0,0.9-0.4,2-0.8,3.5l-1.1,3.6L13.5,6.9L13.5,6.9z M21.5,6.8c1.3,2.5,1.7,5.4,0.9,8.1c-0.8,2.7-2.5,5-5,6.4  l3.3-9.5c0.6-1.5,0.8-2.8,0.8-3.9C21.5,7.5,21.5,7.2,21.5,6.8L21.5,6.8z"
      />
    </MuiSvgIcon>
  );
}

export function KSEyeIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M14.9998 12C14.9998 13.6569 13.6566 15 11.9998 15C10.3429 15 8.99976 13.6569 8.99976 12C8.99976 10.3431 10.3429 9 11.9998 9C13.6566 9 14.9998 10.3431 14.9998 12Z" />
      <path d="M2.45801 12C3.73228 7.94288 7.52257 5 12.0002 5C16.4778 5 20.2681 7.94291 21.5424 12C20.2681 16.0571 16.4778 19 12.0002 19C7.52256 19 3.73226 16.0571 2.45801 12Z" />
    </MuiSvgIcon>
  );
}

export function KSUserIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSUserIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));

  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };
  return (
    <MuiSvgIcon {...props}>
      <path d="M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z" />
      <path d="M12 14C8.13401 14 5 17.134 5 21H19C19 17.134 15.866 14 12 14Z" />
    </MuiSvgIcon>
  );
}

export function KSArrowDownSmIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));

  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };
  return (
    <MuiSvgIcon {...props}>
      <path d="M11 8L6 13M6 13L1 8M6 13L6 1" />
    </MuiSvgIcon>
  );
}

export function KSArrowLeftSmIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));

  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };
  return (
    <MuiSvgIcon {...props}>
      <path d="M6 11L1 6M1 6L6 1M1 6L13 6" />
    </MuiSvgIcon>
  );
}

export function KSArrowRightSmIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSArrowRightSmIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));

  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };
  return (
    <MuiSvgIcon {...props}>
      <path d="M8 1L13 6M13 6L8 11M13 6L1 6" />
    </MuiSvgIcon>
  );
}

export function KSArrowUpSmIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSArrowUpSmIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));

  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };
  return (
    <MuiSvgIcon {...props}>
      <path d="M1 6L6 1M6 1L11 6M6 1V13" />
    </MuiSvgIcon>
  );
}

export function KSChatRectangleSmIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSChatRectangleSmIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));

  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };
  return (
    <MuiSvgIcon {...props}>
      <path d="M15 10.3333C15 11.1924 14.3036 11.8889 13.4444 11.8889H4.11111L1 15V2.55556C1 1.69645 1.69645 1 2.55556 1H13.4444C14.3036 1 15 1.69645 15 2.55556V10.3333Z" />
    </MuiSvgIcon>
  );
}


export function KSChatNewImage({ fill = "none", notification = false, ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSChatImage",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    position: 'relative', // Ensure the container is relative for absolute positioning of the notification
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));

  // Badge styling
  const Badge = styled('svg')(({ theme }) => ({
    position: 'absolute',
    top: '5px', // Adjust position as needed
    right: '-5px', // Adjust position as needed
    width: '12px', // Increase width
    height: '12px', // Increase height
    fill: 'green', // Just for testing, replace with your desired color
    borderRadius: '50%',
    zIndex: '1',
  }));

  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      {notification && <Badge viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 10.4445C21.0038 11.911 20.6612 13.3577 20 14.6667C18.401 17.8659 15.1321 19.8875 11.5555 19.8889C10.089 19.8927 8.64234 19.5501 7.33332 18.8889L1 21L3.11111 14.6667C2.44992 13.3577 2.10729 11.911 2.11111 10.4445C2.11249 6.8679 4.13407 3.59896 7.33332 2.00003C8.64234 1.33884 10.089 0.996208 11.5555 1.00003H12.1111C16.9064 1.26459 20.7354 5.09357 21 9.88891V10.4445Z" fillRule="evenodd" clipRule="evenodd" />
      </Badge>
      }

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 10.4445C21.0038 11.911 20.6612 13.3577 20 14.6667C18.401 17.8659 15.1321 19.8875 11.5555 19.8889C10.089 19.8927 8.64234 19.5501 7.33332 18.8889L1 21L3.11111 14.6667C2.44992 13.3577 2.10729 11.911 2.11111 10.4445C2.11249 6.8679 4.13407 3.59896 7.33332 2.00003C8.64234 1.33884 10.089 0.996208 11.5555 1.00003H12.1111C16.9064 1.26459 20.7354 5.09357 21 9.88891V10.4445Z"
      />
    </MuiSvgIcon>
  );
}




export function KSChatSmIcon({ fill = "none", notification = true, ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSChatSmIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));




  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };
  return (
    <MuiSvgIcon {...props}>

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 10.4445C21.0038 11.911 20.6612 13.3577 20 14.6667C18.401 17.8659 15.1321 19.8875 11.5555 19.8889C10.089 19.8927 8.64234 19.5501 7.33332 18.8889L1 21L3.11111 14.6667C2.44992 13.3577 2.10729 11.911 2.11111 10.4445C2.11249 6.8679 4.13407 3.59896 7.33332 2.00003C8.64234 1.33884 10.089 0.996208 11.5555 1.00003H12.1111C16.9064 1.26459 20.7354 5.09357 21 9.88891V10.4445Z"
      />
    </MuiSvgIcon>
  );
}

export function KSDeleteSmIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSDeleteSmIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));

  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };
  return (
    <MuiSvgIcon {...props}>
      <path d="M5.18188 2.27273C5.18188 2.1221 5.30399 2 5.45461 2H8.00007C8.15069 2 8.27279 2.1221 8.27279 2.27273V2.54541H5.18188V2.27273ZM3.18188 2.54541H2.27273H1C0.447715 2.54541 0 2.99313 0 3.54541C0 4.09769 0.447715 4.54541 1 4.54541H1.27279V12.4545C1.27279 13.7097 2.29033 14.7273 3.54552 14.7273H9.90916C11.1643 14.7273 12.1819 13.7097 12.1819 12.4545V4.54541H12.4545C13.0068 4.54541 13.4545 4.09769 13.4545 3.54541C13.4545 2.99313 13.0068 2.54541 12.4545 2.54541H10.2728V2.27273C10.2728 1.01753 9.25526 0 8.00007 0H5.45461C4.19942 0 3.18188 1.01753 3.18188 2.27273V2.54541ZM9.26328 4.54541C9.26645 4.54544 9.26962 4.54545 9.27279 4.54545H10.1819V12.4545C10.1819 12.6052 10.0598 12.7273 9.90916 12.7273H3.54552C3.3949 12.7273 3.27279 12.6052 3.27279 12.4545V4.54545H4.18188C4.18506 4.54545 4.18823 4.54544 4.1914 4.54541H9.26328Z" />
    </MuiSvgIcon>
  );
}

export function KSDonwloadSmIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSDonwloadSmIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));

  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };
  return (
    <MuiSvgIcon {...props}>
      <path d="M4.5 8L7.3 10.8L10.1 8" />
      <path d="M1 11.5V13.6C1 14.3732 1.6268 15 2.4 15H12.2C12.9732 15 13.6 14.3732 13.6 13.6V11.5" />
      <path d="M7.2998 1V10.8" />
    </MuiSvgIcon>
  );
}

export function KSEditSmIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEditSmIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));

  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };
  return (
    <MuiSvgIcon {...props}>
      <path d="M11.7071 0.292893C11.3166 -0.0976311 10.6834 -0.0976311 10.2929 0.292893L3.62623 6.95956C3.43869 7.1471 3.33333 7.40145 3.33333 7.66667V10.3333C3.33333 10.8856 3.78105 11.3333 4.33333 11.3333H7C7.26522 11.3333 7.51957 11.228 7.70711 11.0404L14.3738 4.37377C14.7643 3.98325 14.7643 3.35008 14.3738 2.95956L11.7071 0.292893ZM5.33333 9.33333V8.08088L11 2.41421L12.2525 3.66667L6.58579 9.33333H5.33333ZM2 2.99984C2 2.81574 2.14924 2.6665 2.33333 2.6665H5.89333C6.44562 2.6665 6.89333 2.21879 6.89333 1.6665C6.89333 1.11422 6.44562 0.666504 5.89333 0.666504H2.33333C1.04467 0.666504 0 1.71117 0 2.99984V12.3332C0 13.6218 1.04467 14.6665 2.33333 14.6665H11.6667C12.9553 14.6665 14 13.6218 14 12.3332V8.77317C14 8.22089 13.5523 7.77317 13 7.77317C12.4477 7.77317 12 8.22089 12 8.77317V12.3332C12 12.5173 11.8508 12.6665 11.6667 12.6665H2.33333C2.14924 12.6665 2 12.5173 2 12.3332V2.99984Z" />
    </MuiSvgIcon>
  );
}

export function KSEditUserSmIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 26 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M21.489 5.49219L24.9971 9.0003L16.2269 17.7706H12.7188V14.2625L21.489 5.49219Z" />
      <path d="M8.54254 12.8516L5.11698 12.8516C3.3006 12.8516 1.82813 14.3242 1.82812 16.1408V17.7854" />
      <path d="M7.99198 9.56285C9.80836 9.56285 11.2808 8.09021 11.2808 6.27361C11.2808 4.45702 9.80836 2.98438 7.99198 2.98438C6.1756 2.98438 4.70312 4.45702 4.70312 6.27361C4.70312 8.09021 6.1756 9.56285 7.99198 9.56285Z" />
    </MuiSvgIcon>
  );
}

export function KSMessageSmIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSMessageSmIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.17261 2.15578C2.27282 2.05964 2.40822 2 2.55567 2H15.0001C15.1476 2 15.2829 2.05963 15.3831 2.15576L8.77786 6.77945L2.17261 2.15578ZM0.000190148 2.53527C-3.35e-05 2.54675 -5.96826e-05 2.55822 0.000110659 2.56969V11.8889C0.000110659 13.2967 1.14783 14.4444 2.55567 14.4444H15.0001C16.408 14.4444 17.5557 13.2967 17.5557 11.8889V2.56587M15.5557 4.4763V11.8889C15.5557 12.1922 15.3034 12.4444 15.0001 12.4444H2.55567C2.2524 12.4444 2.00011 12.1922 2.00011 11.8889V4.47634L8.2044 8.81934C8.54872 9.06036 9.00701 9.06036 9.35133 8.81934L15.5557 4.4763ZM17.5556 2.54013C17.5473 1.13934 16.4028 0 15.0001 0H2.55567C1.15459 0 0.0111527 1.13671 0.000190148 2.53527"
        fillOpacity="0.6"
      />
    </MuiSvgIcon>
  );
}

export function KSMultiDocIconSmIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M5.16667 18.5H11C11.9205 18.5 12.6667 17.7538 12.6667 16.8333V8.84518C12.6667 8.62416 12.5789 8.4122 12.4226 8.25592L7.91074 3.74408C7.75446 3.5878 7.5425 3.5 7.32149 3.5H2.66667C1.74619 3.5 1 4.24619 1 5.16667V14.3333M1 18.5L5.06557 14.4344M5.06557 14.4344C5.51798 14.8868 6.14298 15.1667 6.83333 15.1667C8.21405 15.1667 9.33333 14.0474 9.33333 12.6667C9.33333 11.286 8.21405 10.1667 6.83333 10.1667C5.45262 10.1667 4.33333 11.286 4.33333 12.6667C4.33333 13.357 4.61316 13.982 5.06557 14.4344Z" />
      <path d="M12.834 16.5C13.834 18 16.5007 15.2538 16.5007 14.3333V6.34518C16.5007 6.12416 16.4129 5.9122 16.2566 5.75592L11.7447 1.24408C11.5884 1.0878 11.3765 1 11.1555 1H6.50065C5.58018 1 4.83398 1.74619 4.83398 2.66667" />
    </MuiSvgIcon>
  );
}

export function KSReassingMlpSmIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M11.625 13.125V11.875C11.625 10.4943 10.5057 9.375 9.125 9.375H4.125C2.74429 9.375 1.625 10.4943 1.625 11.875V13.125" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.625 6.875C8.00571 6.875 9.125 5.75571 9.125 4.375C9.125 2.99429 8.00571 1.875 6.625 1.875C5.24429 1.875 4.125 2.99429 4.125 4.375C4.125 5.75571 5.24429 6.875 6.625 6.875Z"
      />
      <path d="M15.375 13.1248V11.8748C15.3742 10.7355 14.6031 9.74088 13.5 9.45605" />
      <path d="M11 1.95605C12.1062 2.23929 12.8799 3.23605 12.8799 4.37793C12.8799 5.51981 12.1062 6.51657 11 6.7998" />
    </MuiSvgIcon>
  );
}

export function KSRevokeMlpSmIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M11.625 13.125V11.875C11.625 10.4943 10.5057 9.375 9.125 9.375H4.125C2.74429 9.375 1.625 10.4943 1.625 11.875V13.125" />
      <path d="M6.625 6.875C8.00571 6.875 9.125 5.75571 9.125 4.375C9.125 2.99429 8.00571 1.875 6.625 1.875" />
      <path d="M15.375 13.1243V11.8743C15.3742 10.735 14.6031 9.74039 13.5 9.45557" />
      <path d="M11 1.95557C12.1062 2.2388 12.8799 3.23556 12.8799 4.37744C12.8799 5.51932 12.1062 6.51609 11 6.79932" />
      <g clipPath="url(#clip0_10099_157395)">
        <path d="M3.70833 4.79167L4.125 4.375M4.125 4.375L4.54167 3.95833M4.125 4.375L3.70833 3.95833M4.125 4.375L4.54167 4.79167M6 4.375C6 5.41053 5.16053 6.25 4.125 6.25C3.08947 6.25 2.25 5.41053 2.25 4.375C2.25 3.33947 3.08947 2.5 4.125 2.5C5.16053 2.5 6 3.33947 6 4.375Z" />
      </g>
    </MuiSvgIcon>
  );
}

export function KSAcademicCapIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",

    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M12 14L21 9L12 4L3 9L12 14ZM12 14L18.1591 10.5783C18.7017 11.9466 19 13.4384 19 14.9999C19 15.7013 18.9398 16.3885 18.8244 17.0569C16.2143 17.3106 13.849 18.4006 12 20.0555C10.151 18.4006 7.78571 17.3106 5.17562 17.0569C5.06017 16.3885 5 15.7012 5 14.9999C5 13.4384 5.29824 11.9466 5.84088 10.5782L12 14ZM8 19.9999V12.5L12 10.2778" />
    </MuiSvgIcon>
  );
}

export function KSAdjustmentsIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M12 6V4M12 6C10.8954 6 10 6.89543 10 8C10 9.10457 10.8954 10 12 10M12 6C13.1046 6 14 6.89543 14 8C14 9.10457 13.1046 10 12 10M6 18C7.10457 18 8 17.1046 8 16C8 14.8954 7.10457 14 6 14M6 18C4.89543 18 4 17.1046 4 16C4 14.8954 4.89543 14 6 14M6 18V20M6 14V4M12 10V20M18 18C19.1046 18 20 17.1046 20 16C20 14.8954 19.1046 14 18 14M18 18C16.8954 18 16 17.1046 16 16C16 14.8954 16.8954 14 18 14M18 18V20M18 14V4" />
    </MuiSvgIcon>
  );
}

export function KSAnnotationIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M7 8H17M7 12H11M12 20L8 16H5C3.89543 16 3 15.1046 3 14V6C3 4.89543 3.89543 4 5 4H19C20.1046 4 21 4.89543 21 6V14C21 15.1046 20.1046 16 19 16H16L12 20Z" />
    </MuiSvgIcon>
  );
}

export function KSArchiveIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M5 8H19M5 8C3.89543 8 3 7.10457 3 6C3 4.89543 3.89543 4 5 4H19C20.1046 4 21 4.89543 21 6C21 7.10457 20.1046 8 19 8M5 8L5 18C5 19.1046 5.89543 20 7 20H17C18.1046 20 19 19.1046 19 18V8M10 12H14" />
    </MuiSvgIcon>
  );
}

export function KSArrowCircleDownIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M15 13L12 16M12 16L9 13M12 16L12 8M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21Z" />
    </MuiSvgIcon>
  );
}

export function KSArrowCircleLeftIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M11 15L8 12M8 12L11 9M8 12L16 12M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z" />
    </MuiSvgIcon>
  );
}

export function KSArrowCircleRightIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M13 9L16 12M16 12L13 15M16 12L8 12M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" />
    </MuiSvgIcon>
  );
}

export function KSArrowCircleUpIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M9 11L12 8M12 8L15 11M12 8L12 16M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3Z" />
    </MuiSvgIcon>
  );
}

export function KSArrowDownIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M19 14L12 21M12 21L5 14M12 21L12 3" />
    </MuiSvgIcon>
  );
}

export function KSArrowLeftIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M10 19L3 12M3 12L10 5M3 12L21 12" />
    </MuiSvgIcon>
  );
}

export function KSArrowNarrowDownIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M16 17L12 21M12 21L8 17M12 21L12 3" />
    </MuiSvgIcon>
  );
}

export function KSArrowNarrowLeftIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M7 16L3 12M3 12L7 8M3 12L21 12" />
    </MuiSvgIcon>
  );
}

export function KSArrowNarrowRightIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M17 8L21 12M21 12L17 16M21 12L3 12" />
    </MuiSvgIcon>
  );
}

export function KSArrowNarrowUpIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M8 7L12 3M12 3L16 7M12 3V21" />
    </MuiSvgIcon>
  );
}

export function KSArrowRightIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M14 5L21 12M21 12L14 19M21 12L3 12" />
    </MuiSvgIcon>
  );
}

export function KSArrowUpIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M5 10L12 3M12 3L19 10M12 3V21" />
    </MuiSvgIcon>
  );
}

export function KSArrowExpandIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M4 8V4M4 4H8M4 4L9 9M20 8V4M20 4H16M20 4L15 9M4 16V20M4 20H8M4 20L9 15M20 20L15 15M20 20V16M20 20H16" />
    </MuiSvgIcon>
  );
}

export function KSAtSymbolIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12ZM16 12V13.5C16 14.8807 17.1193 16 18.5 16C19.8807 16 21 14.8807 21 13.5V12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21M16.5 19.7942C15.0801 20.614 13.5296 21.0029 12 21.0015" />
    </MuiSvgIcon>
  );
}

export function KSBackspaceIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M12 14L14 12M14 12L16 10M14 12L12 10M14 12L16 14M3 12L9.41421 18.4142C9.78929 18.7893 10.298 19 10.8284 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H10.8284C10.298 5 9.78929 5.21071 9.41421 5.58579L3 12Z" />
    </MuiSvgIcon>
  );
}

export function KSBadgeCheckIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M8.99963 12.0001L10.9996 14.0001L14.9996 10.0001M7.83437 4.69717C8.55191 4.63991 9.23309 4.35775 9.78095 3.89087C11.0594 2.80135 12.9398 2.80135 14.2183 3.89087C14.7662 4.35775 15.4474 4.63991 16.1649 4.69717C17.8393 4.83079 19.169 6.16043 19.3026 7.83486C19.3598 8.55239 19.642 9.23358 20.1089 9.78144C21.1984 11.0599 21.1984 12.9403 20.1089 14.2188C19.642 14.7667 19.3598 15.4479 19.3026 16.1654C19.169 17.8398 17.8393 19.1695 16.1649 19.3031C15.4474 19.3603 14.7662 19.6425 14.2183 20.1094C12.9398 21.1989 11.0594 21.1989 9.78095 20.1094C9.23309 19.6425 8.55191 19.3603 7.83437 19.3031C6.15994 19.1695 4.8303 17.8398 4.69668 16.1654C4.63942 15.4478 4.35727 14.7667 3.89038 14.2188C2.80086 12.9403 2.80086 11.0599 3.89038 9.78144C4.35727 9.23358 4.63942 8.55239 4.69668 7.83486C4.8303 6.16043 6.15994 4.83079 7.83437 4.69717Z" />
    </MuiSvgIcon>
  );
}

export function KSBanIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path
        d="M18.364 18.364C21.8787 14.8492 21.8787 9.15076 18.364 5.63604C14.8492 2.12132 9.15076 2.12132 5.63604 5.63604M18.364 18.364C14.8492 21.8787 9.15076 21.8787 5.63604 18.364C2.12132 14.8492 2.12132 9.15076 5.63604 5.63604M18.364 18.364L5.63604 5.63604"
        stroke="#111827"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </MuiSvgIcon>
  );
}

export function KSBeakerIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M19.428 15.4282C19.1488 15.149 18.7932 14.9587 18.406 14.8812L16.0185 14.4037C14.7101 14.1421 13.3519 14.324 12.1585 14.9207L11.8411 15.0793C10.6477 15.676 9.28948 15.8579 7.98113 15.5963L6.04938 15.2099C5.39366 15.0788 4.71578 15.284 4.24294 15.7569M7.9998 4H15.9998L14.9998 5V10.1716C14.9998 10.702 15.2105 11.2107 15.5856 11.5858L20.5856 16.5858C21.8455 17.8457 20.9532 20 19.1714 20H4.82823C3.04642 20 2.15409 17.8457 3.41401 16.5858L8.41402 11.5858C8.78909 11.2107 8.9998 10.702 8.9998 10.1716V5L7.9998 4Z" />
    </MuiSvgIcon>
  );
}

export function KSBellIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M15 17H20L18.5951 15.5951C18.2141 15.2141 18 14.6973 18 14.1585V11C18 8.38757 16.3304 6.16509 14 5.34142V5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5V5.34142C7.66962 6.16509 6 8.38757 6 11V14.1585C6 14.6973 5.78595 15.2141 5.40493 15.5951L4 17H9M15 17V18C15 19.6569 13.6569 21 12 21C10.3431 21 9 19.6569 9 18V17M15 17H9" />
    </MuiSvgIcon>
  );
}

export function KSBookOpenIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M12 6.25278V19.2528M12 6.25278C10.8321 5.47686 9.24649 5 7.5 5C5.75351 5 4.16789 5.47686 3 6.25278V19.2528C4.16789 18.4769 5.75351 18 7.5 18C9.24649 18 10.8321 18.4769 12 19.2528M12 6.25278C13.1679 5.47686 14.7535 5 16.5 5C18.2465 5 19.8321 5.47686 21 6.25278V19.2528C19.8321 18.4769 18.2465 18 16.5 18C14.7535 18 13.1679 18.4769 12 19.2528" />
    </MuiSvgIcon>
  );
}

export function KSBookMarkAltIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M16 4V16L12 14L8 16V4M6 20H18C19.1046 20 20 19.1046 20 18V6C20 4.89543 19.1046 4 18 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20Z" />
    </MuiSvgIcon>
  );
}

export function KSBookMarkIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M5 5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V21L12 17.5L5 21V5Z" />
    </MuiSvgIcon>
  );
}

export function KSBriefcaseIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M21 13.2554C18.2207 14.3805 15.1827 15 12 15C8.8173 15 5.7793 14.3805 3 13.2554M16 6V4C16 2.89543 15.1046 2 14 2H10C8.89543 2 8 2.89543 8 4V6M12 12H12.01M5 20H19C20.1046 20 21 19.1046 21 18V8C21 6.89543 20.1046 6 19 6H5C3.89543 6 3 6.89543 3 8V18C3 19.1046 3.89543 20 5 20Z" />
    </MuiSvgIcon>
  );
}

export function KSCakeIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M21 15.5458C20.4771 15.5458 19.9542 15.6972 19.5 16C18.5917 16.6056 17.4083 16.6056 16.5 16C15.5917 15.3944 14.4083 15.3944 13.5 16C12.5917 16.6056 11.4083 16.6056 10.5 16C9.59167 15.3944 8.40833 15.3944 7.5 16C6.59167 16.6056 5.40833 16.6056 4.5 16C4.04584 15.6972 3.52292 15.5458 3 15.5458M9 6V8M12 6V8M15 6V8M9 3H9.01M12 3H12.01M15 3H15.01M21 21V14C21 12.8954 20.1046 12 19 12H5C3.89543 12 3 12.8954 3 14V21H21ZM18 12V10C18 8.89543 17.1046 8 16 8H8C6.89543 8 6 8.89543 6 10V12H18Z" />
    </MuiSvgIcon>
  );
}

export function KSCalculatorIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M9 7H15M15 17V14M12 17H12.01M9 17H9.01M9 14H9.01M12 14H12.01M15 11H15.01M12 11H12.01M9 11H9.01M7 21H17C18.1046 21 19 20.1046 19 19V5C19 3.89543 18.1046 3 17 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21Z" />
    </MuiSvgIcon>
  );
}

export function KSCalendarIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M8 7V3M16 7V3M7 11H17M5 21H19C20.1046 21 21 20.1046 21 19V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V19C3 20.1046 3.89543 21 5 21Z" />
    </MuiSvgIcon>
  );
}

export function KSCameraIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M3 9C3 7.89543 3.89543 7 5 7H5.92963C6.59834 7 7.2228 6.6658 7.59373 6.1094L8.40627 4.8906C8.7772 4.3342 9.40166 4 10.0704 4H13.9296C14.5983 4 15.2228 4.3342 15.5937 4.8906L16.4063 6.1094C16.7772 6.6658 17.4017 7 18.0704 7H19C20.1046 7 21 7.89543 21 9V18C21 19.1046 20.1046 20 19 20H5C3.89543 20 3 19.1046 3 18V9Z" />
      <path d="M15 13C15 14.6569 13.6569 16 12 16C10.3431 16 9 14.6569 9 13C9 11.3431 10.3431 10 12 10C13.6569 10 15 11.3431 15 13Z" />
    </MuiSvgIcon>
  );
}

export function KSCashIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M17 9V7C17 5.89543 16.1046 5 15 5H5C3.89543 5 3 5.89543 3 7V13C3 14.1046 3.89543 15 5 15H7M9 19H19C20.1046 19 21 18.1046 21 17V11C21 9.89543 20.1046 9 19 9H9C7.89543 9 7 9.89543 7 11V17C7 18.1046 7.89543 19 9 19ZM16 14C16 15.1046 15.1046 16 14 16C12.8954 16 12 15.1046 12 14C12 12.8954 12.8954 12 14 12C15.1046 12 16 12.8954 16 14Z" />
    </MuiSvgIcon>
  );
}

export function KSChatBarIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M9 19V13C9 11.8954 8.10457 11 7 11H5C3.89543 11 3 11.8954 3 13V19C3 20.1046 3.89543 21 5 21H7C8.10457 21 9 20.1046 9 19ZM9 19V9C9 7.89543 9.89543 7 11 7H13C14.1046 7 15 7.89543 15 9V19M9 19C9 20.1046 9.89543 21 11 21H13C14.1046 21 15 20.1046 15 19M15 19V5C15 3.89543 15.8954 3 17 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H17C15.8954 21 15 20.1046 15 19Z" />
    </MuiSvgIcon>
  );
}

export function KSChatPieIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M11 3.05469C6.50005 3.55213 3 7.3672 3 11.9998C3 16.9703 7.02944 20.9998 12 20.9998C16.6326 20.9998 20.4476 17.4997 20.9451 12.9998H11V3.05469Z" />
      <path d="M20.4878 8.99976H15V3.51206C17.5572 4.41589 19.5839 6.4426 20.4878 8.99976Z" />
    </MuiSvgIcon>
  );
}

export function KSChatSquareBarIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M16 8V16M12 11V16M8 14V16M6 20H18C19.1046 20 20 19.1046 20 18V6C20 4.89543 19.1046 4 18 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20Z" />
    </MuiSvgIcon>
  );
}

export function KSChatAlt2Icon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M17 8H19C20.1046 8 21 8.89543 21 10V16C21 17.1046 20.1046 18 19 18H17V22L13 18H9C8.44772 18 7.94772 17.7761 7.58579 17.4142M7.58579 17.4142L11 14H15C16.1046 14 17 13.1046 17 12V6C17 4.89543 16.1046 4 15 4H5C3.89543 4 3 4.89543 3 6V12C3 13.1046 3.89543 14 5 14H7V18L7.58579 17.4142Z" />
    </MuiSvgIcon>
  );
}

export function KSChatAltIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M8 10H8.01M12 10H12.01M16 10H16.01M9 16H5C3.89543 16 3 15.1046 3 14V6C3 4.89543 3.89543 4 5 4H19C20.1046 4 21 4.89543 21 6V14C21 15.1046 20.1046 16 19 16H14L9 21V16Z" />
    </MuiSvgIcon>
  );
}

export function KSChatIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M8 12H8.01M12 12H12.01M16 12H16.01M21 12C21 16.4183 16.9706 20 12 20C10.4607 20 9.01172 19.6565 7.74467 19.0511L3 20L4.39499 16.28C3.51156 15.0423 3 13.5743 3 12C3 7.58172 7.02944 4 12 4C16.9706 4 21 7.58172 21 12Z" />
    </MuiSvgIcon>
  );
}

export function KSCheckCircleIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" />
    </MuiSvgIcon>
  );
}

export function KSCheckIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M5 13L9 17L19 7" />
    </MuiSvgIcon>
  );
}

export function KSCheveronDownIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M19 9L12 16L5 9" />
    </MuiSvgIcon>
  );
}

export function KSCheveronLeftIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M15 19L8 12L15 5" />
    </MuiSvgIcon>
  );
}

export function KSCheveronRightIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M9 5L16 12L9 19" />
    </MuiSvgIcon>
  );
}

export function KSCheveronUpIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M5 15L12 8L19 15" />
    </MuiSvgIcon>
  );
}

export function KSCheveronDoubleDownIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M19 13L12 20L5 13M19 5L12 12L5 5" />
    </MuiSvgIcon>
  );
}

export function KSCheveronDoubleLeftIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M11 19L4 12L11 5M19 19L12 12L19 5" />
    </MuiSvgIcon>
  );
}

export function KSCheveronDoubleRightIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M13 5L20 12L13 19M5 5L12 12L5 19" />
    </MuiSvgIcon>
  );
}

export function KSCheveronDoubleUpIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M5 11L12 4L19 11M5 19L12 12L19 19" />
    </MuiSvgIcon>
  );
}

export function KSChipIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M9 3V5M15 3V5M9 19V21M15 19V21M5 9H3M5 15H3M21 9H19M21 15H19M7 19H17C18.1046 19 19 18.1046 19 17V7C19 5.89543 18.1046 5 17 5H7C5.89543 5 5 5.89543 5 7V17C5 18.1046 5.89543 19 7 19ZM9 9H15V15H9V9Z" />
    </MuiSvgIcon>
  );
}

export function KSClipBoardCheckIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M9.70711 13.2929C9.31658 12.9024 8.68342 12.9024 8.29289 13.2929C7.90237 13.6834 7.90237 14.3166 8.29289 14.7071L9.70711 13.2929ZM11 16L10.2929 16.7071C10.6834 17.0976 11.3166 17.0976 11.7071 16.7071L11 16ZM15.7071 12.7071C16.0976 12.3166 16.0976 11.6834 15.7071 11.2929C15.3166 10.9024 14.6834 10.9024 14.2929 11.2929L15.7071 12.7071ZM18 7V19H20V7H18ZM17 20H7V22H17V20ZM6 19V7H4V19H6ZM7 6H9V4H7V6ZM15 6H17V4H15V6ZM7 20C6.44772 20 6 19.5523 6 19H4C4 20.6569 5.34315 22 7 22V20ZM18 19C18 19.5523 17.5523 20 17 20V22C18.6569 22 20 20.6569 20 19H18ZM20 7C20 5.34315 18.6569 4 17 4V6C17.5523 6 18 6.44772 18 7H20ZM6 7C6 6.44772 6.44772 6 7 6V4C5.34315 4 4 5.34315 4 7H6ZM8.29289 14.7071L10.2929 16.7071L11.7071 15.2929L9.70711 13.2929L8.29289 14.7071ZM11.7071 16.7071L15.7071 12.7071L14.2929 11.2929L10.2929 15.2929L11.7071 16.7071ZM11 4H13V2H11V4ZM13 6H11V8H13V6ZM11 6C10.4477 6 10 5.55228 10 5H8C8 6.65685 9.34315 8 11 8V6ZM14 5C14 5.55228 13.5523 6 13 6V8C14.6569 8 16 6.65685 16 5H14ZM13 4C13.5523 4 14 4.44772 14 5H16C16 3.34315 14.6569 2 13 2V4ZM11 2C9.34315 2 8 3.34315 8 5H10C10 4.44772 10.4477 4 11 4V2Z" />
    </MuiSvgIcon>
  );
}

export function KSClipBoardCopyIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M8 5H6C4.89543 5 4 5.89543 4 7V19C4 20.1046 4.89543 21 6 21H16C17.1046 21 18 20.1046 18 19V18M8 5C8 6.10457 8.89543 7 10 7H12C13.1046 7 14 6.10457 14 5M8 5C8 3.89543 8.89543 3 10 3H12C13.1046 3 14 3.89543 14 5M14 5H16C17.1046 5 18 5.89543 18 7V10M20 14H10M10 14L13 11M10 14L13 17" />
    </MuiSvgIcon>
  );
}

export function KSClipBoardListIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15M9 5C9 6.10457 9.89543 7 11 7H13C14.1046 7 15 6.10457 15 5M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5M12 12H15M12 16H15M9 12H9.01M9 16H9.01" />
    </MuiSvgIcon>
  );
}

export function KSClipBoardIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path
        color={props.color}
        d="M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15M9 5C9 6.10457 9.89543 7 11 7H13C14.1046 7 15 6.10457 15 5M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5"
      />
    </MuiSvgIcon>
  );
}

export function KSClockIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path
        d="M12 8V12L15 15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
      />
    </MuiSvgIcon>
  );
}

export function KSCloudDownloadIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M7 16C4.79086 16 3 14.2091 3 12C3 10.0929 4.33457 8.4976 6.12071 8.09695C6.04169 7.74395 6 7.37684 6 7C6 4.23858 8.23858 2 11 2C13.4193 2 15.4373 3.71825 15.9002 6.00098C15.9334 6.00033 15.9666 6 16 6C18.7614 6 21 8.23858 21 11C21 13.419 19.2822 15.4367 17 15.9M9 19L12 22M12 22L15 19M12 22V10" />
    </MuiSvgIcon>
  );
}

export function KSCloudUploadIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M7 16C4.79086 16 3 14.2091 3 12C3 10.0929 4.33457 8.4976 6.12071 8.09695C6.04169 7.74395 6 7.37684 6 7C6 4.23858 8.23858 2 11 2C13.4193 2 15.4373 3.71825 15.9002 6.00098C15.9334 6.00033 15.9666 6 16 6C18.7614 6 21 8.23858 21 11C21 13.419 19.2822 15.4367 17 15.9M15 13L12 10M12 10L9 13M12 10L12 22" />
    </MuiSvgIcon>
  );
}

export function KSCloudIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M3 15C3 17.2091 4.79086 19 7 19H16C18.7614 19 21 16.7614 21 14C21 11.2386 18.7614 9 16 9C15.9666 9 15.9334 9.00033 15.9002 9.00098C15.4373 6.71825 13.4193 5 11 5C8.23858 5 6 7.23858 6 10C6 10.3768 6.04169 10.7439 6.12071 11.097C4.33457 11.4976 3 13.0929 3 15Z" />
    </MuiSvgIcon>
  );
}

export function KSCodeIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M10 20L14 4M18 8L22 12L18 16M6 16L2 12L6 8" />
    </MuiSvgIcon>
  );
}

export function KSCogIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSCogIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M10.3246 4.31731C10.751 2.5609 13.249 2.5609 13.6754 4.31731C13.9508 5.45193 15.2507 5.99038 16.2478 5.38285C17.7913 4.44239 19.5576 6.2087 18.6172 7.75218C18.0096 8.74925 18.5481 10.0492 19.6827 10.3246C21.4391 10.751 21.4391 13.249 19.6827 13.6754C18.5481 13.9508 18.0096 15.2507 18.6172 16.2478C19.5576 17.7913 17.7913 19.5576 16.2478 18.6172C15.2507 18.0096 13.9508 18.5481 13.6754 19.6827C13.249 21.4391 10.751 21.4391 10.3246 19.6827C10.0492 18.5481 8.74926 18.0096 7.75219 18.6172C6.2087 19.5576 4.44239 17.7913 5.38285 16.2478C5.99038 15.2507 5.45193 13.9508 4.31731 13.6754C2.5609 13.249 2.5609 10.751 4.31731 10.3246C5.45193 10.0492 5.99037 8.74926 5.38285 7.75218C4.44239 6.2087 6.2087 4.44239 7.75219 5.38285C8.74926 5.99037 10.0492 5.45193 10.3246 4.31731Z" />
      <path d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z" />
    </MuiSvgIcon>
  );
}

export function KSCollectionIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSCogIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M19 11H5M19 11C20.1046 11 21 11.8954 21 13V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V13C3 11.8954 3.89543 11 5 11M19 11V9C19 7.89543 18.1046 7 17 7M5 11V9C5 7.89543 5.89543 7 7 7M7 7V5C7 3.89543 7.89543 3 9 3H15C16.1046 3 17 3.89543 17 5V7M7 7H17" />
    </MuiSvgIcon>
  );
}

export function KSColorSwatchIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSColorSwatchIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M7 21C4.79086 21 3 19.2091 3 17V5C3 3.89543 3.89543 3 5 3H9C10.1046 3 11 3.89543 11 5V17C11 19.2091 9.20914 21 7 21ZM7 21H19C20.1046 21 21 20.1046 21 19V15C21 13.8954 20.1046 13 19 13H16.6569M11 7.34312L12.6569 5.68629C13.4379 4.90524 14.7042 4.90524 15.4853 5.68629L18.3137 8.51472C19.0948 9.29577 19.0948 10.5621 18.3137 11.3431L9.82843 19.8284M7 17H7.01" />
    </MuiSvgIcon>
  );
}

export function KSCreditCardIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSColorSwatchIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M3 10H21M7 15H8M12 15H13M6 19H18C19.6569 19 21 17.6569 21 16V8C21 6.34315 19.6569 5 18 5H6C4.34315 5 3 6.34315 3 8V16C3 17.6569 4.34315 19 6 19Z" />
    </MuiSvgIcon>
  );
}

export function KSCubeTransparentIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSColorSwatchIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M14 10L12 11M12 11L10 10M12 11V13.5M20 7L18 8M20 7L18 6M20 7V9.5M14 4L12 3L10 4M4 7L6 6M4 7L6 8M4 7V9.5M12 21L10 20M12 21L14 20M12 21V18.5M6 18L4 17V14.5M18 18L20 17V14.5" />
    </MuiSvgIcon>
  );
}

export function KSCubeIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSCubeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M20 7L12 3L4 7M20 7L12 11M20 7V17L12 21M12 11L4 7M12 11V21M4 7V17L12 21" />
    </MuiSvgIcon>
  );
}

export function KSCurrecyBangladeshiIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSCurrecyBangladeshiIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M11 11V9C11 7.89543 10.1046 7 9 7M11 11V15C11 16.1046 11.8954 17 13 17C14.1046 17 15 16.1046 15 15V14M11 11H9M11 11H15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" />
    </MuiSvgIcon>
  );
}

export function KSCurrecyDollarIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSCurrecyDollarIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path
        d="M13.8434 9.65538C14.2053 10.0725 14.8369 10.1173 15.254 9.7553C15.6712 9.39335 15.7159 8.76176 15.354 8.34462L13.8434 9.65538ZM10.1567 14.3446C9.79471 13.9275 9.16313 13.8827 8.74599 14.2447C8.32885 14.6067 8.28411 15.2382 8.64607 15.6554L10.1567 14.3446ZM13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7H13ZM11 17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17L11 17ZM20 12C20 16.4183 16.4183 20 12 20V22C17.5228 22 22 17.5228 22 12H20ZM12 20C7.58172 20 4 16.4183 4 12H2C2 17.5228 6.47715 22 12 22V20ZM4 12C4 7.58172 7.58172 4 12 4V2C6.47715 2 2 6.47715 2 12H4ZM12 4C16.4183 4 20 7.58172 20 12H22C22 6.47715 17.5228 2 12 2V4ZM12 11C11.3415 11 10.7905 10.8202 10.4334 10.5822C10.0693 10.3394 10 10.1139 10 10H8C8 10.9907 8.6023 11.7651 9.32398 12.2463C10.0526 12.732 11.0017 13 12 13V11ZM10 10C10 9.8861 10.0693 9.66058 10.4334 9.41784C10.7905 9.17976 11.3415 9 12 9V7C11.0017 7 10.0526 7.26796 9.32398 7.75374C8.6023 8.23485 8 9.00933 8 10H10ZM12 9C12.9038 9 13.563 9.33231 13.8434 9.65538L15.354 8.34462C14.5969 7.47209 13.3171 7 12 7V9ZM12 13C12.6585 13 13.2095 13.1798 13.5666 13.4178C13.9308 13.6606 14 13.8861 14 14H16C16 13.0093 15.3977 12.2348 14.676 11.7537C13.9474 11.268 12.9983 11 12 11V13ZM11 7V8H13V7H11ZM11 16L11 17L13 17L13 16L11 16ZM12 15C11.0962 15 10.437 14.6677 10.1567 14.3446L8.64607 15.6554C9.40317 16.5279 10.683 17 12 17L12 15ZM14 14C14 14.1139 13.9308 14.3394 13.5666 14.5822C13.2095 14.8202 12.6586 15 12 15V17C12.9983 17 13.9474 16.732 14.676 16.2463C15.3977 15.7651 16 14.9907 16 14H14ZM11 8L11 16L13 16L13 8L11 8Z"
        fill="#111827"
      />
    </MuiSvgIcon>
  );
}

export function KSCurrecyEuroIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSCurrecyEuroIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M14.1213 15.5355C12.9497 17.4882 11.0503 17.4882 9.87868 15.5355C8.70711 13.5829 8.70711 10.4171 9.87868 8.46447C11.0503 6.51184 12.9497 6.51184 14.1213 8.46447M8 10.5H12M8 13.5H12M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" />
    </MuiSvgIcon>
  );
}

export function KSCurrecyPoundIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSCurrecyPoundIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M15 9C15 7.89543 14.1046 7 13 7C11.8954 7 11 7.89543 11 9V14C11 15.1046 10.1046 16 9 16H15M9 12H13M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" />
    </MuiSvgIcon>
  );
}

export function KSCurrecyRupeeIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSCurrecyRupeeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M9 8H15M10 8C11.6569 8 13 9.34315 13 11C13 12.6569 11.6569 14 10 14H9L12 17M9 11H15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" />
    </MuiSvgIcon>
  );
}

export function KSCurrecyYenIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSCurrecyYenIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M9 8L12 13M12 13L15 8M12 13V17M9 12H15M9 15H15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" />
    </MuiSvgIcon>
  );
}

export function KSCursorClickIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSCursorClickIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M14.9998 14.9998L12.9998 19.9998L8.99983 8.99976L19.9998 12.9998L14.9998 14.9998ZM14.9998 14.9998L19.9998 19.9998M7.18806 2.23828L7.96452 5.13606M5.13606 7.96448L2.23828 7.18802M13.9495 4.05005L11.8282 6.17137M6.17146 11.8281L4.05014 13.9494" />
    </MuiSvgIcon>
  );
}

export function KSDatabaseIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSDatabaseIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M4 7V17C4 19.2091 7.58172 21 12 21C16.4183 21 20 19.2091 20 17V7M4 7C4 9.20914 7.58172 11 12 11C16.4183 11 20 9.20914 20 7M4 7C4 4.79086 7.58172 3 12 3C16.4183 3 20 4.79086 20 7M20 12C20 14.2091 16.4183 16 12 16C7.58172 16 4 14.2091 4 12" />
    </MuiSvgIcon>
  );
}

export function KSDesktopComputerIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSDesktopComputerIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M9.75 17L9 20L8 21H16L15 20L14.25 17M3 13H21M5 17H19C20.1046 17 21 16.1046 21 15V5C21 3.89543 20.1046 3 19 3H5C3.89543 3 3 3.89543 3 5V15C3 16.1046 3.89543 17 5 17Z" />
    </MuiSvgIcon>
  );
}

export function KSDeviceMobileIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSDeviceMobileIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M12 18H12.01M8 21H16C17.1046 21 18 20.1046 18 19V5C18 3.89543 17.1046 3 16 3H8C6.89543 3 6 3.89543 6 5V19C6 20.1046 6.89543 21 8 21Z" />
    </MuiSvgIcon>
  );
}

export function KSDeviceTabletIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSDeviceTabletIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M12 18H12.01M7 21H17C18.1046 21 19 20.1046 19 19V5C19 3.89543 18.1046 3 17 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21Z" />
    </MuiSvgIcon>
  );
}

export function KSDocumentAddIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSDocumentAddIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M9 13H15M12 10L12 16M17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H12.5858C12.851 3 13.1054 3.10536 13.2929 3.29289L18.7071 8.70711C18.8946 8.89464 19 9.149 19 9.41421V19C19 20.1046 18.1046 21 17 21Z" />
    </MuiSvgIcon>
  );
}

export function KSDocumentDownloadIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSDocumentDownloadIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M12 10V16M12 16L9 13M12 16L15 13M17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H12.5858C12.851 3 13.1054 3.10536 13.2929 3.29289L18.7071 8.70711C18.8946 8.89464 19 9.149 19 9.41421V19C19 20.1046 18.1046 21 17 21Z" />
    </MuiSvgIcon>
  );
}

export function KSDocumentDuplicateIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSDocumentDuplicateIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M8 7V15C8 16.1046 8.89543 17 10 17H16M8 7V5C8 3.89543 8.89543 3 10 3H14.5858C14.851 3 15.1054 3.10536 15.2929 3.29289L19.7071 7.70711C19.8946 7.89464 20 8.149 20 8.41421V15C20 16.1046 19.1046 17 18 17H16M8 7H6C4.89543 7 4 7.89543 4 9V19C4 20.1046 4.89543 21 6 21H14C15.1046 21 16 20.1046 16 19V17" />
    </MuiSvgIcon>
  );
}

export function KSDocumentRemoveIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSDocumentRemoveIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M9 13H15M17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H12.5858C12.851 3 13.1054 3.10536 13.2929 3.29289L18.7071 8.70711C18.8946 8.89464 19 9.149 19 9.41421V19C19 20.1046 18.1046 21 17 21Z" />
    </MuiSvgIcon>
  );
}

export function KSDocumentReportIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSDocumentReportIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M9 17V15M12 17V13M15 17V11M17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H12.5858C12.851 3 13.1054 3.10536 13.2929 3.29289L18.7071 8.70711C18.8946 8.89464 19 9.149 19 9.41421V19C19 20.1046 18.1046 21 17 21Z" />
    </MuiSvgIcon>
  );
}

export function KSDocumentSearchIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSDocumentSearchIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M10 21H17C18.1046 21 19 20.1046 19 19V9.41421C19 9.149 18.8946 8.89464 18.7071 8.70711L13.2929 3.29289C13.1054 3.10536 12.851 3 12.5858 3H7C5.89543 3 5 3.89543 5 5V16M5 21L9.87868 16.1213M9.87868 16.1213C10.4216 16.6642 11.1716 17 12 17C13.6569 17 15 15.6569 15 14C15 12.3431 13.6569 11 12 11C10.3431 11 9 12.3431 9 14C9 14.8284 9.33579 15.5784 9.87868 16.1213Z" />
    </MuiSvgIcon>
  );
}

export function KSDocumentTextIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSDocumentTextIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M9 12H15M9 16H15M17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H12.5858C12.851 3 13.1054 3.10536 13.2929 3.29289L18.7071 8.70711C18.8946 8.89464 19 9.149 19 9.41421V19C19 20.1046 18.1046 21 17 21Z" />
    </MuiSvgIcon>
  );
}

export function KSDocumentIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSDocumentTextIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M7 21H17C18.1046 21 19 20.1046 19 19V9.41421C19 9.149 18.8946 8.89464 18.7071 8.70711L13.2929 3.29289C13.1054 3.10536 12.851 3 12.5858 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21Z" />
    </MuiSvgIcon>
  );
}

export function KSdotscircleHorizontalIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSdotscirclehorizontalIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M8 12H8.01M12 12H12.01M16 12H16.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" />
    </MuiSvgIcon>
  );
}

export function KSdotsHorizontalIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSdotsHorizontalIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M5 12H5.01M12 12H12.01M19 12H19.01M6 12C6 12.5523 5.55228 13 5 13C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11C5.55228 11 6 11.4477 6 12ZM13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12ZM20 12C20 12.5523 19.5523 13 19 13C18.4477 13 18 12.5523 18 12C18 11.4477 18.4477 11 19 11C19.5523 11 20 11.4477 20 12Z" />
    </MuiSvgIcon>
  );
}

export function KSDotsVerticalIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSDotsVerticalIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M12 5L12 5.01M12 12L12 12.01M12 19L12 19.01M12 6C11.4477 6 11 5.55228 11 5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5C13 5.55228 12.5523 6 12 6ZM12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13ZM12 20C11.4477 20 11 19.5523 11 19C11 18.4477 11.4477 18 12 18C12.5523 18 13 18.4477 13 19C13 19.5523 12.5523 20 12 20Z" />
    </MuiSvgIcon>
  );
}

export function KSDownloadIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSDownloadIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M4 16L4 17C4 18.6569 5.34315 20 7 20L17 20C18.6569 20 20 18.6569 20 17L20 16M16 12L12 16M12 16L8 12M12 16L12 4" />
    </MuiSvgIcon>
  );
}

export function KSDuplicateIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSDuplicateIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M8 16H6C4.89543 16 4 15.1046 4 14V6C4 4.89543 4.89543 4 6 4H14C15.1046 4 16 4.89543 16 6V8M10 20H18C19.1046 20 20 19.1046 20 18V10C20 8.89543 19.1046 8 18 8H10C8.89543 8 8 8.89543 8 10V18C8 19.1046 8.89543 20 10 20Z" />
    </MuiSvgIcon>
  );
}

export function KSEmojiHappyIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEmojiHappyIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M14.8284 14.8284C13.2663 16.3905 10.7337 16.3905 9.17157 14.8284M9 10H9.01M15 10H15.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" />
    </MuiSvgIcon>
  );
}

export function KSEmojiSadIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEmojiSadIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M9.17163 16.1716C10.7337 14.6095 13.2664 14.6095 14.8285 16.1716M9 10H9.01M15 10H15.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" />
    </MuiSvgIcon>
  );
}

export function KSEmojiCircleIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEmojiCircleIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M12 8V12M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" />
    </MuiSvgIcon>
  );
}

export function KSExclamationIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSExclamationIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M11.9995 9V11M11.9995 15H12.0095M5.07134 19H18.9277C20.4673 19 21.4296 17.3333 20.6598 16L13.7316 4C12.9618 2.66667 11.0373 2.66667 10.2675 4L3.33929 16C2.56949 17.3333 3.53174 19 5.07134 19Z" />
    </MuiSvgIcon>
  );
}

export function KSExternalLinkIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSExternalLinkIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M10 6H6C4.89543 6 4 6.89543 4 8V18C4 19.1046 4.89543 20 6 20H16C17.1046 20 18 19.1046 18 18V14M14 4H20M20 4V10M20 4L10 14" />
    </MuiSvgIcon>
  );
}

export function KSEyeOffIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSEyeOffIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M2.99976 3L6.58891 6.58916M20.9998 21L17.411 17.4112M13.8746 18.8246C13.2675 18.9398 12.6409 19 12.0002 19C7.52256 19 3.73226 16.0571 2.45801 12C2.80491 10.8955 3.33826 9.87361 4.02119 8.97118M9.87844 9.87868C10.4213 9.33579 11.1713 9 11.9998 9C13.6566 9 14.9998 10.3431 14.9998 12C14.9998 12.8284 14.664 13.5784 14.1211 14.1213M9.87844 9.87868L14.1211 14.1213M9.87844 9.87868L6.58891 6.58916M14.1211 14.1213L6.58891 6.58916M14.1211 14.1213L17.411 17.4112M6.58891 6.58916C8.14874 5.58354 10.0063 5 12.0002 5C16.4778 5 20.2681 7.94291 21.5424 12C20.8355 14.2507 19.3543 16.1585 17.411 17.4112" />
    </MuiSvgIcon>
  );
}

export function KSFastForwardIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSFastForwardIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M11.9333 12.7999C12.4667 12.3999 12.4667 11.5999 11.9333 11.1999L6.6 7.19986C5.94076 6.70544 5 7.17582 5 7.99986L5 15.9999C5 16.8239 5.94076 17.2943 6.6 16.7999L11.9333 12.7999Z" />
      <path d="M19.9333 12.7999C20.4667 12.3999 20.4667 11.5999 19.9333 11.1999L14.6 7.19986C13.9408 6.70544 13 7.17582 13 7.99986L13 15.9999C13 16.8239 13.9408 17.2943 14.6 16.7999L19.9333 12.7999Z" />
    </MuiSvgIcon>
  );
}

export function KSFilmIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSFilmIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path
        d="M7 4V20M17 4V20M3 8H7M17 8H21M3 12H21M3 16H7M17 16H21M4 20H20C20.5523 20 21 19.5523 21 19V5C21 4.44772 20.5523 4 20 4H4C3.44772 4 3 4.44772 3 5V19C3 19.5523 3.44772 20 4 20Z"
        stroke="#111827"
        strokeWidth="2"
      />
    </MuiSvgIcon>
  );
}

export function KSFilterIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSFilterIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M3 4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V6.58579C21 6.851 20.8946 7.10536 20.7071 7.29289L14.2929 13.7071C14.1054 13.8946 14 14.149 14 14.4142V17L10 21V14.4142C10 14.149 9.89464 13.8946 9.70711 13.7071L3.29289 7.29289C3.10536 7.10536 3 6.851 3 6.58579V4Z" />
    </MuiSvgIcon>
  );
}

export function KSFingerPrintIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSFingerPrintIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M11.9999 11C11.9999 14.5172 10.9911 17.7988 9.24707 20.5712M5.80688 18.5304C5.82459 18.5005 5.84273 18.4709 5.8613 18.4413C7.2158 16.2881 7.99991 13.7418 7.99991 11C7.99991 8.79086 9.79077 7 11.9999 7C14.209 7 15.9999 8.79086 15.9999 11C15.9999 12.017 15.9307 13.0186 15.7966 14M13.6792 20.8436C14.2909 19.6226 14.7924 18.3369 15.1707 17M19.0097 18.132C19.6547 15.8657 20 13.4732 20 11C20 6.58172 16.4183 3 12 3C10.5429 3 9.17669 3.38958 8 4.07026M3 15.3641C3.64066 14.0454 4 12.5646 4 11C4 9.54285 4.38958 8.17669 5.07026 7" />
    </MuiSvgIcon>
  );
}

export function KSFireIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSFireIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M17.6569 18.6568C14.5327 21.781 9.46734 21.781 6.34315 18.6568C4.78105 17.0947 4 15.0474 4 13C4 10.9526 4.78105 8.90523 6.34315 7.34313C6.34315 7.34313 7.00004 8.99995 9.00004 9.99995C9.00004 7.99995 9.50004 4.99996 11.9859 3C14 5 16.0912 5.77745 17.6569 7.34313C19.219 8.90523 20 10.9526 20 13C20 15.0474 19.2189 17.0947 17.6569 18.6568Z" />
      <path d="M9.87868 16.1213C11.0503 17.2928 12.9497 17.2928 14.1213 16.1213C14.7071 15.5355 15 14.7677 15 14C15 13.2322 14.7071 12.4644 14.1213 11.8786C13.5392 11.2965 12.7775 11.0037 12.0146 11L10.9999 13.9999L9 14C9.00001 14.7677 9.2929 15.5355 9.87868 16.1213Z" />
    </MuiSvgIcon>
  );
}

export function KSFlagIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSFlagIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M3 21V17M3 17V5C3 3.89543 3.89543 3 5 3H11.5L12.5 4H21L18 10L21 16H12.5L11.5 15H5C3.89543 15 3 15.8954 3 17ZM12 3.5V9" />
    </MuiSvgIcon>
  );
}

export function KSFolderAddIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSFolderAddIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M9 13H15M12 10V16M3 17V7C3 5.89543 3.89543 5 5 5H11L13 7H19C20.1046 7 21 7.89543 21 9V17C21 18.1046 20.1046 19 19 19H5C3.89543 19 3 18.1046 3 17Z" />
    </MuiSvgIcon>
  );
}

export function KSFolderDownloadIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSFolderDownloadIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M12 10V16M12 16L9 13M12 16L15 13M3 17V7C3 5.89543 3.89543 5 5 5H11L13 7H19C20.1046 7 21 7.89543 21 9V17C21 18.1046 20.1046 19 19 19H5C3.89543 19 3 18.1046 3 17Z" />
    </MuiSvgIcon>
  );
}

export function KSFolderOpenIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSFolderOpenIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M5 19C3.89543 19 3 18.1046 3 17V7C3 5.89543 3.89543 5 5 5H9L11 7H15C16.1046 7 17 7.89543 17 9V10M5 19H19C20.1046 19 21 18.1046 21 17V12C21 10.8954 20.1046 10 19 10H9C7.89543 10 7 10.8954 7 12V17C7 18.1046 6.10457 19 5 19Z" />
    </MuiSvgIcon>
  );
}

export function KSFolderRemoveIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSFolderRemoveIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M9 13H15M3 17V7C3 5.89543 3.89543 5 5 5H11L13 7H19C20.1046 7 21 7.89543 21 9V17C21 18.1046 20.1046 19 19 19H5C3.89543 19 3 18.1046 3 17Z" />
    </MuiSvgIcon>
  );
}

export function KSFolderIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSFolderRemoveIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M3 7V17C3 18.1046 3.89543 19 5 19H19C20.1046 19 21 18.1046 21 17V9C21 7.89543 20.1046 7 19 7H13L11 5H5C3.89543 5 3 5.89543 3 7Z" />
    </MuiSvgIcon>
  );
}

export function KSGiftIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSGiftIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M12 8V21M12 8C12 8 12 6.50722 12 6C12 4.89543 12.8954 4 14 4C15.1046 4 16 4.89543 16 6C16 7.10457 15.1046 8 14 8C13.4027 8 12 8 12 8ZM12 8C12 8 12 6.06291 12 5.5C12 4.11929 10.8807 3 9.5 3C8.11929 3 7 4.11929 7 5.5C7 6.88071 8.11929 8 9.5 8C10.3178 8 12 8 12 8ZM5 12H19M5 12C3.89543 12 3 11.1046 3 10C3 8.89543 3.89543 8 5 8H19C20.1046 8 21 8.89543 21 10C21 11.1046 20.1046 12 19 12M5 12L5 19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V12" />
    </MuiSvgIcon>
  );
}

export function KSGlobeAltIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSGlobeAltIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M21 12C21 16.9706 16.9706 21 12 21M21 12C21 7.02944 16.9706 3 12 3M21 12H3M12 21C7.02944 21 3 16.9706 3 12M12 21C13.6569 21 15 16.9706 15 12C15 7.02944 13.6569 3 12 3M12 21C10.3431 21 9 16.9706 9 12C9 7.02944 10.3431 3 12 3M3 12C3 7.02944 7.02944 3 12 3" />
    </MuiSvgIcon>
  );
}

export function KSGlobeIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSGlobeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M3.05493 11H5C6.10457 11 7 11.8954 7 13V14C7 15.1046 7.89543 16 9 16C10.1046 16 11 16.8954 11 18V20.9451M8 3.93552V5.5C8 6.88071 9.11929 8 10.5 8H11C12.1046 8 13 8.89543 13 10C13 11.1046 13.8954 12 15 12C16.1046 12 17 11.1046 17 10C17 8.89543 17.8954 8 19 8L20.0645 8M15 20.4879V18C15 16.8954 15.8954 16 17 16H20.0645M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" />
    </MuiSvgIcon>
  );
}

export function KSHandIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSHandIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M7 11.5V14M7 11.5V5.5C7 4.67157 7.67157 4 8.5 4C9.32843 4 10 4.67157 10 5.5M7 11.5C7 10.6716 6.32843 10 5.5 10C4.67157 10 4 10.6716 4 11.5V13.5C4 17.6421 7.35786 21 11.5 21C15.6421 21 19 17.6421 19 13.5V8.5C19 7.67157 18.3284 7 17.5 7C16.6716 7 16 7.67157 16 8.5M10 5.5V11M10 5.5V4.5C10 3.67157 10.6716 3 11.5 3C12.3284 3 13 3.67157 13 4.5V5.5M13 5.5V11M13 5.5C13 4.67157 13.6716 4 14.5 4C15.3284 4 16 4.67157 16 5.5V8.5M16 8.5V11" />
    </MuiSvgIcon>
  );
}

export function KSHashTagIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSHashTagIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M7 20L11 4M13 20L17 4M6 9H20M4 15H18" />
    </MuiSvgIcon>
  );
}

export function KSHeartIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSHeartIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M4.31802 6.31802C2.56066 8.07538 2.56066 10.9246 4.31802 12.682L12.0001 20.364L19.682 12.682C21.4393 10.9246 21.4393 8.07538 19.682 6.31802C17.9246 4.56066 15.0754 4.56066 13.318 6.31802L12.0001 7.63609L10.682 6.31802C8.92462 4.56066 6.07538 4.56066 4.31802 6.31802Z" />
    </MuiSvgIcon>
  );
}

export function KSHomeLoanIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSHomeLoanIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M3 12L5 10M5 10L12 3L19 10M5 10V20C5 20.5523 5.44772 21 6 21H9H15H18C18.5523 21 19 20.5523 19 20V10M19 10L21 12" />
      <path d="M12.1 11.7C10.9402 11.7 10 12.3268 10 13.1C10 13.8732 10.9402 14.5 12.1 14.5C13.2598 14.5 14.2 15.1268 14.2 15.9C14.2 16.6732 13.2598 17.3 12.1 17.3M12.1 11.7C12.8773 11.7 13.556 11.9815 13.9191 12.4M12.1 11.7V11M12.1 11.7L12.1 17.3M12.1 17.3L12.1 18M12.1 17.3C11.3227 17.3 10.6441 17.0185 10.281 16.6" />
    </MuiSvgIcon>
  );
}

export function KSHomeIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSHomeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M3 12L5 10M5 10L12 3L19 10M5 10V20C5 20.5523 5.44772 21 6 21H9M19 10L21 12M19 10V20C19 20.5523 18.5523 21 18 21H15M9 21C9.55228 21 10 20.5523 10 20V16C10 15.4477 10.4477 15 11 15H13C13.5523 15 14 15.4477 14 16V20C14 20.5523 14.4477 21 15 21M9 21H15" />
    </MuiSvgIcon>
  );
}

export function KSIconUserRemoveIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSIconUserRemoveIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M21 12H15M13 7C13 9.20914 11.2091 11 9 11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3C11.2091 3 13 4.79086 13 7ZM3 20C3 16.6863 5.68629 14 9 14C12.3137 14 15 16.6863 15 20V21H3V20Z" />
    </MuiSvgIcon>
  );
}

export function KSIdentificationIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSIdentificationIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M10 6H5C3.89543 6 3 6.89543 3 8V17C3 18.1046 3.89543 19 5 19H19C20.1046 19 21 18.1046 21 17V8C21 6.89543 20.1046 6 19 6H14M10 6V5C10 3.89543 10.8954 3 12 3C13.1046 3 14 3.89543 14 5V6M10 6C10 7.10457 10.8954 8 12 8C13.1046 8 14 7.10457 14 6M9 14C10.1046 14 11 13.1046 11 12C11 10.8954 10.1046 10 9 10C7.89543 10 7 10.8954 7 12C7 13.1046 7.89543 14 9 14ZM9 14C10.3062 14 11.4174 14.8348 11.8292 16M9 14C7.69378 14 6.58249 14.8348 6.17065 16M15 11H18M15 15H17" />
    </MuiSvgIcon>
  );
}

export function KSInboxInIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSInboxInIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M8 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V6C20 4.89543 19.1046 4 18 4H16M12 3V11M12 11L15 8M12 11L9 8M4 13H6.58579C6.851 13 7.10536 13.1054 7.29289 13.2929L9.70711 15.7071C9.89464 15.8946 10.149 16 10.4142 16H13.5858C13.851 16 14.1054 15.8946 14.2929 15.7071L16.7071 13.2929C16.8946 13.1054 17.149 13 17.4142 13H20" />
    </MuiSvgIcon>
  );
}

export function KSInboxIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSInboxIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M20 13V6C20 4.89543 19.1046 4 18 4H6C4.89543 4 4 4.89543 4 6V13M20 13V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V13M20 13H17.4142C17.149 13 16.8946 13.1054 16.7071 13.2929L14.2929 15.7071C14.1054 15.8946 13.851 16 13.5858 16H10.4142C10.149 16 9.89464 15.8946 9.70711 15.7071L7.29289 13.2929C7.10536 13.1054 6.851 13 6.58579 13H4" />
    </MuiSvgIcon>
  );
}

export function KSInformationCircleIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSInformationCircleIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M13 16H12V12H11M12 8H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" />
    </MuiSvgIcon>
  );
}

export function KSKeyIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSKeyIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M15 7C16.1046 7 17 7.89543 17 9M21 9C21 12.3137 18.3137 15 15 15C14.3938 15 13.8087 14.9101 13.2571 14.7429L11 17H9V19H7V21H4C3.44772 21 3 20.5523 3 20V17.4142C3 17.149 3.10536 16.8946 3.29289 16.7071L9.25707 10.7429C9.08989 10.1914 9 9.60617 9 9C9 5.68629 11.6863 3 15 3C18.3137 3 21 5.68629 21 9Z" />
    </MuiSvgIcon>
  );
}

export function KSLibraryIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSLibraryIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M8 14V17M12 14V17M16 14V17M3 21H21M3 10H21M3 7L12 3L21 7M4 10H20V21H4V10Z" />
    </MuiSvgIcon>
  );
}

export function KSLightBulbIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSLightBulbIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M9.66347 17H14.3364M11.9999 3V4M18.3639 5.63604L17.6568 6.34315M21 11.9999H20M4 11.9999H3M6.34309 6.34315L5.63599 5.63604M8.46441 15.5356C6.51179 13.5829 6.51179 10.4171 8.46441 8.46449C10.417 6.51187 13.5829 6.51187 15.5355 8.46449C17.4881 10.4171 17.4881 13.5829 15.5355 15.5356L14.9884 16.0827C14.3555 16.7155 13.9999 17.5739 13.9999 18.469V19C13.9999 20.1046 13.1045 21 11.9999 21C10.8954 21 9.99995 20.1046 9.99995 19V18.469C9.99995 17.5739 9.6444 16.7155 9.01151 16.0827L8.46441 15.5356Z" />
    </MuiSvgIcon>
  );
}

export function KSLightBoltIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSLightBoltIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M13 10V3L4 14H11L11 21L20 10L13 10Z" />
    </MuiSvgIcon>
  );
}

export function KSLinkIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSLinkIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M13.8284 10.1716C12.2663 8.60948 9.73367 8.60948 8.17157 10.1716L4.17157 14.1716C2.60948 15.7337 2.60948 18.2663 4.17157 19.8284C5.73367 21.3905 8.26633 21.3905 9.82843 19.8284L10.93 18.7269M10.1716 13.8284C11.7337 15.3905 14.2663 15.3905 15.8284 13.8284L19.8284 9.82843C21.3905 8.26633 21.3905 5.73367 19.8284 4.17157C18.2663 2.60948 15.7337 2.60948 14.1716 4.17157L13.072 5.27118" />
    </MuiSvgIcon>
  );
}

export function KSLocationMarkerIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSLocationMarkerIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M17.6569 16.6569C16.7202 17.5935 14.7616 19.5521 13.4138 20.8999C12.6327 21.681 11.3677 21.6814 10.5866 20.9003C9.26234 19.576 7.34159 17.6553 6.34315 16.6569C3.21895 13.5327 3.21895 8.46734 6.34315 5.34315C9.46734 2.21895 14.5327 2.21895 17.6569 5.34315C20.781 8.46734 20.781 13.5327 17.6569 16.6569Z" />
      <path d="M15 11C15 12.6569 13.6569 14 12 14C10.3431 14 9 12.6569 9 11C9 9.34315 10.3431 8 12 8C13.6569 8 15 9.34315 15 11Z" />
    </MuiSvgIcon>
  );
}

export function KSLockClosedIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSLockClosedIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M12 15V17M6 21H18C19.1046 21 20 20.1046 20 19V13C20 11.8954 19.1046 11 18 11H6C4.89543 11 4 11.8954 4 13V19C4 20.1046 4.89543 21 6 21ZM16 11V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V11H16Z" />
    </MuiSvgIcon>
  );
}

export function KSLockOpenIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSLockOpenIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M8 11V7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7M12 15V17M6 21H18C19.1046 21 20 20.1046 20 19V13C20 11.8954 19.1046 11 18 11H6C4.89543 11 4 11.8954 4 13V19C4 20.1046 4.89543 21 6 21Z" />
    </MuiSvgIcon>
  );
}

export function KSLogout1Icon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSLockOpenIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M17 16L21 12M21 12L17 8M21 12L7 12M13 16V17C13 18.6569 11.6569 20 10 20H6C4.34315 20 3 18.6569 3 17V7C3 5.34315 4.34315 4 6 4H10C11.6569 4 13 5.34315 13 7V8" />
    </MuiSvgIcon>
  );
}

export function KSLogoutIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSLogoutIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M11 16L7 12M7 12L11 8M7 12L21 12M16 16V17C16 18.6569 14.6569 20 13 20H6C4.34315 20 3 18.6569 3 17V7C3 5.34315 4.34315 4 6 4H13C14.6569 4 16 5.34315 16 7V8" />
    </MuiSvgIcon>
  );
}

export function KSMailOpenIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSMailOpenIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M3 19.0001V10.0705C3 9.40177 3.3342 8.77731 3.8906 8.40637L10.8906 3.73971C11.5624 3.29184 12.4376 3.29184 13.1094 3.73971L20.1094 8.40637C20.6658 8.77731 21 9.40177 21 10.0705V19.0001M3 19.0001C3 20.1047 3.89543 21.0001 5 21.0001H19C20.1046 21.0001 21 20.1047 21 19.0001M3 19.0001L9.75 14.5001M21 19.0001L14.25 14.5001M3 10.0001L9.75 14.5001M21 10.0001L14.25 14.5001M14.25 14.5001L13.1094 15.2605C12.4376 15.7084 11.5624 15.7084 10.8906 15.2605L9.75 14.5001" />
    </MuiSvgIcon>
  );
}

export function KSMailIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSMailIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M3 8L10.8906 13.2604C11.5624 13.7083 12.4376 13.7083 13.1094 13.2604L21 8M5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19Z" />
    </MuiSvgIcon>
  );
}

export function KSMapIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSMapIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M9 20L3.55279 17.2764C3.214 17.107 3 16.7607 3 16.382V5.61803C3 4.87465 3.78231 4.39116 4.44721 4.72361L9 7M9 20L15 17M9 20V7M15 17L19.5528 19.2764C20.2177 19.6088 21 19.1253 21 18.382V7.61803C21 7.23926 20.786 6.893 20.4472 6.72361L15 4M15 17V4M15 4L9 7" />
    </MuiSvgIcon>
  );
}

export function KSMenuAlt1Icon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSMenuAlt1Icon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M4 6H20M4 12H12M4 18H20" />
    </MuiSvgIcon>
  );
}

export function KSMenuAlt2Icon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSMenuAlt2Icon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M4 6H20M4 12H20M4 18H11" />
    </MuiSvgIcon>
  );
}

export function KSMenuAlt3Icon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSMenuAlt3Icon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M4 6H20M4 12H20M13 18H20" />
    </MuiSvgIcon>
  );
}

export function KSMenuAlt4Icon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSMenuAlt4Icon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M4 8H20M4 16H20" />
    </MuiSvgIcon>
  );
}

export function KSMenuIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSMenuIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M4 6H20M4 12H20M4 18H20" />
    </MuiSvgIcon>
  );
}

export function KSMicrophoneIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSMicrophoneIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M19 11C19 14.866 15.866 18 12 18M12 18C8.13401 18 5 14.866 5 11M12 18V22M12 22H8M12 22H16M12 14C10.3431 14 9 12.6569 9 11V5C9 3.34315 10.3431 2 12 2C13.6569 2 15 3.34315 15 5V11C15 12.6569 13.6569 14 12 14Z" />
    </MuiSvgIcon>
  );
}

export function KSMinusCircleIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSMinusCircleIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M15 12H9M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" />
    </MuiSvgIcon>
  );
}

export function KSMinusSmIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSMinusSmIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M18 12H6" />
    </MuiSvgIcon>
  );
}

export function KSMinusIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSMinusIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M20 12H4" />
    </MuiSvgIcon>
  );
}

export function KSMoonIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSMoonIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M20.3542 15.3544C19.3176 15.7709 18.1856 16.0002 17 16.0002C12.0294 16.0002 8 11.9707 8 7.00018C8 5.81461 8.22924 4.68258 8.64581 3.646C5.33648 4.97592 3 8.21519 3 12.0002C3 16.9707 7.02944 21.0002 12 21.0002C15.785 21.0002 19.0243 18.6637 20.3542 15.3544Z" />
    </MuiSvgIcon>
  );
}

export function KSMusicNoteIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSMusicNoteIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M9 19V6L21 3V16M9 19C9 20.1046 7.65685 21 6 21C4.34315 21 3 20.1046 3 19C3 17.8954 4.34315 17 6 17C7.65685 17 9 17.8954 9 19ZM21 16C21 17.1046 19.6569 18 18 18C16.3431 18 15 17.1046 15 16C15 14.8954 16.3431 14 18 14C19.6569 14 21 14.8954 21 16ZM9 10L21 7" />
    </MuiSvgIcon>
  );
}

export function KSNewsPaperIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSNewsPaperIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M19 20H5C3.89543 20 3 19.1046 3 18L3 6C3 4.89543 3.89543 4 5 4L15 4C16.1046 4 17 4.89543 17 6V7M19 20C17.8954 20 17 19.1046 17 18L17 7M19 20C20.1046 20 21 19.1046 21 18V9C21 7.89543 20.1046 7 19 7L17 7M13 4L9 4M7 16H13M7 8H13V12H7V8Z" />
    </MuiSvgIcon>
  );
}

export function KSOfficeBuildingIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSOfficeBuildingIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path
        d="M19 21V5C19 3.89543 18.1046 3 17 3H7C5.89543 3 5 3.89543 5 5V21M19 21L21 21M19 21H14M5 21L3 21M5 21H10M9 6.99998H10M9 11H10M14 6.99998H15M14 11H15M10 21V16C10 15.4477 10.4477 15 11 15H13C13.5523 15 14 15.4477 14 16V21M10 21H14"
        stroke="#111827"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </MuiSvgIcon>
  );
}

export function KSPaperAirplaneIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSpaperAirplaneIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M12 19L21 21L12 3L3 21L12 19ZM12 19V11" />
    </MuiSvgIcon>
  );
}

export function KSPaperClipIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSPaperClipIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M15.1716 7L8.58579 13.5858C7.80474 14.3668 7.80474 15.6332 8.58579 16.4142C9.36684 17.1953 10.6332 17.1953 11.4142 16.4142L17.8284 9.82843C19.3905 8.26633 19.3905 5.73367 17.8284 4.17157C16.2663 2.60948 13.7337 2.60948 12.1716 4.17157L5.75736 10.7574C3.41421 13.1005 3.41421 16.8995 5.75736 19.2426C8.1005 21.5858 11.8995 21.5858 14.2426 19.2426L20.5 13" />
    </MuiSvgIcon>
  );
}

export function KSPauseIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSPauseIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M10 9V15M14 9V15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" />
    </MuiSvgIcon>
  );
}

export function KSPencilAltIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSPencilAltIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M11 5H6C4.89543 5 4 5.89543 4 7V18C4 19.1046 4.89543 20 6 20H17C18.1046 20 19 19.1046 19 18V13M17.5858 3.58579C18.3668 2.80474 19.6332 2.80474 20.4142 3.58579C21.1953 4.36683 21.1953 5.63316 20.4142 6.41421L11.8284 15H9L9 12.1716L17.5858 3.58579Z" />
    </MuiSvgIcon>
  );
}

export function KSPencilIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSPencilIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M15.2322 5.23223L18.7677 8.76777M16.7322 3.73223C17.7085 2.75592 19.2914 2.75592 20.2677 3.73223C21.244 4.70854 21.244 6.29146 20.2677 7.26777L6.5 21.0355H3V17.4644L16.7322 3.73223Z" />
    </MuiSvgIcon>
  );
}

export function KSPhoneIncomingIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSPhoneIncomingIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M21 3L15 9M15 9V4M15 9H20M5 3C3.89543 3 3 3.89543 3 5V6C3 14.2843 9.71573 21 18 21H19C20.1046 21 21 20.1046 21 19V15.7208C21 15.2903 20.7246 14.9082 20.3162 14.7721L15.8228 13.2743C15.3507 13.1169 14.8347 13.3306 14.6121 13.7757L13.4835 16.033C11.0388 14.9308 9.06925 12.9612 7.96701 10.5165L10.2243 9.38787C10.6694 9.16531 10.8831 8.64932 10.7257 8.17721L9.22792 3.68377C9.09181 3.27543 8.70967 3 8.27924 3H5Z" />
    </MuiSvgIcon>
  );
}

export function KSPhoneMissedCallIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSPhoneMissedCallIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M16 8L18 6M18 6L20 4M18 6L16 4M18 6L20 8M5 3C3.89543 3 3 3.89543 3 5V6C3 14.2843 9.71573 21 18 21H19C20.1046 21 21 20.1046 21 19V15.7208C21 15.2903 20.7246 14.9082 20.3162 14.7721L15.8228 13.2743C15.3507 13.1169 14.8347 13.3306 14.6121 13.7757L13.4835 16.033C11.0388 14.9308 9.06925 12.9612 7.96701 10.5165L10.2243 9.38787C10.6694 9.16531 10.8831 8.64932 10.7257 8.17721L9.22792 3.68377C9.09181 3.27543 8.70967 3 8.27924 3H5Z" />
    </MuiSvgIcon>
  );
}

export function KSPhoneOutgoingIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSPhoneOutgoingIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M16 3H21M21 3V8M21 3L15 9M5 3C3.89543 3 3 3.89543 3 5V6C3 14.2843 9.71573 21 18 21H19C20.1046 21 21 20.1046 21 19V15.7208C21 15.2903 20.7246 14.9082 20.3162 14.7721L15.8228 13.2743C15.3507 13.1169 14.8347 13.3306 14.6121 13.7757L13.4835 16.033C11.0388 14.9308 9.06925 12.9612 7.96701 10.5165L10.2243 9.38787C10.6694 9.16531 10.8831 8.64932 10.7257 8.17721L9.22792 3.68377C9.09181 3.27543 8.70967 3 8.27924 3H5Z" />
    </MuiSvgIcon>
  );
}

export function KSPhoneIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSPhoneIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M3 5C3 3.89543 3.89543 3 5 3H8.27924C8.70967 3 9.09181 3.27543 9.22792 3.68377L10.7257 8.17721C10.8831 8.64932 10.6694 9.16531 10.2243 9.38787L7.96701 10.5165C9.06925 12.9612 11.0388 14.9308 13.4835 16.033L14.6121 13.7757C14.8347 13.3306 15.3507 13.1169 15.8228 13.2743L20.3162 14.7721C20.7246 14.9082 21 15.2903 21 15.7208V19C21 20.1046 20.1046 21 19 21H18C9.71573 21 3 14.2843 3 6V5Z" />
    </MuiSvgIcon>
  );
}

export function KSPhoneGraphIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSPhoneGraphIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M4 16L8.58579 11.4142C9.36683 10.6332 10.6332 10.6332 11.4142 11.4142L16 16M14 14L15.5858 12.4142C16.3668 11.6332 17.6332 11.6332 18.4142 12.4142L20 14M14 8H14.01M6 20H18C19.1046 20 20 19.1046 20 18V6C20 4.89543 19.1046 4 18 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20Z" />
    </MuiSvgIcon>
  );
}

export function KSPlayIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSPhoneGraphIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M14.7519 11.1679L11.5547 9.03647C10.8901 8.59343 10 9.06982 10 9.86852V14.1315C10 14.9302 10.8901 15.4066 11.5547 14.9635L14.7519 12.8321C15.3457 12.4362 15.3457 11.5638 14.7519 11.1679Z" />
      <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" />
    </MuiSvgIcon>
  );
}

export function KSPlusCircleIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSPlusCircleIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M12 9V12M12 12V15M12 12H15M12 12H9M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" />
    </MuiSvgIcon>
  );
}

export function KSPlussmIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSPlusCircleIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M12 6V12M12 12V18M12 12H18M12 12L6 12" />
    </MuiSvgIcon>
  );
}

export function KSPlusIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSPlusIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M12 4V20M20 12L4 12" />
    </MuiSvgIcon>
  );
}

export function KSPresentationChartBarIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSPresentationChartBar",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M8 13V12M12 13V10M16 13V8M8 21L12 17L16 21M3 4H21M4 4H20V16C20 16.5523 19.5523 17 19 17H5C4.44772 17 4 16.5523 4 16V4Z" />
    </MuiSvgIcon>
  );
}

export function KSPresentationChartLineIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSPresentationChartLineIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path
        d="M4 4V3H3V4H4ZM20 4H21V3H20V4ZM6.29289 11.2929C5.90237 11.6834 5.90237 12.3166 6.29289 12.7071C6.68342 13.0976 7.31658 13.0976 7.70711 12.7071L6.29289 11.2929ZM10 9L10.7071 8.29289C10.3166 7.90237 9.68342 7.90237 9.29289 8.29289L10 9ZM13 12L12.2929 12.7071C12.6834 13.0976 13.3166 13.0976 13.7071 12.7071L13 12ZM17.7071 8.70711C18.0976 8.31658 18.0976 7.68342 17.7071 7.29289C17.3166 6.90237 16.6834 6.90237 16.2929 7.29289L17.7071 8.70711ZM7.29289 20.2929C6.90237 20.6834 6.90237 21.3166 7.29289 21.7071C7.68342 22.0976 8.31658 22.0976 8.70711 21.7071L7.29289 20.2929ZM12 17L12.7071 16.2929C12.3166 15.9024 11.6834 15.9024 11.2929 16.2929L12 17ZM15.2929 21.7071C15.6834 22.0976 16.3166 22.0976 16.7071 21.7071C17.0976 21.3166 17.0976 20.6834 16.7071 20.2929L15.2929 21.7071ZM3 3C2.44772 3 2 3.44772 2 4C2 4.55228 2.44772 5 3 5V3ZM21 5C21.5523 5 22 4.55228 22 4C22 3.44772 21.5523 3 21 3V5ZM4 5H20V3H4V5ZM19 4V16H21V4H19ZM19 16H5V18H19V16ZM5 16V4H3V16H5ZM5 16H3C3 17.1046 3.89543 18 5 18V16ZM19 16V18C20.1046 18 21 17.1046 21 16H19ZM7.70711 12.7071L10.7071 9.70711L9.29289 8.29289L6.29289 11.2929L7.70711 12.7071ZM9.29289 9.70711L12.2929 12.7071L13.7071 11.2929L10.7071 8.29289L9.29289 9.70711ZM13.7071 12.7071L17.7071 8.70711L16.2929 7.29289L12.2929 11.2929L13.7071 12.7071ZM8.70711 21.7071L12.7071 17.7071L11.2929 16.2929L7.29289 20.2929L8.70711 21.7071ZM11.2929 17.7071L15.2929 21.7071L16.7071 20.2929L12.7071 16.2929L11.2929 17.7071ZM3 5H21V3H3V5Z"
        fill="#111827"
      />
    </MuiSvgIcon>
  );
}

export function KSPrinterIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSPrinterIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M17 17H19C20.1046 17 21 16.1046 21 15V11C21 9.89543 20.1046 9 19 9H5C3.89543 9 3 9.89543 3 11V15C3 16.1046 3.89543 17 5 17H7M9 21H15C16.1046 21 17 20.1046 17 19V15C17 13.8954 16.1046 13 15 13H9C7.89543 13 7 13.8954 7 15V19C7 20.1046 7.89543 21 9 21ZM17 9V5C17 3.89543 16.1046 3 15 3H9C7.89543 3 7 3.89543 7 5V9H17Z" />
    </MuiSvgIcon>
  );
}

export function KSPuzzleIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSPuzzleIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M11 4C11 2.89543 11.8954 2 13 2C14.1046 2 15 2.89543 15 4V5C15 5.55228 15.4477 6 16 6H19C19.5523 6 20 6.44772 20 7V10C20 10.5523 19.5523 11 19 11H18C16.8954 11 16 11.8954 16 13C16 14.1046 16.8954 15 18 15H19C19.5523 15 20 15.4477 20 16V19C20 19.5523 19.5523 20 19 20H16C15.4477 20 15 19.5523 15 19V18C15 16.8954 14.1046 16 13 16C11.8954 16 11 16.8954 11 18V19C11 19.5523 10.5523 20 10 20H7C6.44772 20 6 19.5523 6 19V16C6 15.4477 5.55228 15 5 15H4C2.89543 15 2 14.1046 2 13C2 11.8954 2.89543 11 4 11H5C5.55228 11 6 10.5523 6 10V7C6 6.44772 6.44772 6 7 6H10C10.5523 6 11 5.55228 11 5V4Z" />
    </MuiSvgIcon>
  );
}

export function KSQrCodeIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSQrCodeIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4H13ZM11 5C11 5.55228 11.4477 6 12 6C12.5523 6 13 5.55228 13 5H11ZM18 15C17.4477 15 17 15.4477 17 16C17 16.5523 17.4477 17 18 17V15ZM20 17C20.5523 17 21 16.5523 21 16C21 15.4477 20.5523 15 20 15V17ZM12 16V15C11.4477 15 11 15.4477 11 16H12ZM14 17C14.5523 17 15 16.5523 15 16C15 15.4477 14.5523 15 14 15V17ZM11 20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20H11ZM13 9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9H13ZM12 12H11C11 12.5523 11.4477 13 12 13V12ZM16 19C15.4477 19 15 19.4477 15 20C15 20.5523 15.4477 21 16 21V19ZM20 21C20.5523 21 21 20.5523 21 20C21 19.4477 20.5523 19 20 19V21ZM4 11C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13V11ZM8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11V13ZM12.01 13C12.5623 13 13.01 12.5523 13.01 12C13.01 11.4477 12.5623 11 12.01 11V13ZM16.01 13C16.5623 13 17.01 12.5523 17.01 12C17.01 11.4477 16.5623 11 16.01 11V13ZM20 11C19.4477 11 19 11.4477 19 12C19 12.5523 19.4477 13 20 13V11ZM20.01 13C20.5623 13 21.01 12.5523 21.01 12C21.01 11.4477 20.5623 11 20.01 11V13ZM5 5H7V3H5V5ZM7 5V7H9V5H7ZM7 7H5V9H7V7ZM5 7V5H3V7H5ZM5 7H3C3 8.10457 3.89543 9 5 9V7ZM7 7V9C8.10457 9 9 8.10457 9 7H7ZM7 5H9C9 3.89543 8.10457 3 7 3V5ZM5 3C3.89543 3 3 3.89543 3 5H5V3ZM17 5H19V3H17V5ZM19 5V7H21V5H19ZM19 7H17V9H19V7ZM17 7V5H15V7H17ZM17 7H15C15 8.10457 15.8954 9 17 9V7ZM19 7V9C20.1046 9 21 8.10457 21 7H19ZM19 5H21C21 3.89543 20.1046 3 19 3V5ZM17 3C15.8954 3 15 3.89543 15 5H17V3ZM5 17H7V15H5V17ZM7 17V19H9V17H7ZM7 19H5V21H7V19ZM5 19V17H3V19H5ZM5 19H3C3 20.1046 3.89543 21 5 21V19ZM7 19V21C8.10457 21 9 20.1046 9 19H7ZM7 17H9C9 15.8954 8.10457 15 7 15V17ZM5 15C3.89543 15 3 15.8954 3 17H5V15ZM11 4V5H13V4H11ZM18 17H20V15H18V17ZM12 17H14V15H12V17ZM11 16V20H13V16H11ZM11 9V12H13V9H11ZM16 21H20V19H16V21ZM4 13H8V11H4V13ZM12 13H12.01V11H12V13ZM20 13H20.01V11H20V13ZM12 13H16.01V11H12V13Z" />
    </MuiSvgIcon>
  );
}

export function KSQuestionMarkCircleIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSQuestionMarkCircleIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M8.22766 9C8.77678 7.83481 10.2584 7 12.0001 7C14.2092 7 16.0001 8.34315 16.0001 10C16.0001 11.3994 14.7224 12.5751 12.9943 12.9066C12.4519 13.0106 12.0001 13.4477 12.0001 14M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" />
    </MuiSvgIcon>
  );
}

export function KSReceiptTaxIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSReceiptTaxIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M9 14L15 8M9.50003 8.5H9.51003M14.5 13.5H14.51M19 21V5C19 3.89543 18.1046 3 17 3H7C5.89543 3 5 3.89543 5 5V21L8.5 19L12 21L15.5 19L19 21ZM10 8.5C10 8.77614 9.77614 9 9.5 9C9.22386 9 9 8.77614 9 8.5C9 8.22386 9.22386 8 9.5 8C9.77614 8 10 8.22386 10 8.5ZM15 13.5C15 13.7761 14.7761 14 14.5 14C14.2239 14 14 13.7761 14 13.5C14 13.2239 14.2239 13 14.5 13C14.7761 13 15 13.2239 15 13.5Z" />
    </MuiSvgIcon>
  );
}

export function KSRefreshIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSRefreshIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M4 4V9H4.58152M19.9381 11C19.446 7.05369 16.0796 4 12 4C8.64262 4 5.76829 6.06817 4.58152 9M4.58152 9H9M20 20V15H19.4185M19.4185 15C18.2317 17.9318 15.3574 20 12 20C7.92038 20 4.55399 16.9463 4.06189 13M19.4185 15H15" />
    </MuiSvgIcon>
  );
}

export function KSReplyIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSReplyIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M3 10H13C17.4183 10 21 13.5817 21 18V20M3 10L9 16M3 10L9 4" />
    </MuiSvgIcon>
  );
}

export function KSRewindIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSRewindIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M12.067 11.1999C11.5337 11.5999 11.5337 12.3999 12.067 12.7999L17.4003 16.7999C18.0596 17.2943 19.0003 16.8239 19.0003 15.9999V7.99986C19.0003 7.17582 18.0596 6.70544 17.4003 7.19986L12.067 11.1999Z" />
      <path d="M4.06699 11.1999C3.53366 11.5999 3.53366 12.3999 4.06699 12.7999L9.40033 16.7999C10.0596 17.2943 11.0003 16.8239 11.0003 15.9999V7.99986C11.0003 7.17582 10.0596 6.70544 9.40033 7.19986L4.06699 11.1999Z" />
    </MuiSvgIcon>
  );
}

export function KSRssIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSRssIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M6 5C13.1797 5 19 10.8203 19 18M6 11C9.86599 11 13 14.134 13 18M7 18C7 18.5523 6.55228 19 6 19C5.44772 19 5 18.5523 5 18C5 17.4477 5.44772 17 6 17C6.55228 17 7 17.4477 7 18Z" />
    </MuiSvgIcon>
  );
}

export function KSSaveAsIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSSaveAsIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M17 16V18C17 19.1046 16.1046 20 15 20H5C3.89543 20 3 19.1046 3 18V11C3 9.89543 3.89543 9 5 9H7M10 5H9C7.89543 5 7 5.89543 7 7V14C7 15.1046 7.89543 16 9 16H19C20.1046 16 21 15.1046 21 14V7C21 5.89543 20.1046 5 19 5H18M17 9L14 12M14 12L11 9M14 12L14 3" />
    </MuiSvgIcon>
  );
}

export function KSSaveIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSSaveIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M8 7H5C3.89543 7 3 7.89543 3 9V18C3 19.1046 3.89543 20 5 20H19C20.1046 20 21 19.1046 21 18V9C21 7.89543 20.1046 7 19 7H16M15 11L12 14M12 14L9 11M12 14L12 4" />
    </MuiSvgIcon>
  );
}

export function KSScaleIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSScaleIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M3 6L6 7M6 7L3 16C4.77253 17.3334 7.22866 17.3334 9.00119 16M6 7L9.00006 16M6 7L12 5M18 7L21 6M18 7L15 16C16.7725 17.3334 19.2287 17.3334 21.0012 16M18 7L21.0001 16M18 7L12 5M12 3V5M12 21V5M12 21H9M12 21H15" />
    </MuiSvgIcon>
  );
}

export function KSScissorsIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSScissorsIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M14.1213 14.1213L19 19M12 12L19 5M12 12L9.12132 14.8787M12 12L9.12132 9.12132M9.12132 14.8787C8.57843 14.3358 7.82843 14 7 14C5.34315 14 4 15.3431 4 17C4 18.6569 5.34315 20 7 20C8.65685 20 10 18.6569 10 17C10 16.1716 9.66421 15.4216 9.12132 14.8787ZM9.12132 9.12132C9.66421 8.57843 10 7.82843 10 7C10 5.34315 8.65685 4 7 4C5.34315 4 4 5.34315 4 7C4 8.65685 5.34315 10 7 10C7.82843 10 8.57843 9.66421 9.12132 9.12132Z" />
    </MuiSvgIcon>
  );
}

export function KSSearchCircleIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSSearchCircleIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M8 16L10.8787 13.1213M10.8787 13.1213C11.4216 13.6642 12.1716 14 13 14C14.6569 14 16 12.6569 16 11C16 9.34315 14.6569 8 13 8C11.3431 8 10 9.34315 10 11C10 11.8284 10.3358 12.5784 10.8787 13.1213ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" />
    </MuiSvgIcon>
  );
}

export function KSSearchIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSSearchIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z" />
    </MuiSvgIcon>
  );
}

export function KSSelectorIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSSelectorIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M8 9L12 5L16 9M16 15L12 19L8 15" />
    </MuiSvgIcon>
  );
}

export function KSServerIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSServerIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M5 12H19M5 12C3.89543 12 3 11.1046 3 10V6C3 4.89543 3.89543 4 5 4H19C20.1046 4 21 4.89543 21 6V10C21 11.1046 20.1046 12 19 12M5 12C3.89543 12 3 12.8954 3 14V18C3 19.1046 3.89543 20 5 20H19C20.1046 20 21 19.1046 21 18V14C21 12.8954 20.1046 12 19 12M17 8H17.01M17 16H17.01" />
    </MuiSvgIcon>
  );
}

export function KSShareIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSShareIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M8.68387 13.3419C8.88616 12.9381 9 12.4824 9 12C9 11.5176 8.88616 11.0619 8.68387 10.6581M8.68387 13.3419C8.19134 14.3251 7.17449 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.17449 9 8.19134 9.67492 8.68387 10.6581M8.68387 13.3419L15.3161 16.6581M8.68387 10.6581L15.3161 7.34193M15.3161 7.34193C15.8087 8.32508 16.8255 9 18 9C19.6569 9 21 7.65685 21 6C21 4.34315 19.6569 3 18 3C16.3431 3 15 4.34315 15 6C15 6.48237 15.1138 6.93815 15.3161 7.34193ZM15.3161 16.6581C15.1138 17.0619 15 17.5176 15 18C15 19.6569 16.3431 21 18 21C19.6569 21 21 19.6569 21 18C21 16.3431 19.6569 15 18 15C16.8255 15 15.8087 15.6749 15.3161 16.6581Z" />
    </MuiSvgIcon>
  );
}

export function KSShieldCheckIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSShieldCheckIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M9 12L11 14L15 10M20.6179 5.98434C20.4132 5.99472 20.2072 5.99997 20 5.99997C16.9265 5.99997 14.123 4.84453 11.9999 2.94434C9.87691 4.84446 7.07339 5.99985 4 5.99985C3.79277 5.99985 3.58678 5.9946 3.38213 5.98422C3.1327 6.94783 3 7.95842 3 9.00001C3 14.5915 6.82432 19.2898 12 20.622C17.1757 19.2898 21 14.5915 21 9.00001C21 7.95847 20.8673 6.94791 20.6179 5.98434Z" />
    </MuiSvgIcon>
  );
}

export function KSShieldExclamationIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSShieldExclamationIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M12 9.00001V11M12 15H12.01M20.6179 5.98434C20.4132 5.99472 20.2072 5.99997 20 5.99997C16.9265 5.99997 14.123 4.84453 11.9999 2.94434C9.87691 4.84446 7.07339 5.99985 4 5.99985C3.79277 5.99985 3.58678 5.9946 3.38213 5.98422C3.1327 6.94783 3 7.95842 3 9.00001C3 14.5915 6.82432 19.2898 12 20.622C17.1757 19.2898 21 14.5915 21 9.00001C21 7.95847 20.8673 6.94791 20.6179 5.98434Z" />
    </MuiSvgIcon>
  );
}

export function KSShoppingBagIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSShoppingBagIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M16 11V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V11M5 9H19L20 21H4L5 9Z" />
    </MuiSvgIcon>
  );
}

export function KSShoppingCartIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSShoppingCartIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M3 3H5L5.4 5M7 13H17L21 5H5.4M7 13L5.4 5M7 13L4.70711 15.2929C4.07714 15.9229 4.52331 17 5.41421 17H17M17 17C15.8954 17 15 17.8954 15 19C15 20.1046 15.8954 21 17 21C18.1046 21 19 20.1046 19 19C19 17.8954 18.1046 17 17 17ZM9 19C9 20.1046 8.10457 21 7 21C5.89543 21 5 20.1046 5 19C5 17.8954 5.89543 17 7 17C8.10457 17 9 17.8954 9 19Z" />
    </MuiSvgIcon>
  );
}

export function KSSmViewGridAddIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSSmViewGridAddIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M17 14V20M14 17H20M6 10H8C9.10457 10 10 9.10457 10 8V6C10 4.89543 9.10457 4 8 4H6C4.89543 4 4 4.89543 4 6V8C4 9.10457 4.89543 10 6 10ZM16 10H18C19.1046 10 20 9.10457 20 8V6C20 4.89543 19.1046 4 18 4H16C14.8954 4 14 4.89543 14 6V8C14 9.10457 14.8954 10 16 10ZM6 20H8C9.10457 20 10 19.1046 10 18V16C10 14.8954 9.10457 14 8 14H6C4.89543 14 4 14.8954 4 16V18C4 19.1046 4.89543 20 6 20Z" />
    </MuiSvgIcon>
  );
}

export function KSSortAssendingIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSSortAssendingIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M3 4H16M3 8H12M3 12H9M13 12L17 8M17 8L21 12M17 8V20" />
    </MuiSvgIcon>
  );
}

export function KSSortdesendingIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSSortdesendingIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M3 4H16M3 8H12M3 12H12M17 8V20M17 20L13 16M17 20L21 16" />
    </MuiSvgIcon>
  );
}

export function KSSparklesIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSSparklesIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M5 3V7M3 5H7M6 17V21M4 19H8M13 3L15.2857 9.85714L21 12L15.2857 14.1429L13 21L10.7143 14.1429L5 12L10.7143 9.85714L13 3Z" />
    </MuiSvgIcon>
  );
}

export function KSSpeakerPhoneIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSSpeakerPhoneIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M11 5.88218V19.2402C11 20.2121 10.2121 21 9.24018 21C8.49646 21 7.83302 20.5325 7.58288 19.8321L5.43647 13.6829M18 13C19.6569 13 21 11.6569 21 10C21 8.34315 19.6569 7 18 7M5.43647 13.6829C4.0043 13.0741 3 11.6543 3 10C3 7.79086 4.79086 6 6.99999 6H8.83208C12.9327 6 16.4569 4.7659 18 3L18 17C16.4569 15.2341 12.9327 14 8.83208 14L6.99998 14C6.44518 14 5.91677 13.887 5.43647 13.6829Z" />
    </MuiSvgIcon>
  );
}

export function KSStarIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSStarIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M11.049 2.92664C11.3483 2.00537 12.6517 2.00538 12.951 2.92664L14.4699 7.60055C14.6038 8.01254 14.9877 8.29148 15.4209 8.29149L20.3354 8.29168C21.3041 8.29172 21.7068 9.53127 20.9232 10.1007L16.9474 12.9895C16.5969 13.2441 16.4503 13.6955 16.5841 14.1075L18.1026 18.7815C18.4019 19.7028 17.3475 20.4689 16.5638 19.8995L12.5878 17.011C12.2373 16.7564 11.7627 16.7564 11.4122 17.011L7.43622 19.8995C6.65252 20.4689 5.5981 19.7028 5.8974 18.7815L7.41589 14.1075C7.54974 13.6955 7.40309 13.2441 7.05263 12.9895L3.07683 10.1007C2.29317 9.53127 2.69592 8.29172 3.66461 8.29168L8.57911 8.29149C9.01231 8.29148 9.39623 8.01254 9.53011 7.60055L11.049 2.92664Z" />
    </MuiSvgIcon>
  );
}

export function KSStatusOfflineIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSStatusOfflineIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path
        d="M19.0711 4.92894C18.6805 4.53842 18.0474 4.53842 17.6569 4.92894C17.2663 5.31946 17.2663 5.95263 17.6569 6.34315L19.0711 4.92894ZM18.364 18.364L17.6569 19.0711L17.6569 19.0711L18.364 18.364ZM16.2426 7.75737C15.8521 7.36684 15.219 7.36684 14.8284 7.75737C14.4379 8.14789 14.4379 8.78106 14.8284 9.17158L16.2426 7.75737ZM15.5355 15.5355L14.8284 16.2426L14.8284 16.2427L15.5355 15.5355ZM7.75736 16.2427C8.14788 16.6332 8.78105 16.6332 9.17157 16.2427C9.5621 15.8521 9.5621 15.219 9.17157 14.8284L7.75736 16.2427ZM8.03998 12.5662C7.96233 12.0194 7.45612 11.6391 6.90932 11.7167C6.36252 11.7943 5.9822 12.3005 6.05984 12.8473L8.03998 12.5662ZM4.92893 19.0711C5.31946 19.4616 5.95262 19.4616 6.34315 19.0711C6.73367 18.6806 6.73367 18.0474 6.34315 17.6569L4.92893 19.0711ZM4.41704 9.44452C4.59296 8.921 4.31118 8.354 3.78767 8.17807C3.26415 8.00215 2.69714 8.28393 2.52122 8.80744L4.41704 9.44452ZM3.70711 2.29289C3.31658 1.90237 2.68342 1.90237 2.29289 2.29289C1.90237 2.68342 1.90237 3.31658 2.29289 3.70711L3.70711 2.29289ZM20.2929 21.7071C20.6834 22.0976 21.3166 22.0976 21.7071 21.7071C22.0976 21.3166 22.0976 20.6834 21.7071 20.2929L20.2929 21.7071ZM17.6569 6.34315C20.7811 9.46735 20.7811 14.5327 17.6569 17.6569L19.0711 19.0711C22.9763 15.1658 22.9763 8.83418 19.0711 4.92894L17.6569 6.34315ZM14.8284 9.17158C16.3905 10.7337 16.3905 13.2663 14.8284 14.8284L16.2426 16.2427C18.5858 13.8995 18.5858 10.1005 16.2426 7.75737L14.8284 9.17158ZM12 12H14C14 10.8954 13.1046 10 12 10V12ZM9.17157 14.8284C8.5339 14.1908 8.15753 13.394 8.03998 12.5662L6.05984 12.8473C6.2362 14.0894 6.80287 15.2882 7.75736 16.2427L9.17157 14.8284ZM6.34315 17.6569C4.1231 15.4368 3.47919 12.2354 4.41704 9.44452L2.52122 8.80744C1.35084 12.2902 2.15154 16.2937 4.92893 19.0711L6.34315 17.6569ZM12 12L12 12V10C11.448 10 10.9466 10.225 10.5858 10.5858L12 12ZM2.29289 3.70711L10.5858 12L12 10.5858L3.70711 2.29289L2.29289 3.70711ZM10.5858 12L12 13.4142L13.4142 12L12 10.5858L10.5858 12ZM12 13.4142L14.8284 16.2426L16.2426 14.8284L13.4142 12L12 13.4142ZM14.8284 16.2427L17.6569 19.0711L19.0711 17.6569L16.2426 14.8284L14.8284 16.2427ZM17.6569 19.0711L20.2929 21.7071L21.7071 20.2929L19.0711 17.6569L17.6569 19.0711ZM12 12L12 12L13.4142 13.4142C13.7751 13.0534 14 12.552 14 12H12Z"
        fill="#111827"
      />
    </MuiSvgIcon>
  );
}

export function KSStatusOnlineIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSStatusOnlineIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M5.63604 18.3642C2.12132 14.8494 2.12132 9.15095 5.63604 5.63623M18.364 5.63623C21.8787 9.15095 21.8787 14.8494 18.364 18.3642M8.46447 15.5357C6.51184 13.5831 6.51184 10.4173 8.46447 8.46466M15.5355 8.46466C17.4882 10.4173 17.4882 13.5831 15.5355 15.5357M13 12.0002C13 12.5525 12.5523 13.0002 12 13.0002C11.4477 13.0002 11 12.5525 11 12.0002C11 11.4479 11.4477 11.0002 12 11.0002C12.5523 11.0002 13 11.4479 13 12.0002Z" />
    </MuiSvgIcon>
  );
}

export function KSStopIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSStopIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" />
      <path d="M9 10C9 9.44772 9.44772 9 10 9H14C14.5523 9 15 9.44772 15 10V14C15 14.5523 14.5523 15 14 15H10C9.44772 15 9 14.5523 9 14V10Z" />
    </MuiSvgIcon>
  );
}

export function KSSunIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSSunIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M12 3V4M12 20V21M21 12H20M4 12H3M18.364 18.364L17.6569 17.6569M6.34315 6.34315L5.63604 5.63604M18.364 5.63609L17.6569 6.3432M6.3432 17.6569L5.63609 18.364M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z" />
    </MuiSvgIcon>
  );
}

export function KSSupportIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSSupportIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path
        d="M20 12C20 16.4183 16.4183 20 12 20V22C17.5228 22 22 17.5228 22 12H20ZM12 20C7.58172 20 4 16.4183 4 12H2C2 17.5228 6.47715 22 12 22V20ZM4 12C4 7.58172 7.58172 4 12 4V2C6.47715 2 2 6.47715 2 12H4ZM12 4C16.4183 4 20 7.58172 20 12H22C22 6.47715 17.5228 2 12 2V4ZM15 12C15 13.6569 13.6569 15 12 15V17C14.7614 17 17 14.7614 17 12H15ZM12 15C10.3431 15 9 13.6569 9 12H7C7 14.7614 9.23858 17 12 17V15ZM9 12C9 10.3431 10.3431 9 12 9V7C9.23858 7 7 9.23858 7 12H9ZM12 9C13.6569 9 15 10.3431 15 12H17C17 9.23858 14.7614 7 12 7V9ZM17.6569 4.92893L14.1213 8.46447L15.5355 9.87868L19.0711 6.34315L17.6569 4.92893ZM14.1213 15.5355L17.6569 19.0711L19.0711 17.6569L15.5355 14.1213L14.1213 15.5355ZM9.87868 8.46447L6.34315 4.92893L4.92893 6.34315L8.46447 9.87868L9.87868 8.46447ZM8.46447 14.1213L4.92893 17.6569L6.34315 19.0711L9.87868 15.5355L8.46447 14.1213Z"
        fill="#111827"
      />
    </MuiSvgIcon>
  );
}

export function KSSwitchHorizontalIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSSwitchHorizontalIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M8 7L20 7M20 7L16 3M20 7L16 11M16 17L4 17M4 17L8 21M4 17L8 13" />
    </MuiSvgIcon>
  );
}

export function KSSwitchVerticalIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSSwitchVerticalIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M7 16V4M7 4L3 8M7 4L11 8M17 8V20M17 20L21 16M17 20L13 16" />
    </MuiSvgIcon>
  );
}

export function KSTableIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSTableIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M3 10H21M3 14H21M12 10V18M5 18H19C20.1046 18 21 17.1046 21 16V8C21 6.89543 20.1046 6 19 6H5C3.89543 6 3 6.89543 3 8V16C3 17.1046 3.89543 18 5 18Z" />
    </MuiSvgIcon>
  );
}

export function KSTagIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSTagIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M13.5 3.67709L12.7503 4.33882C12.764 4.35438 12.7782 4.36952 12.7929 4.38419L13.5 3.67709ZM20.3229 13.5L19.6612 12.7503C19.6456 12.764 19.6305 12.7782 19.6158 12.7929L20.3229 13.5ZM20.5 10.6771L21.2497 10.0154C21.236 9.99979 21.2218 9.98466 21.2071 9.96998L20.5 10.6771ZM10.6771 20.5L9.96998 21.2071C9.98466 21.2218 9.99979 21.236 10.0154 21.2497L10.6771 20.5ZM13.3229 20.5L13.9846 21.2497C14.0002 21.236 14.0153 21.2218 14.03 21.2071L13.3229 20.5ZM3.67709 13.5L4.38419 12.7929L4.36217 12.7709L4.33882 12.7503L3.67709 13.5ZM7 6C6.44772 6 6 6.44772 6 7C6 7.55228 6.44772 8 7 8V6ZM7.01 8C7.56228 8 8.01 7.55228 8.01 7C8.01 6.44772 7.56228 6 7.01 6V8ZM4 7C4 5.34315 5.34315 4 7 4V2C4.23858 2 2 4.23858 2 7H4ZM4 12V7H2V12H4ZM7 4H12V2H7V4ZM12 4C12.2985 4 12.5656 4.12956 12.7503 4.33882L14.2497 3.01535C13.7015 2.3942 12.8962 2 12 2V4ZM20 12C20 12.2985 19.8704 12.5656 19.6612 12.7503L20.9846 14.2497C21.6058 13.7015 22 12.8962 22 12H20ZM19.7503 11.3388C19.9064 11.5157 20 11.7457 20 12H22C22 11.2398 21.716 10.5436 21.2497 10.0154L19.7503 11.3388ZM12 20C11.7457 20 11.5157 19.9064 11.3388 19.7503L10.0154 21.2497C10.5436 21.716 11.2398 22 12 22V20ZM12.6612 19.7503C12.4843 19.9064 12.2543 20 12 20V22C12.7602 22 13.4564 21.716 13.9846 21.2497L12.6612 19.7503ZM4.33882 12.7503C4.12956 12.5656 4 12.2985 4 12H2C2 12.8962 2.3942 13.7015 3.01535 14.2497L4.33882 12.7503ZM12.7929 4.38419L19.7929 11.3842L21.2071 9.96998L14.2071 2.96998L12.7929 4.38419ZM11.3842 19.7929L4.38419 12.7929L2.96998 14.2071L9.96998 21.2071L11.3842 19.7929ZM19.6158 12.7929L12.6158 19.7929L14.03 21.2071L21.03 14.2071L19.6158 12.7929ZM7 8H7.01V6H7V8Z" />
    </MuiSvgIcon>
  );
}

export function KSTempleIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSTempleIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M4 5C4 4.44772 4.44772 4 5 4H19C19.5523 4 20 4.44772 20 5V7C20 7.55228 19.5523 8 19 8H5C4.44772 8 4 7.55228 4 7V5Z" />
      <path d="M4 13C4 12.4477 4.44772 12 5 12H11C11.5523 12 12 12.4477 12 13V19C12 19.5523 11.5523 20 11 20H5C4.44772 20 4 19.5523 4 19V13Z" />
      <path d="M16 13C16 12.4477 16.4477 12 17 12H19C19.5523 12 20 12.4477 20 13V19C20 19.5523 19.5523 20 19 20H17C16.4477 20 16 19.5523 16 19V13Z" />
    </MuiSvgIcon>
  );
}

export function KSTerminalIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSTerminalIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M8 9L11 12L8 15M13 15H16M5 20H19C20.1046 20 21 19.1046 21 18V6C21 4.89543 20.1046 4 19 4H5C3.89543 4 3 4.89543 3 6V18C3 19.1046 3.89543 20 5 20Z" />
    </MuiSvgIcon>
  );
}

export function KSThumbDownIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSThumbDownIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M9.99991 14H5.23598C3.74922 14 2.78222 12.4354 3.44712 11.1056L6.94712 4.10557C7.28591 3.42801 7.97843 3 8.73598 3H12.7537C12.9172 3 13.0801 3.02005 13.2388 3.05972L16.9999 4M9.99991 14V19C9.99991 20.1046 10.8953 21 11.9999 21H12.0954C12.5949 21 12.9999 20.595 12.9999 20.0955C12.9999 19.3812 13.2113 18.6828 13.6076 18.0885L16.9999 13V4M9.99991 14H11.9999M16.9999 4H18.9999C20.1045 4 20.9999 4.89543 20.9999 6V12C20.9999 13.1046 20.1045 14 18.9999 14H16.4999" />
    </MuiSvgIcon>
  );
}

export function KSThumbUpIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSThumbUpIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M14 10H18.7639C20.2507 10 21.2177 11.5646 20.5528 12.8944L17.0528 19.8944C16.714 20.572 16.0215 21 15.2639 21H11.2462C11.0827 21 10.9198 20.9799 10.7611 20.9403L7 20M14 10V5C14 3.89543 13.1046 3 12 3H11.9045C11.405 3 11 3.40497 11 3.90453C11 4.61883 10.7886 5.31715 10.3923 5.91149L7 11V20M14 10H12M7 20H5C3.89543 20 3 19.1046 3 18V12C3 10.8954 3.89543 10 5 10H7.5" />
    </MuiSvgIcon>
  );
}

export function KSTicketIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSTicketIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M15 5V7M15 11V13M15 17V19M5 5C3.89543 5 3 5.89543 3 7V10C4.10457 10 5 10.8954 5 12C5 13.1046 4.10457 14 3 14V17C3 18.1046 3.89543 19 5 19H19C20.1046 19 21 18.1046 21 17V14C19.8954 14 19 13.1046 19 12C19 10.8954 19.8954 10 21 10V7C21 5.89543 20.1046 5 19 5H5Z" />
    </MuiSvgIcon>
  );
}

export function KSTranslateIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSTranslateIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M3 5H15M9 3V5M10.0482 14.5C8.52083 12.9178 7.28073 11.0565 6.41187 9M12.5 18H19.5M11 21L16 11L21 21M12.7511 5C11.7831 10.7702 8.06969 15.6095 3 18.129" />
    </MuiSvgIcon>
  );
}

export function KSTrashIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSTrashIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M19 7L18.1327 19.1425C18.0579 20.1891 17.187 21 16.1378 21H7.86224C6.81296 21 5.94208 20.1891 5.86732 19.1425L5 7M10 11V17M14 11V17M15 7V4C15 3.44772 14.5523 3 14 3H10C9.44772 3 9 3.44772 9 4V7M4 7H20" />
    </MuiSvgIcon>
  );
}

export function KSTrendingDownIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSTrendingDownIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M13 17H21M21 17V9M21 17L13 9L9 13L3 7" />
    </MuiSvgIcon>
  );
}

export function KSTrendingUpIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSTrendingUpIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M13 7H21M21 7V15M21 7L13 15L9 11L3 17" />
    </MuiSvgIcon>
  );
}

export function KSTruckIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSTruckIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M13 16V6C13 5.44772 12.5523 5 12 5H4C3.44772 5 3 5.44772 3 6V16C3 16.5523 3.44772 17 4 17H5M13 16C13 16.5523 12.5523 17 12 17H9M13 16L13 8C13 7.44772 13.4477 7 14 7H16.5858C16.851 7 17.1054 7.10536 17.2929 7.29289L20.7071 10.7071C20.8946 10.8946 21 11.149 21 11.4142V16C21 16.5523 20.5523 17 20 17H19M13 16C13 16.5523 13.4477 17 14 17H15M5 17C5 18.1046 5.89543 19 7 19C8.10457 19 9 18.1046 9 17M5 17C5 15.8954 5.89543 15 7 15C8.10457 15 9 15.8954 9 17M15 17C15 18.1046 15.8954 19 17 19C18.1046 19 19 18.1046 19 17M15 17C15 15.8954 15.8954 15 17 15C18.1046 15 19 15.8954 19 17" />
    </MuiSvgIcon>
  );
}

export function KSUploadIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSUploadIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M4 16L4 17C4 18.6569 5.34315 20 7 20L17 20C18.6569 20 20 18.6569 20 17L20 16M16 8L12 4M12 4L8 8M12 4L12 16" />
    </MuiSvgIcon>
  );
}

export function KSUserCircleIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSUserCircleIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M18 9V12M18 12V15M18 12H21M18 12H15M13 7C13 9.20914 11.2091 11 9 11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3C11.2091 3 13 4.79086 13 7ZM3 20C3 16.6863 5.68629 14 9 14C12.3137 14 15 16.6863 15 20V21H3V20Z" />
    </MuiSvgIcon>
  );
}

export function KSUserGroupIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSUserGroupIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M17 20H22V18C22 16.3431 20.6569 15 19 15C18.0444 15 17.1931 15.4468 16.6438 16.1429M17 20H7M17 20V18C17 17.3438 16.8736 16.717 16.6438 16.1429M7 20H2V18C2 16.3431 3.34315 15 5 15C5.95561 15 6.80686 15.4468 7.35625 16.1429M7 20V18C7 17.3438 7.12642 16.717 7.35625 16.1429M7.35625 16.1429C8.0935 14.301 9.89482 13 12 13C14.1052 13 15.9065 14.301 16.6438 16.1429M15 7C15 8.65685 13.6569 10 12 10C10.3431 10 9 8.65685 9 7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7ZM21 10C21 11.1046 20.1046 12 19 12C17.8954 12 17 11.1046 17 10C17 8.89543 17.8954 8 19 8C20.1046 8 21 8.89543 21 10ZM7 10C7 11.1046 6.10457 12 5 12C3.89543 12 3 11.1046 3 10C3 8.89543 3.89543 8 5 8C6.10457 8 7 8.89543 7 10Z" />
    </MuiSvgIcon>
  );
}

export function KSUsersIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSUsersIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M12 4.35418C12.7329 3.52375 13.8053 3 15 3C17.2091 3 19 4.79086 19 7C19 9.20914 17.2091 11 15 11C13.8053 11 12.7329 10.4762 12 9.64582M15 21H3V20C3 16.6863 5.68629 14 9 14C12.3137 14 15 16.6863 15 20V21ZM15 21H21V20C21 16.6863 18.3137 14 15 14C13.9071 14 12.8825 14.2922 12 14.8027M13 7C13 9.20914 11.2091 11 9 11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3C11.2091 3 13 4.79086 13 7Z" />
    </MuiSvgIcon>
  );
}

export function KSVariableIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSVariableIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M4.87104 4C3.67341 6.40992 3 9.12632 3 12C3 14.8737 3.67341 17.5901 4.87104 20M19.0001 20C20.1977 17.5901 20.8711 14.8737 20.8711 12C20.8711 9.12632 20.1977 6.40992 19.0001 4M9 9H10.2457C10.6922 9 11.0846 9.29598 11.2072 9.72528L12.7928 15.2747C12.9154 15.704 13.3078 16 13.7543 16H15M16 9H15.9199C15.336 9 14.7813 9.25513 14.4014 9.69842L9.59864 15.3016C9.21868 15.7449 8.66398 16 8.08013 16H8" />
    </MuiSvgIcon>
  );
}

export function KSVideoCameraIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSVideoCameraIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M15 10L19.5528 7.72361C20.2177 7.39116 21 7.87465 21 8.61803V15.382C21 16.1253 20.2177 16.6088 19.5528 16.2764L15 14M5 18H13C14.1046 18 15 17.1046 15 16V8C15 6.89543 14.1046 6 13 6H5C3.89543 6 3 6.89543 3 8V16C3 17.1046 3.89543 18 5 18Z" />
    </MuiSvgIcon>
  );
}

export function KSViewBoardsIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSViewBoardsIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M9 17V7M9 17C9 18.1046 8.10457 19 7 19H5C3.89543 19 3 18.1046 3 17V7C3 5.89543 3.89543 5 5 5H7C8.10457 5 9 5.89543 9 7M9 17C9 18.1046 9.89543 19 11 19H13C14.1046 19 15 18.1046 15 17M9 7C9 5.89543 9.89543 5 11 5H13C14.1046 5 15 5.89543 15 7M15 17V7M15 17C15 18.1046 15.8954 19 17 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H17C15.8954 5 15 5.89543 15 7" />
    </MuiSvgIcon>
  );
}

export function KSViewGridIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSViewGridIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M4 6C4 4.89543 4.89543 4 6 4H8C9.10457 4 10 4.89543 10 6V8C10 9.10457 9.10457 10 8 10H6C4.89543 10 4 9.10457 4 8V6Z" />
      <path d="M14 6C14 4.89543 14.8954 4 16 4H18C19.1046 4 20 4.89543 20 6V8C20 9.10457 19.1046 10 18 10H16C14.8954 10 14 9.10457 14 8V6Z" />
      <path d="M4 16C4 14.8954 4.89543 14 6 14H8C9.10457 14 10 14.8954 10 16V18C10 19.1046 9.10457 20 8 20H6C4.89543 20 4 19.1046 4 18V16Z" />
      <path d="M14 16C14 14.8954 14.8954 14 16 14H18C19.1046 14 20 14.8954 20 16V18C20 19.1046 19.1046 20 18 20H16C14.8954 20 14 19.1046 14 18V16Z" />
    </MuiSvgIcon>
  );
}

export function KSViewListIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSViewListIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M4 6H20M4 10H20M4 14H20M4 18H20" />
    </MuiSvgIcon>
  );
}

export function KSVolumeOffIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSVolumeOffIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M17 14L19 12M19 12L21 10M19 12L17 10M19 12L21 14M5.58579 15.0001H4C3.44772 15.0001 3 14.5523 3 14.0001V10.0001C3 9.44777 3.44772 9.00005 4 9.00005H5.58579L10.2929 4.29294C10.9229 3.66298 12 4.10915 12 5.00005V19.0001C12 19.891 10.9229 20.3371 10.2929 19.7072L5.58579 15.0001Z" />
    </MuiSvgIcon>
  );
}

export function KSVolumeUpIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSVolumeUpIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M15.5355 8.46448C17.4881 10.4171 17.4881 13.5829 15.5355 15.5355M18.364 5.63599C21.8787 9.15071 21.8787 14.8492 18.364 18.3639M5.58579 15.0001H4C3.44772 15.0001 3 14.5523 3 14.0001V10.0001C3 9.44777 3.44772 9.00005 4 9.00005H5.58579L10.2929 4.29294C10.9229 3.66298 12 4.10915 12 5.00005V19.0001C12 19.891 10.9229 20.3371 10.2929 19.7072L5.58579 15.0001Z" />
    </MuiSvgIcon>
  );
}

export function KSWifiIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSWifiIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M8.11107 16.4039C10.259 14.256 13.7414 14.256 15.8892 16.4039M12.0002 20H12.0102M4.92913 12.9289C8.83437 9.02371 15.166 9.0237 19.0713 12.9289M1.39355 9.3934C7.25142 3.53553 16.7489 3.53553 22.6068 9.3934" />
    </MuiSvgIcon>
  );
}

export function KSXCircleIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSXCircleIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M10 14L12 12M12 12L14 10M12 12L10 10M12 12L14 14M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" />
    </MuiSvgIcon>
  );
}

export function KSZoomInIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSZoomInIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M21 21L15 15M10 7V10M10 10V13M10 10H13M10 10H7M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z" />
    </MuiSvgIcon>
  );
}

export function KSZoomOutIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSZoomOutIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M21 21L15 15M13 10H7M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z" />
    </MuiSvgIcon>
  );
}

export function KSBorrowerEditFeatureIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSBorrowerEditFeatureIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M13.2375 3.28516L15.3325 5.38016L10.095 10.6177H8V8.52266L13.2375 3.28516Z" />
      <path d="M5.50195 7.67773L3.45625 7.67773C2.37153 7.67773 1.49219 8.55718 1.49219 9.64203V10.6242" />
      <path d="M5.175 5.71374C6.25972 5.71374 7.13906 4.8343 7.13906 3.74945C7.13906 2.6646 6.25972 1.78516 5.175 1.78516C4.09028 1.78516 3.21094 2.6646 3.21094 3.74945C3.21094 4.8343 4.09028 5.71374 5.175 5.71374Z" />
    </MuiSvgIcon>
  );
}

export function KSReAssignMloIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSReAssignMloIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 17 17",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M11.625 13.125V11.875C11.625 10.4943 10.5057 9.375 9.125 9.375H4.125C2.74429 9.375 1.625 10.4943 1.625 11.875V13.125" />
      <path d="M6.625 6.875C8.00571 6.875 9.125 5.75571 9.125 4.375C9.125 2.99429 8.00571 1.875 6.625 1.875C5.24429 1.875 4.125 2.99429 4.125 4.375C4.125 5.75571 5.24429 6.875 6.625 6.875Z" />
      <path d="M15.375 13.1248V11.8748C15.3742 10.7355 14.6031 9.74088 13.5 9.45605" stroke="#00CB14" />
      <path d="M11 1.95605C12.1062 2.23929 12.8799 3.23605 12.8799 4.37793C12.8799 5.51981 12.1062 6.51657 11 6.7998" stroke="#00CB14" />
    </MuiSvgIcon>
  );
}


export function KSLinkedInIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSLinkedInIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 61 61",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <circle cx="30.0856" cy="30.0856" r="29.0856" stroke="white" strokeWidth="2" />
      <path d="M31.6346 28.9042C32.271 28.1216 33.0141 27.501 33.8797 27.0267C35.8126 25.9635 37.8522 25.7342 39.9471 26.4022C41.9432 27.0386 43.3345 28.3588 44.0776 30.3509C44.4176 31.26 44.627 32.185 44.627 33.1613C44.6191 36.8966 44.6231 40.6318 44.6231 44.3632C44.6231 44.6991 44.6231 44.6991 44.2871 44.6991C42.627 44.6991 40.9669 44.6991 39.3067 44.6991C39.034 44.6991 39.034 44.6991 39.034 44.4304C39.034 41.1299 39.0498 37.8294 39.0301 34.5329C39.0222 33.4142 38.6467 32.4379 37.6743 31.7778C37.034 31.347 36.3106 31.1968 35.5517 31.2245C34.6189 31.2561 33.7493 31.4893 33.0655 32.1692C32.4133 32.8174 32.0931 33.6316 31.9864 34.5289C31.9508 34.8135 31.9508 35.106 31.9508 35.3945C31.9469 38.4065 31.9508 41.4145 31.9508 44.4264C31.9508 44.6991 31.9508 44.6991 31.682 44.6991C30.0101 44.6991 28.3381 44.6991 26.6621 44.6991C26.3894 44.6991 26.3894 44.6991 26.3894 44.4224C26.3894 38.5013 26.3894 32.5802 26.3894 26.6591C26.3894 26.3903 26.3894 26.3903 26.6621 26.3903C28.2353 26.3903 29.8124 26.3943 31.3856 26.3864C31.5872 26.3864 31.6425 26.4457 31.6386 26.6433C31.6267 27.335 31.6346 28.0267 31.6346 28.7185C31.6346 28.7778 31.6346 28.841 31.6346 28.9042Z" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" />
      <path d="M17.6109 35.5481C17.6109 32.5836 17.6109 29.6191 17.6109 26.6546C17.6109 26.3858 17.6109 26.3818 17.8797 26.3818C19.5793 26.3818 21.279 26.3818 22.9786 26.3818C23.3106 26.3818 23.3146 26.3818 23.3146 26.7139C23.3146 31.7179 23.3146 36.726 23.3146 41.7301C23.3146 42.6313 23.3106 43.5364 23.3186 44.4377C23.3186 44.6353 23.2553 44.6985 23.0577 44.6946C21.3264 44.6867 19.5912 44.6867 17.8599 44.6946C17.6623 44.6946 17.6069 44.6353 17.6069 44.4337C17.6148 41.4771 17.6109 38.5126 17.6109 35.5481Z" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" />
      <path d="M20.4566 23.7214C18.6541 23.7214 17.1877 22.2549 17.1917 20.4485C17.1956 18.654 18.6858 17.1757 20.4763 17.1915C22.2748 17.2073 23.7254 18.6659 23.7254 20.4604C23.7254 22.2668 22.2669 23.7214 20.4566 23.7214Z" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" />
    </MuiSvgIcon>
  );
}


export function KSFacebookIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSFacebookIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 61 61",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <circle cx="30.4828" cy="30.0856" r="29.0856" stroke="white" strokeWidth="2" />
      <path fillRule="evenodd" clipRule="evenodd" d="M37.524 17.9233H33.6833C30.148 17.9233 27.2821 20.7893 27.2821 24.3245V28.1653H23.4414V33.2862H27.2821V43.5281H32.4031V33.2862H36.2438L37.524 28.1653H32.4031V24.3245C32.4031 23.6175 32.9763 23.0443 33.6833 23.0443H37.524V17.9233Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </MuiSvgIcon>
  );
}


export function KSTwitterIcon({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSTwitterIcon",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "currentColor",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 61 61",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <circle cx="30.4828" cy="30.0856" r="29.0856" stroke="white" strokeWidth="2" />
      <path fillRule="evenodd" clipRule="evenodd" d="M45.6372 19.2036C44.4112 20.0683 43.0538 20.7298 41.6172 21.1623C40.0379 19.3464 37.4928 18.7095 35.2443 19.5677C32.9958 20.4259 31.5223 22.5966 31.5546 25.0031V26.2833C26.985 26.4018 22.6595 24.2246 20.0324 20.4838C20.0324 20.4838 14.9114 32.006 26.4336 37.1269C23.797 38.9166 20.6561 39.814 17.4719 39.6874C28.9941 46.0886 43.0767 39.6874 43.0767 24.9646C43.0755 24.608 43.0412 24.2523 42.9743 23.902C44.2809 22.6135 45.203 20.9866 45.6372 19.2036Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </MuiSvgIcon>
  );
}

export function ViewInvoiceIcon({ width = 20, height = 20 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.04659 17.5H13.679C14.5678 17.5 15.2883 16.7538 15.2883 15.8333V7.84518C15.2883 7.62416 15.2035 7.4122 15.0526 7.25592L10.6962 2.74408C10.5453 2.5878 10.3406 2.5 10.1272 2.5H5.6327C4.74393 2.5 4.02344 3.24619 4.02344 4.16667V13.3333M4.02344 17.5L7.94897 13.4344M7.94897 13.4344C8.3858 13.8868 8.98927 14.1667 9.65585 14.1667C10.989 14.1667 12.0697 13.0474 12.0697 11.6667C12.0697 10.286 10.989 9.16667 9.65585 9.16667C8.3227 9.16667 7.24196 10.286 7.24196 11.6667C7.24196 12.357 7.51214 12.982 7.94897 13.4344Z"
        stroke="#31B9B5"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}



export function DownloadInvoiceIcon({ width = 20, height = 22 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_15442_166214)">
        <path
          d="M14.1667 7.66927C16.0076 7.66927 17.5 9.16165 17.5 11.0026C17.5 12.5918 16.3879 13.9213 14.8994 14.2551C14.9653 14.5493 15 14.8552 15 15.1693C15 17.4705 13.1345 19.3359 10.8333 19.3359C8.81725 19.3359 7.13559 17.9041 6.74985 16.0018C6.72219 16.0023 6.69446 16.0026 6.66667 16.0026C4.36548 16.0026 2.5 14.1371 2.5 11.8359C2.5 9.82014 3.93147 8.13868 5.83333 7.75262M7.5 10.1693L10 12.6693M10 12.6693L12.5 10.1693M10 12.6693L10 2.66927"
          stroke="#31B9B5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_15442_166214">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(20 21) rotate(-180)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}



export function MailInvoiceIcon({ width = 19, height = 19 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.16732 3.17188H15.834C16.7048 3.17188 17.4173 3.88437 17.4173 4.75521V14.2552C17.4173 15.126 16.7048 15.8385 15.834 15.8385H3.16732C2.29648 15.8385 1.58398 15.126 1.58398 14.2552V4.75521C1.58398 3.88437 2.29648 3.17188 3.16732 3.17188Z"
        stroke="#31B9B5"
        strokeWidth="1.82264"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4173 4.75L9.50065 10.2917L1.58398 4.75"
        stroke="#31B9B5"
        strokeWidth="1.82264"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}


export function DeleteIcon({ width = 14, height = 15 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.18155 2.27273C5.18155 2.1221 5.30366 2 5.45428 2H7.99973C8.15036 2 8.27246 2.1221 8.27246 2.27273V2.54545H5.18155V2.27273ZM3.18155 2.27273V2.54688H2.27273H2.27246H1C0.447715 2.54688 0 2.99459 0 3.54688C0 4.09916 0.447715 4.54688 1 4.54688H1.27246V12.456C1.27246 13.7112 2.29 14.7287 3.54519 14.7287H9.90882C11.164 14.7287 12.1816 13.7112 12.1816 12.456V4.54688H12.4545C13.0068 4.54688 13.4545 4.09916 13.4545 3.54688C13.4545 2.99459 13.0068 2.54688 12.4545 2.54688H11.1816H10.2725V2.27273C10.2725 1.01753 9.25493 0 7.99973 0H5.45428C4.19909 0 3.18155 1.01753 3.18155 2.27273ZM10.1816 4.54688H3.27246V12.456C3.27246 12.6066 3.39457 12.7287 3.54519 12.7287H9.90882C10.0594 12.7287 10.1816 12.6066 10.1816 12.456V4.54688Z"
        fill="#31B9B5"
      />
    </svg>
  );
}

export function NoCoupon({ size }) {
  const getSize = (size) => {
    switch (size) {
      case 'xs':
        return { width: 100, height: 50 };
      case 'sm':
        return { width: 150, height: 75 };
      case 'md':
        return { width: 180, height: 90 };
      case 'lg':
        return { width: 213, height: 121 };
      case 'xl':
        return { width: 250, height: 150 };
      default:
        return { width: 213, height: 121 };
    }
  };

  const { width, height } = getSize(size);

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={width} height={height} fill="url(#pattern0)" />
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref="#image0_17863_84597" transform="matrix(0.0078125 0 0 0.0137526 0 -0.00196927)" />
        </pattern>
        <image id="image0_17863_84597" width="128" height="73" xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAABJCAYAAAD12S63AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAACiVJREFUeNrsXV1sFEUcn16vvVpbekYMlaiUB1sTHtoCBk3UlmhsjEFJjEoggUKC4EsjhGjig6CPaCDwBPJA1UAQHoASYzQmXCUxISmUPpjYqrGgARpDvEKh9Ovq/Ka7ZXZ2Zvc+Zvf27vaXbA6ud/sxv//3/GeujHBo3nOrnYQoVjQYB5CgR3Jgz6NXygziW+jLae4DIUoDwxHjHyH5JWoVIlT7G0LySxdRJ/LfaK4kjfVR0lRfPv/epeFp9jp4c5rcmZgl15MpdpQiVjZEC+ZeB2/OkDv3Z6UCYENtVRk5srHWQvz8Qy+JhmpToIAQ7O65y15NRGQf/PTNh6XkhyhsgNN979RY3ovQVCAhav/qpopwtIoUi+NWnY/IpCREaQWBrkCQt/XrO+wVFgLB4a6Oas9vru/qNNl99u78dXFNXDuEGscuTpDDveMs4IO2I5YTtd7RAshwbmByPtLHiXERP4AH4a97/OL9kGEXfPHDvfloH2MH7kRlzlgAghTFhsgN10ezEICaqjLHQMKzgKXOep0wOM08yBO5E9N4WwzQZxR6eGxYFSNj1Kz0XZ1ipKxfVeXLw8Dnw/cPjsyw625reyhk2AVI8+Aqoekrl1S4xkzmZJClRNT/ySPhSBYxWj/7L7MsoFiBLMPJPIZpYBECgSRMZI8QHZuAyYSLK5V6SLSQtDRXDT3ce58coqmlEyAYOLbTeGNbW1UoAPnOafmaA2bfUNjQcS43HGLFlJQnBS/k6bVCdO4XxBnBQNcBRDMty1DSwfnBqayKV/gOvqvT/bx+cJS8tDfJKquy6Vm/456o0Q5mu9Fi8oHQfhFbX6wk61ZWzGsiyDjRN0WOXJi0fXd1U13O94AKHKZizUochBnnxsyrn0j8NmmzAHHbgP14LxDEiTlsNg0YEGax/Anyt75QaTHD+Dfe2/lKzEZcrhVIfH/dl7dt50F9w+8AWLSq0hGFdO78doz5P7+qfjLg+muaY6zzqDZWlpVVSkhMOIhWYd2zFWTfTxO2c2RrETHoKnO/uqnSV/JxH7IgMKnym31Xb7Pyaz7Tolyvi0COx4qn3M+Hz1y6NqM8hw7yYd38yjKg9fwkkUUA0BtO44BhIukNxBfMtAjmd9er1QUXG+gItLI5hxv5Xvt+XBdKjJqHkwszXcAOehyVxQO8W4AfK7T8eHHcKrDXR93JFD8jniOdwd95cixv5KPecYwSn4bgJpmDp1bgDH1ZagjCGZVbMPNjNGn46bdQu8ZrNilZo2CxboymyOVrao3A324IU6aNGVg9855lndJekw/CoaSHjIYQFekGx+B6qbIaYSwT20SPTlWE7rUkIxDlSc+mEISBQO7NDwgi/s/fqiLLhXhgaCRF3j8+bvvsd111aRVu8mn2cU1c28Hcd9PjAFy+axZgWIUEAmAqCAcM99AiBhYrGio8bdFC9J8rQNwGGsTyJWAM1vZj46RxUYS0Nc4NQe/QNBMAEfhu0MkHYJUV5IPHzZTPYacYgDgIAiSmlQrCUdEazBVJKjwrayL10wHELOcHJ20DBMKHRiYdM5B04p18k4/qnsI9dlP+Njt9N23nNpLYe7a+/aMG3hJMThMSi5Z5tkKmYWE5uTWWIgtrI6RpUTnpermaLKzJri7RsayS/PLnFD1felYF5MPd4PmCTD7Tfq7CmAn5QEYqRq0AsoR+PmVEoQg+slBSQlgt1VQwT5zZjRR08kE8YhwBw5T8pel8PyN1oidNGtGj5QbECYagAoSCFAgs2tx4y4V/4z38DZ8pBPLNgp0EO9L9flZOllqCv3grUCpz50Ej3wz+BIuWtvZnbAE4nLEOyLSngw0LExQrEyTy54pWKUdu3JBt9DagO12TQWdDSDGSb96TEzdeWYBhl5vQAl0NIcVKvhnYOnHjlQC43UTo830MbHNBtgLQwP/Hq54BscqYj5VBQSbfrFcIaPEjBmj2QwD4hhD2sIvKQ/JFC2Cvli7xwwKstQhAXcRTCUc7OA4/O2kLgfy58Yk6cqPdAjTvubVWdAGYFAp9vjyIRRMmUjWcE5YSVsycRNMh0CtQzOq1umfM5Io7v6iQcykYQPXMKzcAEtA86deyLR3k8xtbOAVvuja8QJu5cL9XqAC0euEC9ovkIzf3inx0trAe+q/mmkK8bkTRQT60HvfrtnUeroHn0fFMG+yrtVuM2Vt9AiCbDga8XLItLuPq4XYqCbLmZ1rryHXHlfWrYjJ30kk525+zAMCf0KNfRj6bUPHINKtKv5LSZyDINzVaRE2MkNeWRciW58vJ28sjpH5BmcTSjeck2CBfoYgfUO5OG7vBZhYEGsHeJlVUOdcs4Z32q1I+3RmHzoBPJBHEd7WXMyEw0dVOyKnLKXIwMWMRHnTv5rIOEco4dHNaNtUN/tZSPruJU0uYEeBBy9voQW9T3SEMv4+dKLxMy8zdyPgHQiFIZ7zBtLbnrpZULzFoHfjWJ8vIxx1yIYYl+P3fWfL9rw8EBtO6uzpyex7zfhX9Dp2GW8CUPjIE5A7d5g4hnUaAF3e6AAYfWu/nVm1sL2Jq9rNdGeREvqqJMps8n991AwD5sAAqQAC2fGN1cz9/GNeiVBmshE5GuejeUeNRkcvHHn0QOt1Zhm7yZaivcyby6cfsf9eV7sKVtD9TyWILlwm0uLk6OO4UXMC/FAtgUbBow0vygwBWPd1Yy57z3MAEcwuq3cKV5Kt2DPe7KpfL4lCRfCyc8KK8i/Hiz3vhjxRpfUJ9v/i7jDTtwTQds6b6aqbIyFLEFjKlbd33bk3eyYcvA2EorOAVRy7Aw3tV2xfJQ4A35uCGT/WnbER5CQgoOBU7uCEASdmABGHHLDGazbXxRFZ/12X21z9nrcaB/K6T06T/n1lb8Nd1ir7/t/V9xFh+QEzdzdXBljcRQBQjxFVCiG107QHEfC7VLj7oYmSfdO9iQpDrV4AtKrbUBQRlS1YdO4TYNNUom0LrdW8AhdpIpqacmWaPaypOiMpuKCgw0xmdQRKe78R7CzyZwDIDZ5dFmoEKtKOyqDFo6YwXtQUv3QwEDPGLanOGOZMfU03i5FcAQuhzXzjMSua8gGiuaGoXgHy2XhcjvKhk+m4BkDujrIhSJSQYqYQfUgzzyX7+ZGKWzQ5is6ogD2YQwI8ZtouXuRmMoTlzmZYAiE0LEAQ/VgTjQczKFSwTbhrFjBBqoMzNb0ZZw1LfmFIApOokNmOMCdUzv34pVFxypnPb1mKFyM2Yy6IdqQDo2plDN8KftNM0jlyzTSSdgV5Do1nzPZgPv2bMsC+h6fPNXoQQ7rUT0+eDszWSCmNt1QPaw5+MKUHwewqEIXUpZgrcJtUR2Xbxpfpz8KUABPjir4fHnVKJEMVVIxB/OyGq+iB2nkIwkW3kHVYU/QNfbUTxB3ice+8Sq6HMSLuFldvFszwcPxYZElkQuT9f/MkEEWOhQDIcxtKEmQXsCIeiJJH4X4ABAIEVrj1qzFPrAAAAAElFTkSuQmCC" />
      </defs>
    </svg>
  );
}


export function KSChatImage({ fill = "none", ...props }) {
  const MuiSvgIcon = styled(SvgIcon, {
    name: "KSChatImage",
    shouldForwardProp: (prop) => prop !== "fill",
  })(() => ({
    fill: fill,
    stroke: "none",
    strokeLinecap: props.strokeLinecap ? props.strokeLinecap : "round",
    strokeLinejoin: props.strokeLinejoin ? props.strokeLinejoin : "round",
    strokeWidth: props.strokeWidth ? props.strokeWidth : "2px",
  }));
  MuiSvgIcon.defaultProps = {
    viewBox: "0 0 323 240",
    focusable: "false",
    "aria-hidden": "true",
  };

  return (
    <MuiSvgIcon {...props}>
      <path d="M322.051 210.875H0V211.036H322.051V210.875Z" fill="#E0E0E0" />
      <path d="M279.027 220.977H250.133V221.138H279.027V220.977Z" fill="#E0E0E0" />
      <path d="M245.894 220.977H240.297V221.138H245.894V220.977Z" fill="#E0E0E0" />
      <path d="M192.79 218.758H180.32V218.919H192.79V218.758Z" fill="#E0E0E0" />
      <path d="M79.9437 218.672H52.125V218.833H79.9437V218.672Z" fill="#E0E0E0" />
      <path d="M46.3975 218.672H42.3203V218.833H46.3975V218.672Z" fill="#E0E0E0" />
      <path d="M182.269 214.859H121.93V215.02H182.269V214.859Z" fill="#E0E0E0" />
      <path d="M152.65 182.152H28.2808C27.3065 182.15 26.3726 181.762 25.6843 181.072C24.996 180.383 24.6094 179.448 24.6094 178.474V3.64561C24.6179 2.6769 25.0082 1.75065 25.6956 1.06806C26.383 0.385468 27.312 0.00165946 28.2808 0H152.65C153.626 0 154.561 0.387484 155.251 1.07721C155.941 1.76693 156.328 2.7024 156.328 3.67782V178.474C156.328 179.449 155.941 180.385 155.251 181.075C154.561 181.764 153.626 182.152 152.65 182.152ZM28.2808 0.128821C27.3492 0.130527 26.4563 0.501797 25.7982 1.16114C25.14 1.82048 24.7704 2.71402 24.7704 3.64561V178.474C24.7704 179.406 25.14 180.299 25.7982 180.959C26.4563 181.618 27.3492 181.989 28.2808 181.991H152.65C153.583 181.989 154.476 181.618 155.135 180.959C155.794 180.3 156.165 179.406 156.167 178.474V3.64561C156.165 2.71343 155.794 1.8199 155.135 1.16075C154.476 0.501588 153.583 0.130523 152.65 0.128821H28.2808Z" fill="#E0E0E0" />
      <path d="M291.976 182.152H167.6C166.625 182.15 165.69 181.762 165.001 181.073C164.312 180.383 163.924 179.449 163.922 178.474V3.64561C163.932 2.67631 164.324 1.75007 165.012 1.06766C165.701 0.385243 166.63 0.00164136 167.6 0H291.976C292.943 0.00335222 293.871 0.38791 294.557 1.07032C295.243 1.75273 295.632 2.67801 295.641 3.64561V178.474C295.641 179.447 295.255 180.381 294.568 181.07C293.881 181.76 292.949 182.148 291.976 182.152ZM167.6 0.128821C166.668 0.130523 165.774 0.501588 165.115 1.16075C164.456 1.8199 164.085 2.71343 164.083 3.64561V178.474C164.085 179.406 164.456 180.3 165.115 180.959C165.774 181.618 166.668 181.989 167.6 181.991H291.976C292.908 181.989 293.801 181.618 294.461 180.959C295.12 180.3 295.491 179.406 295.493 178.474V3.64561C295.491 2.71343 295.12 1.8199 294.461 1.16075C293.801 0.501588 292.908 0.130523 291.976 0.128821H167.6Z" fill="#E0E0E0" />
      <path d="M151.399 40.6484H74.3906V210.955H151.399V40.6484Z" fill="#E6E6E6" />
      <path d="M151.396 40.6484H78.0391V210.955H151.396V40.6484Z" fill="#F0F0F0" />
      <path d="M147.531 207.093V44.5156L81.9037 44.5156L81.9037 207.093H147.531Z" fill="#EBEBEB" />
      <path d="M147.531 207.101V44.5234H146.526V207.101H147.531Z" fill="#E6E6E6" />
      <path d="M138.768 122.059C140.586 122.059 142.059 120.586 142.059 118.768C142.059 116.95 140.586 115.477 138.768 115.477C136.95 115.477 135.477 116.95 135.477 118.768C135.477 120.586 136.95 122.059 138.768 122.059Z" fill="#E6E6E6" />
      <path d="M140.057 121.372C141.875 121.372 143.348 119.898 143.348 118.08C143.348 116.263 141.875 114.789 140.057 114.789C138.239 114.789 136.766 116.263 136.766 118.08C136.766 119.898 138.239 121.372 140.057 121.372Z" fill="#FAFAFA" />
      <path d="M272.623 19.6875H185.219V150.505H272.623V19.6875Z" fill="#E0E0E0" />
      <path d="M274.561 19.6875H187.156V150.505H274.561V19.6875Z" fill="#F0F0F0" />
      <path d="M271.078 146.586V23.6016L190.649 23.6016V146.586H271.078Z" fill="#FAFAFA" />
      <path d="M271.078 146.586V23.6016H269.61V146.586H271.078Z" fill="#E0E0E0" />
      <path d="M273.121 61.9453H188.602V67.2012H273.121V61.9453Z" fill="#F0F0F0" />
      <path d="M278.361 13.2031H181.417C181.276 13.2031 181.14 13.2595 181.039 13.3597C180.939 13.46 180.883 13.5959 180.883 13.7377C180.883 13.8801 180.939 14.0168 181.039 14.118C181.139 14.2193 181.275 14.2771 181.417 14.2788H278.361C278.504 14.2771 278.641 14.2196 278.742 14.1185C278.843 14.0174 278.901 13.8807 278.902 13.7377C278.901 13.5954 278.843 13.4594 278.741 13.3593C278.64 13.2592 278.504 13.2031 278.361 13.2031Z" fill="#E0E0E0" />
      <path d="M281.583 13.742C281.584 14.2735 281.428 14.7934 281.133 15.2359C280.839 15.6785 280.42 16.0237 279.929 16.228C279.438 16.4323 278.898 16.4864 278.377 16.3835C277.855 16.2806 277.376 16.0253 277 15.6499C276.624 15.2745 276.367 14.796 276.263 14.2748C276.159 13.7536 276.212 13.2132 276.415 12.722C276.618 12.2309 276.962 11.811 277.404 11.5156C277.846 11.2202 278.365 11.0625 278.897 11.0625C279.608 11.0625 280.29 11.3446 280.794 11.8469C281.297 12.3492 281.581 13.0307 281.583 13.742Z" fill="#E0E0E0" />
      <path d="M185.94 16.7501C185.748 16.7484 185.565 16.671 185.43 16.5347C185.295 16.3984 185.219 16.2142 185.219 16.0223V14.47C185.219 14.2781 185.295 14.0939 185.43 13.9576C185.565 13.8213 185.748 13.7439 185.94 13.7422C186.133 13.7439 186.317 13.8211 186.453 13.9572C186.589 14.0934 186.666 14.2775 186.668 14.47V16.0223C186.666 16.2148 186.589 16.399 186.453 16.5351C186.317 16.6712 186.133 16.7485 185.94 16.7501Z" fill="#E0E0E0" />
      <path d="M270.275 16.7501C270.082 16.7485 269.898 16.6712 269.762 16.5351C269.626 16.399 269.549 16.2148 269.547 16.0223V14.47C269.549 14.2775 269.626 14.0934 269.762 13.9572C269.898 13.8211 270.082 13.7439 270.275 13.7422C270.467 13.7439 270.65 13.8213 270.785 13.9576C270.92 14.0939 270.996 14.2781 270.996 14.47V16.0223C270.996 16.2142 270.92 16.3984 270.785 16.5347C270.65 16.671 270.467 16.7484 270.275 16.7501Z" fill="#E0E0E0" />
      <path opacity="0.4" d="M278.196 13.7422H188.602V51.3126H278.196V13.7422Z" fill="#E0E0E0" />
      <path d="M197.255 13.742C197.256 14.2735 197.099 14.7934 196.805 15.2359C196.511 15.6785 196.092 16.0237 195.601 16.228C195.11 16.4323 194.57 16.4864 194.049 16.3835C193.527 16.2806 193.048 16.0253 192.672 15.6499C192.296 15.2745 192.039 14.796 191.935 14.2748C191.831 13.7536 191.884 13.2132 192.087 12.722C192.29 12.2309 192.634 11.811 193.076 11.5156C193.518 11.2202 194.037 11.0625 194.569 11.0625C195.28 11.0625 195.962 11.3446 196.466 11.8469C196.969 12.3492 197.253 13.0307 197.255 13.742Z" fill="#E0E0E0" />
      <path d="M198.874 170.203H181.625V208.456H198.874V170.203Z" fill="#E6E6E6" />
      <path d="M270.017 208.453H184.938V210.875H270.017V208.453Z" fill="#E6E6E6" />
      <path d="M198.876 208.453H273.328V170.2H198.876V208.453Z" fill="#F0F0F0" />
      <path d="M205.652 187.461H266.539V174.914H205.652V187.461Z" fill="#E6E6E6" />
      <path d="M205.652 203.742H266.539V191.195H205.652V203.742Z" fill="#E6E6E6" />
      <path d="M243.862 180.32H228.346C227.926 180.32 227.586 180.661 227.586 181.08V181.28C227.586 181.7 227.926 182.04 228.346 182.04H243.862C244.282 182.04 244.622 181.7 244.622 181.28V181.08C244.622 180.661 244.282 180.32 243.862 180.32Z" fill="#F0F0F0" />
      <path d="M243.862 196.609H228.346C227.926 196.609 227.586 196.95 227.586 197.369V197.569C227.586 197.989 227.926 198.329 228.346 198.329H243.862C244.282 198.329 244.622 197.989 244.622 197.569V197.369C244.622 196.95 244.282 196.609 243.862 196.609Z" fill="#F0F0F0" />
      <path d="M220.363 164.561C222.461 164.561 224.163 162.86 224.163 160.761C224.163 158.662 222.461 156.961 220.363 156.961C218.264 156.961 216.562 158.662 216.562 160.761C216.562 162.86 218.264 164.561 220.363 164.561Z" fill="#F0F0F0" />
      <path d="M226.339 163.85C228.438 163.85 230.139 162.149 230.139 160.05C230.139 157.951 228.438 156.25 226.339 156.25C224.24 156.25 222.539 157.951 222.539 160.05C222.539 162.149 224.24 163.85 226.339 163.85Z" fill="#F0F0F0" />
      <path d="M248.53 161.808C248.53 162.56 248.307 163.294 247.89 163.919C247.472 164.544 246.879 165.031 246.184 165.319C245.49 165.607 244.726 165.682 243.989 165.535C243.251 165.389 242.574 165.027 242.043 164.495C241.511 163.964 241.149 163.287 241.003 162.549C240.856 161.812 240.931 161.048 241.219 160.354C241.507 159.659 241.994 159.066 242.619 158.648C243.244 158.231 243.978 158.008 244.73 158.008C245.738 158.008 246.704 158.408 247.417 159.121C248.13 159.834 248.53 160.8 248.53 161.808Z" fill="#F0F0F0" />
      <path d="M238.715 163.558C238.716 164.311 238.494 165.048 238.076 165.675C237.658 166.302 237.064 166.791 236.368 167.08C235.672 167.369 234.906 167.445 234.167 167.298C233.428 167.152 232.749 166.789 232.216 166.256C231.684 165.723 231.321 165.045 231.174 164.306C231.028 163.566 231.104 162.801 231.393 162.105C231.681 161.409 232.17 160.814 232.797 160.397C233.424 159.979 234.161 159.757 234.915 159.758C235.923 159.758 236.889 160.158 237.602 160.871C238.314 161.584 238.715 162.55 238.715 163.558Z" fill="#F0F0F0" />
      <path d="M209.336 161.453C209.336 161.453 209.98 170.2 233.554 170.2C257.128 170.2 257.772 161.453 257.772 161.453H209.336Z" fill="#E6E6E6" />
      <path d="M39.8045 156.727H28.0625V207.649H39.8045V156.727Z" fill="#E6E6E6" />
      <path d="M88.225 207.648H30.3203V210.875H88.225V207.648Z" fill="#E6E6E6" />
      <path d="M39.7973 207.648H90.4688V156.726H39.7973L39.7973 207.648Z" fill="#F0F0F0" />
      <path d="M44.4243 179.703H85.8594V163.002H44.4243V179.703Z" fill="#E6E6E6" />
      <path d="M44.4243 201.383H85.8594V184.681H44.4243V201.383Z" fill="#E6E6E6" />
      <path d="M69.7912 172.5H60.4904C60.3382 172.5 60.1875 172.47 60.0472 172.411C59.9068 172.352 59.7795 172.266 59.6728 172.157C59.5661 172.049 59.482 171.92 59.4256 171.779C59.3691 171.637 59.3413 171.486 59.3439 171.334C59.3439 171.03 59.4647 170.738 59.6797 170.523C59.8947 170.308 60.1863 170.187 60.4904 170.188H69.7912C70.0953 170.188 70.3869 170.308 70.6019 170.523C70.817 170.738 70.9377 171.03 70.9377 171.334C70.9403 171.486 70.9125 171.637 70.8561 171.779C70.7996 171.92 70.7156 172.049 70.6089 172.157C70.5021 172.266 70.3749 172.352 70.2345 172.411C70.0941 172.47 69.9434 172.5 69.7912 172.5Z" fill="#F0F0F0" />
      <path d="M69.7911 194.177H60.4903C60.1862 194.177 59.8946 194.056 59.6796 193.841C59.4645 193.626 59.3438 193.335 59.3438 193.031C59.3455 192.728 59.467 192.438 59.6818 192.224C59.8966 192.011 60.1873 191.891 60.4903 191.891H69.7911C70.094 191.891 70.3847 192.011 70.5995 192.224C70.8143 192.438 70.9359 192.728 70.9376 193.031C70.9376 193.335 70.8168 193.626 70.6018 193.841C70.3868 194.056 70.0951 194.177 69.7911 194.177Z" fill="#F0F0F0" />
      <path d="M62.7092 146.937C62.7092 146.937 53.0477 130.249 66.4643 116.961C66.4643 116.961 69.9683 119.241 69.9167 122.313C69.8652 125.386 66.1616 126.178 66.9539 128.754C67.7461 131.331 71.2436 133.836 68.9506 135.955C66.6576 138.075 69.3177 139.962 69.1631 142.558C69.0085 145.153 62.7092 146.937 62.7092 146.937Z" fill="#F0F0F0" />
      <path d="M48.6094 144.281C48.6094 144.281 48.9314 156.732 61.2789 156.732C73.6263 156.732 73.9419 144.281 73.9419 144.281H48.6094Z" fill="#E6E6E6" />
      <path d="M63.4476 148.468C63.4476 148.468 67.3766 129.576 50.4368 121.203C50.4368 121.203 47.8603 124.475 48.8523 127.374C49.8442 130.272 53.625 129.841 53.683 132.526C53.741 135.212 51.2097 138.697 54.0566 139.985C56.9035 141.273 54.9712 143.908 55.9374 146.323C56.9035 148.738 63.4476 148.468 63.4476 148.468Z" fill="#E6E6E6" />
      <path d="M57.6029 55.3203H38.2734V103.944H57.6029V55.3203Z" fill="#E0E0E0" />
      <path d="M61.5146 55.3203H41V103.944H61.5146V55.3203Z" fill="#F0F0F0" />
      <path d="M58.3906 100.821V58.4453H44.1238V100.821H58.3906Z" fill="#FAFAFA" />
      <path d="M161.025 239.965C229.997 239.965 285.91 236.701 285.91 232.674C285.91 228.647 229.997 225.383 161.025 225.383C92.0535 225.383 36.1406 228.647 36.1406 232.674C36.1406 236.701 92.0535 239.965 161.025 239.965Z" fill="#F5F5F5" />
      <path d="M236.169 90.4213C236.066 92.2312 235.847 93.893 235.602 95.6192C235.357 97.3454 235.003 99.02 234.63 100.708C233.863 104.151 232.725 107.5 231.235 110.698C230.709 111.703 229.986 112.592 229.11 113.313C228.39 113.925 227.623 114.481 226.817 114.974C225.312 115.896 223.743 116.708 222.121 117.403C218.973 118.752 215.726 119.857 212.408 120.707L211.609 118.317C213.091 117.673 214.611 116.958 216.079 116.23C217.548 115.503 219.017 114.768 220.421 113.97C221.809 113.209 223.149 112.363 224.433 111.438C225.025 111.014 225.585 110.547 226.108 110.041C226.508 109.674 226.838 109.238 227.081 108.752C227.669 107.312 228.174 105.839 228.594 104.34C229.007 102.801 229.387 101.249 229.709 99.6706C230.031 98.0925 230.288 96.4952 230.52 94.8914C230.752 93.2875 230.939 91.6708 231.081 90.125L236.169 90.4213Z" fill="#E58A7B" />
      <path d="M232.694 84.374C230.639 84.8958 229.203 93.3528 229.203 93.3528L234.865 97.2174C234.865 97.2174 240.295 88.6895 238.729 86.4352C237.068 84.0327 235.696 83.5818 232.694 84.374Z" fill="#A7C2FF" />
      <path opacity="0.5" d="M232.694 84.374C230.639 84.8958 229.203 93.3528 229.203 93.3528L234.865 97.2174C234.865 97.2174 240.295 88.6895 238.729 86.4352C237.068 84.0327 235.696 83.5818 232.694 84.374Z" fill="black" />
      <path d="M232.883 86.2344L231.305 94.7558L234.487 96.9136L232.883 86.2344Z" fill="#A7C2FF" />
      <path opacity="0.7" d="M232.883 86.2344L231.305 94.7558L234.487 96.9136L232.883 86.2344Z" fill="black" />
      <path d="M212.773 118.191L209.237 114.609L208.773 119.659C208.773 119.659 211.421 121.45 213.282 120.49L212.773 118.191Z" fill="#E58A7B" />
      <path d="M205.075 114.07L204.914 118.315L208.772 119.655L209.236 114.605L205.075 114.07Z" fill="#E58A7B" />
      <path d="M243.812 226.644H238.827L238.492 215.102H243.478L243.812 226.644Z" fill="#E58A7B" />
      <path d="M287.8 203.496L284 206.723L275.305 198.961L279.105 195.734L287.8 203.496Z" fill="#E58A7B" />
      <path d="M282.967 206.338L286.632 202.119C286.693 202.045 286.78 201.995 286.875 201.981C286.97 201.967 287.067 201.988 287.147 202.042L290.903 204.477C290.995 204.541 291.073 204.624 291.131 204.721C291.189 204.818 291.226 204.926 291.239 205.038C291.253 205.15 291.242 205.263 291.209 205.371C291.175 205.478 291.119 205.578 291.044 205.662C289.756 207.111 289.028 207.742 287.412 209.597C286.413 210.737 285.074 212.509 283.702 214.106C282.33 215.703 280.694 214.402 281.125 213.623C283.057 210.132 282.594 208.902 282.626 207.182C282.633 206.869 282.755 206.569 282.967 206.338Z" fill="#263238" />
      <path d="M238.657 226.078H244.261C244.357 226.077 244.451 226.111 244.524 226.174C244.598 226.237 244.646 226.324 244.66 226.42L245.304 230.851C245.316 230.963 245.304 231.076 245.269 231.182C245.234 231.289 245.177 231.387 245.102 231.471C245.027 231.554 244.934 231.62 244.832 231.666C244.729 231.711 244.618 231.734 244.505 231.733C242.573 231.733 241.607 231.585 239.146 231.585C237.633 231.585 234.496 231.746 232.409 231.746C230.322 231.746 230.2 229.672 231.076 229.485C234.979 228.648 236.519 227.489 237.833 226.381C238.065 226.19 238.356 226.083 238.657 226.078Z" fill="#263238" />
      <path d="M238.492 215.109L238.666 221.061H243.651L243.484 215.109H238.492Z" fill="#CF6F64" />
      <path d="M279.113 195.734L275.312 198.961L279.795 202.961L283.596 199.734L279.113 195.734Z" fill="#CF6F64" />
      <path d="M232.7 84.3769C232.7 84.3769 230.33 85.2143 235.084 114.463H255.328C254.986 106.225 254.98 101.143 258.915 84.2288C256.083 83.6403 253.211 83.2592 250.323 83.0887C247.261 82.8663 244.187 82.8663 241.125 83.0887C237.177 83.4365 232.7 84.3769 232.7 84.3769Z" fill="#A7C2FF" />
      <path opacity="0.5" d="M232.7 84.3769C232.7 84.3769 230.33 85.2143 235.084 114.463H255.328C254.986 106.225 254.98 101.143 258.915 84.2288C256.083 83.6403 253.211 83.2592 250.323 83.0887C247.261 82.8663 244.187 82.8663 241.125 83.0887C237.177 83.4365 232.7 84.3769 232.7 84.3769Z" fill="black" />
      <path d="M244.117 85.1864L245.946 88.9222C245.946 88.9222 253.618 86.5776 252.613 83.2025L250.036 82.9062L244.117 85.1864Z" fill="#A7C2FF" />
      <path opacity="0.6" d="M244.117 85.1864L245.946 88.9222C245.946 88.9222 253.618 86.5776 252.613 83.2025L250.036 82.9062L244.117 85.1864Z" fill="#FAFAFA" />
      <path d="M243.979 84.8386L241.402 88.6516C241.402 88.6516 235.94 86.2813 239.708 83.093L241.312 82.9062L243.979 84.8386Z" fill="#A7C2FF" />
      <path opacity="0.6" d="M243.979 84.8386L241.402 88.6516C241.402 88.6516 235.94 86.2813 239.708 83.093L241.312 82.9062L243.979 84.8386Z" fill="#FAFAFA" />
      <path d="M252.203 57.3216C254.567 55.0479 252.3 44.3622 258.522 47.8984C266.431 52.4071 271.539 46.5071 268.898 44.2656C274.45 44.6585 273.909 50.9772 271.597 54.3716C265.729 63.009 253.891 54.7967 253.82 59.183C253.749 63.5693 252.203 57.3216 252.203 57.3216Z" fill="#263238" />
      <path d="M248.789 55.7794C251.501 53.6345 260.763 55.4187 254.412 64.0561L248.789 55.7794Z" fill="#A7C2FF" />
      <path opacity="0.3" d="M248.789 55.7794C251.501 53.6345 260.763 55.4187 254.412 64.0561L248.789 55.7794Z" fill="black" />
      <path d="M250.221 59.7969C258.117 60.9756 258.671 73.8061 246.414 75.7964L250.221 59.7969Z" fill="#263238" />
      <path d="M249.408 72.7188C248.829 75.6752 248.249 81.0921 250.323 83.0695C250.323 83.0695 249.512 86.0645 244.017 86.0645C237.976 86.0645 241.125 83.0695 241.125 83.0695C244.423 82.2772 244.346 79.849 243.766 77.5366L249.408 72.7188Z" fill="#E58A7B" />
      <path d="M247.109 74.7109L243.766 77.5579C243.912 78.0928 244.007 78.6407 244.049 79.1939C245.337 79.0071 247.044 77.6223 247.179 76.3083C247.253 75.776 247.229 75.2346 247.109 74.7109Z" fill="#CF6F64" />
      <path d="M236.945 69.2953C234.22 65.785 230.671 56.7289 241.292 55.8594L236.945 69.2953Z" fill="#263238" />
      <path d="M249.209 65.176C249.853 70.0841 250.24 72.1452 248.282 75.1081C245.338 79.5717 239.168 79.3076 237.068 74.6959C235.168 70.5479 234.421 63.2244 238.781 60.3646C239.74 59.7292 240.846 59.3496 241.994 59.2619C243.141 59.1741 244.292 59.3811 245.336 59.8631C246.381 60.3452 247.286 61.0864 247.963 62.0163C248.641 62.9461 249.07 64.0338 249.209 65.176Z" fill="#E58A7B" />
      <path d="M235.102 114.438C235.102 114.438 231.173 152.832 231.495 168.033C231.837 183.846 237.634 219.909 237.634 219.909H244.371C244.371 219.909 243.302 184.767 243.901 169.244C244.545 152.311 249.93 114.438 249.93 114.438H235.102Z" fill="#A7C2FF" />
      <path opacity="0.6" d="M235.102 114.438C235.102 114.438 231.173 152.832 231.495 168.033C231.837 183.846 237.634 219.909 237.634 219.909H244.371C244.371 219.909 243.302 184.767 243.901 169.244C244.545 152.311 249.93 114.438 249.93 114.438H235.102Z" fill="#FAFAFA" />
      <path d="M244.935 220.148H237.025L236.445 217.629L245.302 217.32L244.935 220.148Z" fill="#A7C2FF" />
      <path opacity="0.4" d="M244.935 220.148H237.025L236.445 217.629L245.302 217.32L244.935 220.148Z" fill="#FAFAFA" />
      <path d="M243.819 123.985C238.846 133.987 242.821 152.235 244.579 159.024C245.481 148.828 247.001 136.364 248.186 127.211C247.432 122.033 246.112 119.373 243.819 123.985Z" fill="#A7C2FF" />
      <path opacity="0.4" d="M243.819 123.985C238.846 133.987 242.821 152.235 244.579 159.024C245.481 148.828 247.001 136.364 248.186 127.211C247.432 122.033 246.112 119.373 243.819 123.985Z" fill="#FAFAFA" />
      <path d="M240.43 114.435C240.43 114.435 245.016 154.369 248.481 167.167C252.59 182.387 278.11 202.863 278.11 202.863L283.295 198.458C283.295 198.458 264.783 176.217 261.64 168.185C254.928 151.078 260.674 125.584 255.308 114.422L240.43 114.435Z" fill="#A7C2FF" />
      <path opacity="0.6" d="M240.43 114.435C240.43 114.435 245.016 154.369 248.481 167.167C252.59 182.387 278.11 202.863 278.11 202.863L283.295 198.458C283.295 198.458 264.783 176.217 261.64 168.185C254.928 151.078 260.674 125.584 255.308 114.422L240.43 114.435Z" fill="#FAFAFA" />
      <path d="M284.137 198.228L277.709 203.684L275.312 202.247L282.578 195.484L284.137 198.228Z" fill="#A7C2FF" />
      <path opacity="0.4" d="M284.137 198.228L277.709 203.684L275.312 202.247L282.578 195.484L284.137 198.228Z" fill="#FAFAFA" />
      <path d="M242.119 67.9781C242.196 68.371 242.048 68.7317 241.79 68.7832C241.532 68.8347 241.262 68.5513 241.185 68.1391C241.107 67.7269 241.255 67.3855 241.513 67.334C241.771 67.2824 242.041 67.5787 242.119 67.9781Z" fill="#263238" />
      <path d="M237.674 68.8531C237.751 69.246 237.603 69.6067 237.345 69.6582C237.088 69.7097 236.817 69.4263 236.74 69.0141C236.663 68.6019 236.804 68.2605 237.062 68.209C237.32 68.1574 237.584 68.4537 237.674 68.8531Z" fill="#263238" />
      <path d="M237.177 68.223L236.172 68.1328C236.172 68.1328 236.803 68.7769 237.177 68.223Z" fill="#263238" />
      <path d="M238.963 69.2969C238.789 70.2657 238.483 71.2061 238.055 72.0923C238.283 72.1974 238.531 72.2519 238.783 72.2519C239.034 72.2519 239.282 72.1974 239.51 72.0923L238.963 69.2969Z" fill="#DF5753" />
      <path d="M241.194 73.3595C241.163 73.3595 241.134 73.3473 241.112 73.3256C241.09 73.3038 241.078 73.2743 241.078 73.2436C241.078 73.2128 241.09 73.1833 241.112 73.1616C241.134 73.1399 241.163 73.1276 241.194 73.1276C241.687 73.0415 242.153 72.8404 242.554 72.5404C242.954 72.2405 243.278 71.8503 243.5 71.4015C243.506 71.3871 243.515 71.374 243.526 71.363C243.537 71.352 243.55 71.3432 243.564 71.3372C243.578 71.3313 243.594 71.3282 243.609 71.3281C243.625 71.3281 243.64 71.3311 243.655 71.337C243.669 71.343 243.682 71.3517 243.693 71.3626C243.704 71.3736 243.713 71.3866 243.719 71.401C243.725 71.4153 243.728 71.4307 243.728 71.4463C243.728 71.4618 243.725 71.4772 243.719 71.4916C243.486 71.979 243.139 72.4032 242.707 72.7283C242.275 73.0534 241.772 73.2699 241.239 73.3595H241.194Z" fill="#263238" />
      <path d="M237.029 62.0974C237.029 62.0974 241.223 68.4547 248.952 69.292C248.952 69.292 256.932 62.0458 252.024 57.0218C244.076 48.8933 234.595 59.2504 237.029 62.0974Z" fill="#263238" />
      <path d="M250.886 68.9646C250.875 69.4378 250.771 69.9041 250.578 70.3364C250.386 70.7688 250.11 71.1586 249.765 71.4831C248.838 72.3526 247.794 71.6634 247.562 70.4847C247.356 69.4219 247.562 67.6958 248.754 67.2642C249.011 67.1778 249.286 67.1573 249.553 67.2044C249.82 67.2515 250.071 67.3648 250.283 67.5339C250.495 67.703 250.661 67.9225 250.767 68.1725C250.872 68.4224 250.913 68.6948 250.886 68.9646Z" fill="#E58A7B" />
      <path d="M243.141 66.2727C243.083 66.2733 243.025 66.2528 242.98 66.2147C242.765 66.0114 242.504 65.8617 242.22 65.7778C241.936 65.6938 241.636 65.678 241.344 65.7316C241.314 65.7403 241.283 65.7429 241.252 65.7391C241.221 65.7354 241.191 65.7254 241.164 65.7097C241.137 65.6941 241.113 65.6731 241.094 65.6481C241.076 65.6231 241.062 65.5945 241.055 65.5642C241.039 65.5035 241.047 65.4391 241.079 65.3849C241.11 65.3306 241.162 65.2909 241.222 65.2743C241.589 65.199 241.97 65.2129 242.33 65.3149C242.691 65.4169 243.022 65.604 243.296 65.8604C243.34 65.905 243.365 65.9652 243.365 66.0279C243.365 66.0906 243.34 66.1508 243.296 66.1954C243.256 66.2401 243.201 66.2678 243.141 66.2727Z" fill="#263238" />
      <path d="M235.192 67.1987C235.162 67.2053 235.131 67.2053 235.101 67.1987C235.072 67.1874 235.046 67.1703 235.023 67.1484C235.001 67.1266 234.983 67.1005 234.971 67.0716C234.959 67.0427 234.953 67.0117 234.953 66.9804C234.953 66.9491 234.96 66.9182 234.973 66.8895C235.108 66.54 235.326 66.2282 235.607 65.9805C235.889 65.7327 236.225 65.5563 236.589 65.466C236.619 65.4595 236.65 65.4593 236.681 65.4652C236.711 65.4712 236.74 65.4834 236.765 65.5009C236.79 65.5184 236.812 65.5409 236.828 65.567C236.844 65.5931 236.855 65.6223 236.86 65.6528C236.866 65.6833 236.867 65.7148 236.861 65.7454C236.855 65.776 236.843 65.8052 236.825 65.831C236.808 65.8569 236.785 65.8789 236.759 65.8959C236.733 65.9129 236.704 65.9244 236.673 65.9298C236.383 66.0041 236.115 66.1463 235.891 66.3445C235.667 66.5427 235.494 66.7913 235.385 67.0698C235.367 67.1064 235.339 67.1376 235.305 67.1602C235.272 67.1828 235.232 67.1961 235.192 67.1987Z" fill="#263238" />
      <path d="M266.014 109.059V108.486C266.014 107.713 265.905 106.972 265.827 106.225C265.437 103.332 264.821 100.474 263.985 97.6778C263.176 94.9079 262.213 92.1855 261.1 89.5234L256.352 91.4557C257.312 93.942 258.22 96.5635 259.051 99.1399C259.451 100.428 259.831 101.716 260.159 103.004C260.488 104.293 260.803 105.581 261.029 106.869L261.164 107.726C260.719 107.578 260.262 107.417 259.798 107.223C257.364 106.231 254.877 104.943 252.423 103.707L251 105.787C253.184 107.684 255.538 109.374 258.034 110.837C258.704 111.225 259.399 111.569 260.114 111.867C260.515 112.041 260.928 112.186 261.351 112.299C261.602 112.37 261.858 112.424 262.117 112.46C262.461 112.504 262.81 112.504 263.154 112.46C263.722 112.41 264.266 112.205 264.726 111.867C265.298 111.442 265.702 110.828 265.866 110.135C265.963 109.784 266.013 109.423 266.014 109.059ZM262.549 108.099H262.665C262.736 108.093 262.645 108.106 262.517 108.099H262.549Z" fill="#E58A7B" />
      <path d="M258.936 84.197C260.965 84.8411 263.399 91.7974 263.399 91.7974L255.535 97.4268C255.535 97.4268 252.662 91.5977 253.519 88.9762C254.382 86.2452 256.604 83.4949 258.936 84.197Z" fill="#A7C2FF" />
      <path opacity="0.5" d="M258.936 84.197C260.965 84.8411 263.399 91.7974 263.399 91.7974L255.535 97.4268C255.535 97.4268 252.662 91.5977 253.519 88.9762C254.382 86.2452 256.604 83.4949 258.936 84.197Z" fill="black" />
      <path d="M281.598 208.734C281.496 208.731 281.395 208.705 281.304 208.659C281.212 208.612 281.133 208.545 281.07 208.464C281.021 208.412 280.987 208.349 280.971 208.28C280.955 208.21 280.958 208.138 280.98 208.071C281.16 207.459 282.912 206.963 283.086 206.911C283.109 206.905 283.134 206.905 283.156 206.911C283.179 206.918 283.2 206.932 283.215 206.95C283.226 206.97 283.232 206.992 283.232 207.014C283.232 207.037 283.226 207.059 283.215 207.079C282.906 207.665 282.288 208.657 281.663 208.734H281.598ZM282.887 207.221C282.197 207.44 281.309 207.82 281.212 208.142C281.202 208.171 281.201 208.202 281.209 208.232C281.217 208.262 281.234 208.289 281.257 208.309C281.301 208.373 281.361 208.424 281.431 208.456C281.502 208.489 281.579 208.503 281.656 208.496C281.985 208.457 282.436 207.987 282.88 207.221H282.887Z" fill="#A7C2FF" />
      <path d="M282.332 207.244C281.817 207.297 281.301 207.152 280.889 206.838C280.829 206.765 280.797 206.674 280.797 206.58C280.797 206.486 280.829 206.395 280.889 206.323C280.94 206.249 281.006 206.187 281.083 206.141C281.159 206.094 281.245 206.064 281.334 206.052C282.042 205.968 283.137 206.896 283.182 206.941C283.199 206.953 283.211 206.97 283.218 206.99C283.225 207.009 283.226 207.031 283.221 207.051C283.218 207.071 283.209 207.091 283.195 207.107C283.182 207.123 283.164 207.135 283.144 207.141C282.879 207.215 282.606 207.249 282.332 207.244ZM281.456 206.278H281.379C281.322 206.284 281.267 206.303 281.218 206.333C281.169 206.363 281.127 206.404 281.095 206.452C281.012 206.574 281.044 206.645 281.095 206.69C281.308 206.967 282.287 207.07 282.886 206.967C282.484 206.617 281.998 206.379 281.475 206.278H281.456Z" fill="#A7C2FF" />
      <path d="M236.789 226.943C236.362 226.982 235.934 226.873 235.578 226.634C235.498 226.563 235.437 226.474 235.4 226.374C235.362 226.274 235.351 226.166 235.366 226.061C235.37 225.995 235.39 225.932 235.425 225.877C235.46 225.822 235.508 225.776 235.565 225.745C236.177 225.417 238.142 226.428 238.386 226.544C238.408 226.555 238.426 226.573 238.438 226.595C238.449 226.617 238.454 226.642 238.451 226.666C238.448 226.69 238.438 226.712 238.422 226.73C238.406 226.747 238.384 226.759 238.361 226.763C237.844 226.874 237.318 226.935 236.789 226.943ZM235.9 225.912C235.825 225.908 235.749 225.923 235.681 225.958C235.658 225.969 235.639 225.986 235.625 226.008C235.611 226.029 235.604 226.054 235.604 226.08C235.591 226.15 235.597 226.221 235.621 226.288C235.645 226.355 235.685 226.414 235.739 226.46C236.042 226.73 236.86 226.782 237.968 226.595C237.322 226.252 236.623 226.021 235.9 225.912Z" fill="#A7C2FF" />
      <path d="M238.325 226.764H238.273C237.681 226.494 236.508 225.425 236.599 224.832C236.599 224.697 236.715 224.529 237.043 224.497C237.159 224.484 237.276 224.496 237.387 224.532C237.498 224.567 237.6 224.626 237.687 224.703C238.331 225.225 238.434 226.565 238.434 226.636C238.438 226.655 238.435 226.676 238.427 226.694C238.419 226.712 238.406 226.728 238.389 226.739C238.371 226.754 238.349 226.763 238.325 226.764ZM237.14 224.742H237.069C236.85 224.742 236.837 224.845 236.831 224.877C236.779 225.212 237.571 226.062 238.177 226.429C238.132 225.861 237.906 225.321 237.533 224.89C237.425 224.801 237.292 224.749 237.153 224.742H237.14Z" fill="#A7C2FF" />
      <path d="M253.138 104.285L251.463 99.1641L248.797 103.473C248.797 103.473 250.368 106.262 252.442 106.217L253.138 104.285Z" fill="#E58A7B" />
      <path d="M247.965 96.8281L245.93 100.557L248.777 103.469L251.443 99.1598L247.965 96.8281Z" fill="#E58A7B" />
      <path d="M241.631 67.348L240.633 67.2578C240.633 67.2578 241.264 67.9019 241.631 67.348Z" fill="#263238" />
      <path d="M255.625 113.245L256.146 115.062C256.217 115.197 256.05 115.345 255.812 115.345H234.981C234.795 115.345 234.646 115.255 234.633 115.139L234.453 113.361C234.453 113.232 234.595 113.129 234.794 113.129H255.296C255.356 113.12 255.418 113.126 255.475 113.146C255.532 113.166 255.584 113.2 255.625 113.245Z" fill="#263238" />
      <path d="M252.877 115.532H253.424C253.534 115.532 253.618 115.474 253.611 115.409L253.353 113.052C253.353 112.981 253.25 112.93 253.141 112.93H252.593C252.484 112.93 252.4 112.981 252.407 113.052L252.664 115.409C252.671 115.474 252.767 115.532 252.877 115.532Z" fill="#A7C2FF" />
      <path opacity="0.6" d="M252.877 115.532H253.424C253.534 115.532 253.618 115.474 253.611 115.409L253.353 113.052C253.353 112.981 253.25 112.93 253.141 112.93H252.593C252.484 112.93 252.4 112.981 252.407 113.052L252.664 115.409C252.671 115.474 252.767 115.532 252.877 115.532Z" fill="#FAFAFA" />
      <path d="M236.525 115.532H237.073C237.182 115.532 237.266 115.474 237.26 115.409L237.002 113.052C237.002 112.981 236.899 112.93 236.789 112.93H236.242C236.132 112.93 236.049 112.981 236.055 113.052L236.313 115.409C236.319 115.474 236.39 115.532 236.525 115.532Z" fill="#A7C2FF" />
      <path opacity="0.6" d="M236.525 115.532H237.073C237.182 115.532 237.266 115.474 237.26 115.409L237.002 113.052C237.002 112.981 236.899 112.93 236.789 112.93H236.242C236.132 112.93 236.049 112.981 236.055 113.052L236.313 115.409C236.319 115.474 236.39 115.532 236.525 115.532Z" fill="#FAFAFA" />
      <path d="M244.697 115.532H245.251C245.361 115.532 245.444 115.474 245.431 115.409L245.174 113.052C245.174 112.981 245.071 112.93 244.961 112.93H244.414C244.304 112.93 244.22 112.981 244.227 113.052L244.485 115.409C244.502 115.45 244.532 115.484 244.571 115.506C244.609 115.528 244.653 115.537 244.697 115.532Z" fill="#A7C2FF" />
      <path opacity="0.6" d="M244.697 115.532H245.251C245.361 115.532 245.444 115.474 245.431 115.409L245.174 113.052C245.174 112.981 245.071 112.93 244.961 112.93H244.414C244.304 112.93 244.22 112.981 244.227 113.052L244.485 115.409C244.502 115.45 244.532 115.484 244.571 115.506C244.609 115.528 244.653 115.537 244.697 115.532Z" fill="#FAFAFA" />
      <path d="M180.095 232.673H222.702C223.696 232.684 224.681 232.488 225.594 232.096C226.508 231.705 227.33 231.126 228.006 230.399C228.683 229.671 229.2 228.81 229.525 227.87C229.849 226.931 229.974 225.934 229.89 224.943L219.7 79.2219C219.524 77.1382 218.58 75.1942 217.052 73.7663C215.524 72.3384 213.521 71.5283 211.43 71.4927H168.823C167.829 71.4811 166.844 71.6774 165.93 72.069C165.017 72.4606 164.195 73.0388 163.518 73.7666C162.841 74.4944 162.324 75.3557 162 76.2952C161.675 77.2346 161.551 78.2315 161.635 79.2219L171.824 224.95C172.003 227.032 172.947 228.975 174.475 230.401C176.002 231.828 178.005 232.637 180.095 232.673Z" fill="#A7C2FF" />
      <path opacity="0.2" d="M180.095 232.673H222.702C223.696 232.684 224.681 232.488 225.594 232.096C226.508 231.705 227.33 231.126 228.006 230.399C228.683 229.671 229.2 228.81 229.525 227.87C229.849 226.931 229.974 225.934 229.89 224.943L219.7 79.2219C219.524 77.1382 218.58 75.1942 217.052 73.7663C215.524 72.3384 213.521 71.5283 211.43 71.4927H168.823C167.829 71.4811 166.844 71.6774 165.93 72.069C165.017 72.4606 164.195 73.0388 163.518 73.7666C162.841 74.4944 162.324 75.3557 162 76.2952C161.675 77.2346 161.551 78.2315 161.635 79.2219L171.824 224.95C172.003 227.032 172.947 228.975 174.475 230.401C176.002 231.828 178.005 232.637 180.095 232.673Z" fill="black" />
      <path d="M157.588 124.158L156.945 124.203L157.655 134.355L158.298 134.31L157.588 124.158Z" fill="#A7C2FF" />
      <path opacity="0.5" d="M157.588 124.158L156.945 124.203L157.655 134.355L158.298 134.31L157.588 124.158Z" fill="black" />
      <path d="M174.516 232.673H217.117C218.111 232.684 219.096 232.488 220.01 232.096C220.923 231.705 221.745 231.126 222.422 230.399C223.099 229.671 223.616 228.81 223.94 227.87C224.265 226.931 224.389 225.934 224.305 224.943L214.116 79.2219C213.939 77.1382 212.995 75.1942 211.468 73.7663C209.94 72.3384 207.936 71.5283 205.846 71.4927H163.245C162.251 71.4811 161.266 71.6774 160.352 72.069C159.439 72.4606 158.617 73.0388 157.94 73.7666C157.263 74.4944 156.746 75.3557 156.422 76.2952C156.097 77.2346 155.973 78.2315 156.056 79.2219L166.246 224.943C166.423 227.027 167.367 228.971 168.894 230.399C170.422 231.827 172.426 232.637 174.516 232.673Z" fill="#A7C2FF" />
      <path opacity="0.5" d="M174.516 232.673H217.117C218.111 232.684 219.096 232.488 220.01 232.096C220.923 231.705 221.745 231.126 222.422 230.399C223.099 229.671 223.616 228.81 223.94 227.87C224.265 226.931 224.389 225.934 224.305 224.943L214.116 79.2219C213.939 77.1382 212.995 75.1942 211.468 73.7663C209.94 72.3384 207.936 71.5283 205.846 71.4927H163.245C162.251 71.4811 161.266 71.6774 160.352 72.069C159.439 72.4606 158.617 73.0388 157.94 73.7666C157.263 74.4944 156.746 75.3557 156.422 76.2952C156.097 77.2346 155.973 78.2315 156.056 79.2219L166.246 224.943C166.423 227.027 167.367 228.971 168.894 230.399C170.422 231.827 172.426 232.637 174.516 232.673Z" fill="black" />
      <path d="M182.424 117.903H190.308C190.494 117.911 190.679 117.878 190.85 117.808C191.022 117.737 191.177 117.63 191.303 117.495C191.43 117.359 191.526 117.197 191.584 117.021C191.643 116.845 191.662 116.658 191.641 116.473L189.754 89.4854C189.722 89.0992 189.547 88.7387 189.264 88.4743C188.981 88.2099 188.609 88.0606 188.221 88.0555H180.35C180.165 88.0488 179.981 88.0821 179.81 88.153C179.639 88.224 179.485 88.331 179.36 88.4667C179.234 88.6024 179.138 88.7636 179.08 88.9394C179.022 89.1152 179.003 89.3015 179.024 89.4854L180.911 116.473C180.942 116.856 181.114 117.214 181.394 117.478C181.673 117.742 182.04 117.893 182.424 117.903Z" fill="#A7C2FF" />
      <path opacity="0.2" d="M182.424 117.903H190.308C190.494 117.911 190.679 117.878 190.85 117.808C191.022 117.737 191.177 117.63 191.303 117.495C191.43 117.359 191.526 117.197 191.584 117.021C191.643 116.845 191.662 116.658 191.641 116.473L189.754 89.4854C189.722 89.0992 189.547 88.7387 189.264 88.4743C188.981 88.2099 188.609 88.0606 188.221 88.0555H180.35C180.165 88.0488 179.981 88.0821 179.81 88.153C179.639 88.224 179.485 88.331 179.36 88.4667C179.234 88.6024 179.138 88.7636 179.08 88.9394C179.022 89.1152 179.003 89.3015 179.024 89.4854L180.911 116.473C180.942 116.856 181.114 117.214 181.394 117.478C181.673 117.742 182.04 117.893 182.424 117.903Z" fill="black" />
      <path d="M134.141 232.673H91.5337C90.5399 232.684 89.5546 232.488 88.6411 232.096C87.7277 231.705 86.9061 231.126 86.2293 230.399C85.5524 229.671 85.0352 228.81 84.7108 227.87C84.3864 226.931 84.262 225.934 84.3456 224.943L94.5352 79.2219C94.7134 77.1387 95.6575 75.1955 97.185 73.7679C98.7125 72.3403 100.715 71.5297 102.806 71.4927H145.413C146.407 71.4811 147.392 71.6774 148.305 72.069C149.219 72.4606 150.04 73.0388 150.717 73.7666C151.394 74.4944 151.911 75.3557 152.236 76.2952C152.56 77.2346 152.685 78.2315 152.601 79.2219L142.411 224.943C142.235 227.027 141.291 228.971 139.763 230.399C138.235 231.827 136.232 232.637 134.141 232.673Z" fill="#A7C2FF" />
      <path opacity="0.5" d="M134.141 232.673H91.5337C90.5399 232.684 89.5546 232.488 88.6411 232.096C87.7277 231.705 86.9061 231.126 86.2293 230.399C85.5524 229.671 85.0352 228.81 84.7108 227.87C84.3864 226.931 84.262 225.934 84.3456 224.943L94.5352 79.2219C94.7134 77.1387 95.6575 75.1955 97.185 73.7679C98.7125 72.3403 100.715 71.5297 102.806 71.4927H145.413C146.407 71.4811 147.392 71.6774 148.305 72.069C149.219 72.4606 150.04 73.0388 150.717 73.7666C151.394 74.4944 151.911 75.3557 152.236 76.2952C152.56 77.2346 152.685 78.2315 152.601 79.2219L142.411 224.943C142.235 227.027 141.291 228.971 139.763 230.399C138.235 231.827 136.232 232.637 134.141 232.673Z" fill="black" />
      <path d="M116.215 69.2344H113.812V69.8785H116.215V69.2344Z" fill="#A7C2FF" />
      <path opacity="0.3" d="M116.215 69.2344H113.812V69.8785H116.215V69.2344Z" fill="black" />
      <path d="M109.508 69.2344H101.953V69.8785H109.508V69.2344Z" fill="#A7C2FF" />
      <path opacity="0.3" d="M109.508 69.2344H101.953V69.8785H109.508V69.2344Z" fill="black" />
      <path d="M128.549 232.673H85.9478C84.954 232.684 83.9687 232.488 83.0552 232.096C82.1417 231.705 81.3202 231.126 80.6433 230.399C79.9665 229.671 79.4493 228.81 79.1249 227.87C78.8005 226.931 78.6761 225.934 78.7596 224.943L88.9493 79.2219C89.1261 77.1382 90.0697 75.1942 91.5975 73.7663C93.1254 72.3384 95.1287 71.5283 97.2196 71.4927H139.82C140.814 71.4811 141.8 71.6774 142.713 72.069C143.627 72.4606 144.448 73.0388 145.125 73.7666C145.802 74.4944 146.319 75.3557 146.643 76.2952C146.968 77.2346 147.092 78.2315 147.009 79.2219L136.819 224.943C136.642 227.027 135.699 228.971 134.171 230.399C132.643 231.827 130.64 232.637 128.549 232.673Z" fill="#A7C2FF" />
      <path opacity="0.3" d="M128.549 232.673H85.9478C84.954 232.684 83.9687 232.488 83.0552 232.096C82.1417 231.705 81.3202 231.126 80.6433 230.399C79.9665 229.671 79.4493 228.81 79.1249 227.87C78.8005 226.931 78.6761 225.934 78.7596 224.943L88.9493 79.2219C89.1261 77.1382 90.0697 75.1942 91.5975 73.7663C93.1254 72.3384 95.1287 71.5283 97.2196 71.4927H139.82C140.814 71.4811 141.8 71.6774 142.713 72.069C143.627 72.4606 144.448 73.0388 145.125 73.7666C145.802 74.4944 146.319 75.3557 146.643 76.2952C146.968 77.2346 147.092 78.2315 147.009 79.2219L136.819 224.943C136.642 227.027 135.699 228.971 134.171 230.399C132.643 231.827 130.64 232.637 128.549 232.673Z" fill="black" />
      <path d="M134.943 224.285H78.8483C78.7139 224.285 78.5809 224.257 78.4577 224.203C78.3345 224.149 78.2236 224.07 78.1319 223.972C78.0402 223.873 77.9696 223.757 77.9244 223.631C77.8793 223.504 77.8605 223.37 77.8693 223.235L87.7949 81.2818C87.8128 81.0329 87.9245 80.8001 88.1074 80.6303C88.2903 80.4606 88.5308 80.3665 88.7804 80.3672H144.869C145.004 80.3669 145.137 80.3944 145.261 80.4479C145.385 80.5014 145.497 80.5798 145.589 80.6782C145.682 80.7767 145.753 80.893 145.799 81.0201C145.844 81.1472 145.863 81.2824 145.854 81.4171L135.909 223.371C135.893 223.617 135.785 223.848 135.605 224.017C135.426 224.187 135.19 224.283 134.943 224.285Z" fill="#A7C2FF" />
      <path opacity="0.9" d="M134.943 224.285H78.8483C78.7139 224.285 78.5809 224.257 78.4577 224.203C78.3345 224.149 78.2236 224.07 78.1319 223.972C78.0402 223.873 77.9696 223.757 77.9244 223.631C77.8793 223.504 77.8605 223.37 77.8693 223.235L87.7949 81.2818C87.8128 81.0329 87.9245 80.8001 88.1074 80.6303C88.2903 80.4606 88.5308 80.3665 88.7804 80.3672H144.869C145.004 80.3669 145.137 80.3944 145.261 80.4479C145.385 80.5014 145.497 80.5798 145.589 80.6782C145.682 80.7767 145.753 80.893 145.799 81.0201C145.844 81.1472 145.863 81.2824 145.854 81.4171L135.909 223.371C135.893 223.617 135.785 223.848 135.605 224.017C135.426 224.187 135.19 224.283 134.943 224.285Z" fill="#FAFAFA" />
      <path d="M133.578 94.8986H97.1672C96.1774 94.9158 95.2291 95.2993 94.5058 95.9751C93.7824 96.6508 93.3354 97.5708 93.251 98.5571L89.4573 152.79C89.4177 153.26 89.4767 153.732 89.6306 154.177C89.7844 154.622 90.0297 155.03 90.3506 155.374C90.6715 155.719 91.0609 155.993 91.4939 156.178C91.9268 156.363 92.3937 156.455 92.8645 156.449H95.3894L94.1012 160.423C97.0803 160.155 99.8349 158.728 101.772 156.449H129.276C130.265 156.432 131.214 156.048 131.937 155.373C132.66 154.697 133.107 153.777 133.192 152.79L136.986 98.5571C137.024 98.0882 136.964 97.6163 136.81 97.1717C136.656 96.7272 136.411 96.3197 136.09 95.9753C135.769 95.631 135.38 95.3574 134.948 95.172C134.515 94.9866 134.049 94.8935 133.578 94.8986Z" fill="#A7C2FF" />
      <path opacity="0.6" d="M133.578 94.8986H97.1672C96.1774 94.9158 95.2291 95.2993 94.5058 95.9751C93.7824 96.6508 93.3354 97.5708 93.251 98.5571L89.4573 152.79C89.4177 153.26 89.4767 153.732 89.6306 154.177C89.7844 154.622 90.0297 155.03 90.3506 155.374C90.6715 155.719 91.0609 155.993 91.4939 156.178C91.9268 156.363 92.3937 156.455 92.8645 156.449H95.3894L94.1012 160.423C97.0803 160.155 99.8349 158.728 101.772 156.449H129.276C130.265 156.432 131.214 156.048 131.937 155.373C132.66 154.697 133.107 153.777 133.192 152.79L136.986 98.5571C137.024 98.0882 136.964 97.6163 136.81 97.1717C136.656 96.7272 136.411 96.3197 136.09 95.9753C135.769 95.631 135.38 95.3574 134.948 95.172C134.515 94.9866 134.049 94.8935 133.578 94.8986Z" fill="#FAFAFA" />
      <path d="M92.1096 167.367H128.521C128.991 167.361 129.458 167.454 129.891 167.639C130.324 167.824 130.714 168.097 131.035 168.442C131.356 168.787 131.601 169.194 131.755 169.64C131.909 170.085 131.968 170.557 131.928 171.026L130.298 194.323C130.214 195.309 129.767 196.229 129.044 196.905C128.32 197.581 127.372 197.965 126.382 197.982H123.851L124.559 201.956C123.163 201.839 121.808 201.424 120.585 200.738C119.363 200.053 118.302 199.113 117.474 197.982H89.9583C89.4875 197.988 89.0206 197.895 88.5876 197.71C88.1547 197.525 87.7652 197.252 87.4443 196.907C87.1234 196.563 86.8782 196.155 86.7243 195.71C86.5705 195.265 86.5114 194.792 86.551 194.323L88.1806 171.026C88.2652 170.037 88.7141 169.116 89.4401 168.44C90.1662 167.764 91.1176 167.381 92.1096 167.367Z" fill="#A7C2FF" />
      <path opacity="0.6" d="M92.1096 167.367H128.521C128.991 167.361 129.458 167.454 129.891 167.639C130.324 167.824 130.714 168.097 131.035 168.442C131.356 168.787 131.601 169.194 131.755 169.64C131.909 170.085 131.968 170.557 131.928 171.026L130.298 194.323C130.214 195.309 129.767 196.229 129.044 196.905C128.32 197.581 127.372 197.965 126.382 197.982H123.851L124.559 201.956C123.163 201.839 121.808 201.424 120.585 200.738C119.363 200.053 118.302 199.113 117.474 197.982H89.9583C89.4875 197.988 89.0206 197.895 88.5876 197.71C88.1547 197.525 87.7652 197.252 87.4443 196.907C87.1234 196.563 86.8782 196.155 86.7243 195.71C86.5705 195.265 86.5114 194.792 86.551 194.323L88.1806 171.026C88.2652 170.037 88.7141 169.116 89.4401 168.44C90.1662 167.764 91.1176 167.381 92.1096 167.367Z" fill="#FAFAFA" />
      <path d="M124.989 75.569C124.963 75.8956 124.817 76.201 124.579 76.426C124.341 76.6509 124.028 76.7794 123.7 76.7864C123.544 76.7888 123.388 76.7583 123.244 76.6968C123.1 76.6353 122.97 76.5443 122.863 76.4296C122.756 76.3148 122.675 76.179 122.624 76.0307C122.573 75.8825 122.553 75.7252 122.567 75.569C122.595 75.2435 122.742 74.9397 122.979 74.7153C123.217 74.4909 123.528 74.3615 123.855 74.3517C124.012 74.3493 124.167 74.3798 124.311 74.4413C124.456 74.5028 124.585 74.5938 124.692 74.7085C124.799 74.8233 124.881 74.9591 124.932 75.1073C124.983 75.2556 125.002 75.4129 124.989 75.569Z" fill="#A7C2FF" />
      <path opacity="0.5" d="M124.989 75.569C124.963 75.8956 124.817 76.201 124.579 76.426C124.341 76.6509 124.028 76.7794 123.7 76.7864C123.544 76.7888 123.388 76.7583 123.244 76.6968C123.1 76.6353 122.97 76.5443 122.863 76.4296C122.756 76.3148 122.675 76.179 122.624 76.0307C122.573 75.8825 122.553 75.7252 122.567 75.569C122.595 75.2435 122.742 74.9397 122.979 74.7153C123.217 74.4909 123.528 74.3615 123.855 74.3517C124.012 74.3493 124.167 74.3798 124.311 74.4413C124.456 74.5028 124.585 74.5938 124.692 74.7085C124.799 74.8233 124.881 74.9591 124.932 75.1073C124.983 75.2556 125.002 75.4129 124.989 75.569Z" fill="black" />
      <path d="M118.719 76.7863H110.223C110.067 76.7877 109.912 76.7565 109.768 76.6947C109.624 76.6329 109.495 76.5418 109.388 76.4273C109.282 76.3128 109.2 76.1774 109.149 76.0296C109.097 75.8818 109.077 75.7249 109.09 75.569C109.116 75.2429 109.263 74.9383 109.501 74.7136C109.738 74.489 110.051 74.36 110.378 74.3516H118.873C119.03 74.3502 119.185 74.3814 119.329 74.4432C119.472 74.505 119.602 74.5961 119.708 74.7106C119.815 74.8251 119.897 74.9605 119.948 75.1083C120 75.2561 120.02 75.413 120.007 75.569C119.98 75.895 119.834 76.1996 119.596 76.4243C119.358 76.649 119.046 76.7779 118.719 76.7863Z" fill="#A7C2FF" />
      <path opacity="0.5" d="M118.719 76.7863H110.223C110.067 76.7877 109.912 76.7565 109.768 76.6947C109.624 76.6329 109.495 76.5418 109.388 76.4273C109.282 76.3128 109.2 76.1774 109.149 76.0296C109.097 75.8818 109.077 75.7249 109.09 75.569C109.116 75.2429 109.263 74.9383 109.501 74.7136C109.738 74.489 110.051 74.36 110.378 74.3516H118.873C119.03 74.3502 119.185 74.3814 119.329 74.4432C119.472 74.505 119.602 74.5961 119.708 74.7106C119.815 74.8251 119.897 74.9605 119.948 75.1083C120 75.2561 120.02 75.413 120.007 75.569C119.98 75.895 119.834 76.1996 119.596 76.4243C119.358 76.649 119.046 76.7779 118.719 76.7863Z" fill="black" />
      <path d="M73.3634 104.773L74.3747 106.751C74.7289 107.395 75.0896 108.097 75.4632 108.76C76.2104 110.094 76.9704 111.414 77.7691 112.696C79.2935 115.22 81.0395 117.604 82.9863 119.82C83.4694 120.303 83.9911 120.882 84.326 121.146C84.7941 121.524 85.2941 121.86 85.8204 122.151C87.0746 122.813 88.3799 123.373 89.7236 123.826C92.619 124.787 95.5675 125.581 98.5542 126.203L98.3481 129.752C94.9938 129.948 91.628 129.752 88.3195 129.166C86.5567 128.86 84.8301 128.375 83.1667 127.716C82.2411 127.347 81.3561 126.883 80.5258 126.332C80.0961 126.045 79.6871 125.729 79.302 125.385L78.2844 124.489C75.8266 122.105 73.6444 119.452 71.7789 116.58C70.845 115.182 69.9626 113.765 69.1574 112.309C68.7517 111.582 68.3523 110.847 67.9723 110.107C67.5923 109.366 67.2316 108.644 66.8516 107.807L73.3634 104.773Z" fill="#E58A7B" />
      <path d="M97.2638 126.202L100.13 124.18L101.644 130.028C101.644 130.028 99.1188 130.917 97.2188 129.635L97.2638 126.202Z" fill="#E58A7B" />
      <path d="M104.086 122.852L105.104 127.747L101.639 130.027L100.125 124.178L104.086 122.852Z" fill="#E58A7B" />
      <path d="M117.247 132.564L126.79 125.654C127.538 125.119 127.765 124.211 127.286 123.645L116.568 110.691C116.089 110.125 115.098 110.102 114.35 110.637L104.807 117.547C104.059 118.082 103.832 118.99 104.311 119.557L115.029 132.51C115.508 133.077 116.499 133.099 117.247 132.564Z" fill="#A7C2FF" />
      <path d="M91.7327 84.8035C91.6554 85.1771 91.7907 85.5185 92.0354 85.57C92.2802 85.6215 92.5443 85.3639 92.6215 84.9903C92.6988 84.6167 92.5636 84.2689 92.3188 84.2174C92.0741 84.1658 91.81 84.4299 91.7327 84.8035Z" fill="#263238" />
      <path d="M91.7577 85.5078C91.965 86.7424 92.3399 87.943 92.872 89.0761C92.58 89.2062 92.263 89.2702 91.9434 89.2635C91.6238 89.2568 91.3097 89.1796 91.0234 89.0375L91.7577 85.5078Z" fill="#DF5753" />
      <path d="M92.7515 82.5109C92.7079 82.5101 92.6654 82.4967 92.6292 82.4722C92.3819 82.3384 92.1065 82.2651 91.8255 82.2584C91.5444 82.2517 91.2658 82.3117 91.0125 82.4336C90.9586 82.4578 90.8974 82.4599 90.8419 82.4394C90.7865 82.4189 90.7414 82.3775 90.7162 82.3241C90.7035 82.2971 90.6964 82.2679 90.6954 82.2381C90.6944 82.2084 90.6995 82.1787 90.7104 82.151C90.7212 82.1232 90.7376 82.098 90.7586 82.0768C90.7795 82.0556 90.8045 82.039 90.8321 82.0278C91.1532 81.8749 91.5063 81.8015 91.8617 81.8138C92.2171 81.8262 92.5643 81.9238 92.8739 82.0986C92.8989 82.1143 92.9205 82.1349 92.9373 82.1591C92.9542 82.1833 92.966 82.2106 92.972 82.2395C92.978 82.2684 92.9781 82.2982 92.9723 82.3271C92.9665 82.356 92.955 82.3835 92.9383 82.4078C92.9186 82.4395 92.891 82.4656 92.8583 82.4836C92.8256 82.5017 92.7889 82.511 92.7515 82.5109Z" fill="#263238" />
      <path d="M78.4833 86C79.1274 89.4588 79.8359 95.8032 77.4141 98.1091C77.4141 98.1091 78.3609 101.626 84.7955 101.626C91.8806 101.626 88.1706 98.1091 88.1706 98.1091C84.306 97.188 84.4154 94.3282 85.0853 91.6681L78.4833 86Z" fill="#E58A7B" />
      <path d="M76.434 99.0984C75.9702 97.9647 76.0475 95.8779 76.3889 95.8457C77.7286 95.7555 84.8781 95.7362 87.242 96.6443C87.5546 96.7429 87.8445 96.9027 88.0948 97.1144C88.3452 97.326 88.5509 97.5853 88.7002 97.8772C88.8494 98.169 88.9391 98.4877 88.9641 98.8145C88.9891 99.1414 88.9489 99.4699 88.8458 99.7811L76.434 99.0984Z" fill="#A7C2FF" />
      <path d="M60.634 228.657C60.2183 228.655 59.8038 228.61 59.3974 228.522C59.3765 228.518 59.3573 228.508 59.3423 228.493C59.3273 228.478 59.3173 228.459 59.3136 228.438C59.3108 228.417 59.3134 228.395 59.3213 228.374C59.3291 228.354 59.342 228.336 59.3587 228.322C59.4167 228.284 60.7242 227.395 61.4134 227.549C61.4879 227.566 61.558 227.597 61.6191 227.643C61.6802 227.689 61.7308 227.747 61.7677 227.813C61.8237 227.891 61.8539 227.985 61.8539 228.081C61.8539 228.177 61.8237 228.27 61.7677 228.348C61.6089 228.472 61.4268 228.564 61.2321 228.617C61.0374 228.67 60.8341 228.684 60.634 228.657ZM59.713 228.361C60.4215 228.477 61.3876 228.477 61.5938 228.206C61.5938 228.206 61.671 228.103 61.5938 227.923C61.5729 227.884 61.5436 227.849 61.508 227.823C61.4723 227.796 61.4313 227.777 61.3876 227.768C60.7815 227.798 60.1983 228.009 59.713 228.374V228.361Z" fill="#A7C2FF" />
      <path d="M59.4229 228.538H59.3649C59.347 228.527 59.3326 228.512 59.3234 228.494C59.3142 228.475 59.3107 228.455 59.3134 228.434C59.3134 228.376 59.4293 227.011 59.9575 226.56C60.0243 226.505 60.1016 226.464 60.1846 226.44C60.2676 226.416 60.3546 226.408 60.4405 226.418C60.5246 226.42 60.6056 226.45 60.6701 226.504C60.7346 226.558 60.7786 226.632 60.7948 226.715C60.8914 227.243 59.9446 228.273 59.4615 228.544L59.4229 228.538ZM60.3761 226.605C60.2835 226.606 60.1944 226.641 60.1249 226.702C59.7902 227.126 59.5946 227.644 59.5646 228.183C60.0476 227.816 60.6531 227.037 60.5951 226.721C60.5951 226.721 60.5951 226.625 60.4277 226.605H60.3761Z" fill="#A7C2FF" />
      <path d="M53.9609 228.425H58.6951L63.0557 217.469H58.328L53.9609 228.425Z" fill="#E58A7B" />
      <path d="M59.0666 227.875H53.7528C53.6579 227.876 53.5661 227.909 53.4924 227.968C53.4187 228.028 53.3674 228.111 53.347 228.203L52.4131 232.409C52.3917 232.512 52.3938 232.618 52.419 232.719C52.4443 232.821 52.4921 232.915 52.559 232.996C52.6258 233.076 52.71 233.141 52.8052 233.184C52.9003 233.228 53.0041 233.249 53.1087 233.247C54.9637 233.215 55.8654 233.105 58.2035 233.105C59.6399 233.105 62.6027 233.26 64.593 233.26C66.5833 233.26 66.8345 231.327 66.0229 231.115C62.3773 230.316 61.0054 229.215 59.8395 228.171C59.6278 227.98 59.3522 227.874 59.0666 227.875Z" fill="#263238" />
      <path d="M97.5907 102.711C99.0013 105.287 100.393 107.928 101.764 110.543L105.874 118.395L106.904 120.327C107.122 120.795 107.381 121.244 107.677 121.667C108.397 122.534 109.27 123.261 110.254 123.812C112.634 125.17 115.163 126.251 117.79 127.032L117.39 130.562C116.582 130.579 115.774 130.553 114.969 130.485C114.168 130.434 113.37 130.341 112.579 130.208C110.941 129.955 109.336 129.523 107.793 128.919C106.036 128.259 104.428 127.254 103.066 125.963C102.387 125.261 101.793 124.483 101.294 123.644L100.083 121.712C98.4989 119.136 96.9724 116.546 95.5038 113.944C94.0417 111.323 92.6247 108.695 91.2656 106.009L97.5907 102.711Z" fill="#E58A7B" />
      <path d="M65.4056 102.027C63.4733 106.156 69.6502 119.192 69.6502 119.192L80.2006 114.297C79.0493 110.598 77.6151 106.994 75.9109 103.515C73.1542 98.0465 67.3637 97.8082 65.4056 102.027Z" fill="#A7C2FF" />
      <path opacity="0.8" d="M65.4056 102.027C63.4733 106.156 69.6502 119.192 69.6502 119.192L80.2006 114.297C79.0493 110.598 77.6151 106.994 75.9109 103.515C73.1542 98.0465 67.3637 97.8082 65.4056 102.027Z" fill="#FAFAFA" />
      <path d="M71.0629 102.875L68.6797 117.013C69.2465 118.346 69.6458 119.197 69.6458 119.197L80.1962 114.301C80.1962 114.301 75.4299 106.063 71.0629 102.875Z" fill="#A7C2FF" />
      <path opacity="0.7" d="M71.0629 102.875L68.6797 117.013C69.2465 118.346 69.6458 119.197 69.6458 119.197L80.1962 114.301C80.1962 114.301 75.4299 106.063 71.0629 102.875Z" fill="#FAFAFA" />
      <path d="M95.4423 99.4218C95.4423 99.4218 100.479 105.116 95.7257 140.322H70.4189C70.2386 136.458 72.6797 117.489 68.9375 99.177C71.7348 98.6384 74.564 98.2812 77.4074 98.1078C80.99 97.9016 84.5814 97.9016 88.1639 98.1078C90.6201 98.359 93.0533 98.7983 95.4423 99.4218Z" fill="#A7C2FF" />
      <path opacity="0.8" d="M95.4423 99.4218C95.4423 99.4218 100.479 105.116 95.7257 140.322H70.4189C70.2386 136.458 72.6797 117.489 68.9375 99.177C71.7348 98.6384 74.564 98.2812 77.4074 98.1078C80.99 97.9016 84.5814 97.9016 88.1639 98.1078C90.6201 98.359 93.0533 98.7983 95.4423 99.4218Z" fill="#FAFAFA" />
      <path d="M97.4878 107.805L93.5781 117.466L97.4878 123.154C97.8742 118.045 97.8742 112.914 97.4878 107.805Z" fill="#A7C2FF" />
      <path opacity="0.7" d="M97.4878 107.805L93.5781 117.466L97.4878 123.154C97.8742 118.045 97.8742 112.914 97.4878 107.805Z" fill="#FAFAFA" />
      <path d="M89.2883 102.545C87.7296 106.796 93.9903 119.691 93.9903 119.691L105.326 113.977C103.874 110.112 102.013 106.413 99.7743 102.944C96.3799 97.9843 91.0017 97.9006 89.2883 102.545Z" fill="#A7C2FF" />
      <path opacity="0.8" d="M89.2883 102.545C87.7296 106.796 93.9903 119.691 93.9903 119.691L105.326 113.977C103.874 110.112 102.013 106.413 99.7743 102.944C96.3799 97.9843 91.0017 97.9006 89.2883 102.545Z" fill="#FAFAFA" />
      <path d="M116.852 127.199L121.49 125.344L122.778 130.935C122.778 130.935 119.094 132.268 116.414 130.329L116.852 127.199Z" fill="#E58A7B" />
      <path d="M126.599 125.402L125.884 130.4L122.766 130.935L121.484 125.344L126.599 125.402Z" fill="#E58A7B" />
      <path d="M58.3216 217.477H63.0557L59.919 225.347L55.5391 224.459L58.3216 217.477Z" fill="#CF6F64" />
      <path d="M79.4412 81.4146C78.7971 86.0585 78.153 88.7444 79.9629 91.5849C82.7133 95.8553 88.8129 94.9343 90.8611 90.5801C92.7097 86.664 93.502 79.7206 89.3926 76.9574C88.4864 76.353 87.4417 75.9883 86.3563 75.8975C85.2708 75.8066 84.18 75.9925 83.186 76.4377C82.1919 76.8829 81.3269 77.573 80.672 78.4434C80.0171 79.3138 79.5937 80.336 79.4412 81.4146Z" fill="#E58A7B" />
      <path d="M97.2917 73.6066C93.2854 69.903 96.4544 68.9626 96.4544 68.9626C96.4544 68.9626 92.0616 67.1462 93.8007 71.0366C96.229 76.4599 89.4273 74.7917 86.1681 71.0366C84.1585 68.7178 78.8704 71.0946 79.1281 73.3554C79.3857 75.6162 71.0768 73.8642 74.8384 78.798C74.9092 83.9508 76.9124 88.9619 79.5725 90.321C84.1328 92.6462 87.5529 86.1408 88.8283 80.93C95.7073 84.2342 101.44 77.439 97.2917 73.6066Z" fill="#263238" />
      <path d="M85.3516 84.0371C85.3774 85.2093 85.787 86.3406 86.5174 87.2576C87.49 88.4428 88.5979 87.7922 88.8555 86.4203C89.0874 85.1836 88.8555 83.0774 87.6317 82.3882C86.4079 81.699 85.3452 82.633 85.3516 84.0371Z" fill="#E58A7B" />
      <path d="M74.8828 73.9743C76.9499 73.8957 78.9775 74.5556 80.6024 75.8357C80.6024 75.8357 79.4366 70.8504 74.8828 73.9743Z" fill="#263238" />
      <path d="M84.6477 140.32C84.6477 140.32 85.5945 159.489 89.092 176.39C90.2063 181.742 89.4785 187.475 86.3417 191.951C77.1246 205.098 62.5099 222.604 62.5099 222.604L54.8516 221.748C54.8516 221.748 67.2505 198.76 73.6014 187.34C75.0441 184.763 76.3195 182.406 75.2309 179.611C64.7128 152.912 70.4002 140.32 70.4002 140.32H84.6477Z" fill="#A7C2FF" />
      <path opacity="0.3" d="M84.6477 140.32C84.6477 140.32 85.5945 159.489 89.092 176.39C90.2063 181.742 89.4785 187.475 86.3417 191.951C77.1246 205.098 62.5099 222.604 62.5099 222.604L54.8516 221.748C54.8516 221.748 67.2505 198.76 73.6014 187.34C75.0441 184.763 76.3195 182.406 75.2309 179.611C64.7128 152.912 70.4002 140.32 70.4002 140.32H84.6477Z" fill="black" />
      <path d="M86.0699 156.888L78.7401 148.141C78.4631 152.063 80.8334 166.736 88.962 175.753C87.6673 169.396 86.7334 162.691 86.0699 156.888Z" fill="#A7C2FF" />
      <path opacity="0.4" d="M86.0699 156.888L78.7401 148.141C78.4631 152.063 80.8334 166.736 88.962 175.753C87.6673 169.396 86.7334 162.691 86.0699 156.888Z" fill="black" />
      <path d="M64.6604 221.442L63.1597 224.546L53.9297 222.176L54.664 219.297L64.6604 221.442Z" fill="#A7C2FF" />
      <path opacity="0.1" d="M64.6604 221.442L63.1597 224.546L53.9297 222.176L54.664 219.297L64.6604 221.442Z" fill="black" />
      <path d="M92.1719 228.425H96.8996L98.2844 217.469H93.5567L92.1719 228.425Z" fill="#E58A7B" />
      <path d="M98.9693 228.655C98.4809 228.655 97.9936 228.609 97.5136 228.519C97.4911 228.516 97.4702 228.505 97.4541 228.489C97.4379 228.473 97.4272 228.452 97.4234 228.429C97.4195 228.406 97.423 228.383 97.4334 228.362C97.4439 228.341 97.4607 228.324 97.4814 228.313C97.5523 228.275 99.2012 227.334 99.9934 227.547C100.067 227.564 100.137 227.597 100.198 227.642C100.259 227.687 100.31 227.745 100.348 227.811C100.398 227.883 100.425 227.968 100.425 228.056C100.425 228.143 100.398 228.229 100.348 228.3C100.161 228.584 99.5747 228.655 98.9693 228.655ZM97.8743 228.358C98.7632 228.481 99.9612 228.461 100.174 228.165C100.174 228.127 100.232 228.062 100.174 227.92C100.15 227.881 100.118 227.846 100.081 227.82C100.043 227.793 100 227.775 99.9548 227.766C99.4459 227.643 98.454 228.075 97.9065 228.371L97.8743 228.358Z" fill="#A7C2FF" />
      <path d="M97.5315 228.541C97.5104 228.547 97.4882 228.547 97.4671 228.541C97.4522 228.528 97.4405 228.512 97.4327 228.495C97.4249 228.477 97.4212 228.457 97.422 228.438C97.422 228.38 97.5572 227.105 98.1563 226.615C98.2433 226.538 98.346 226.481 98.4572 226.448C98.5683 226.415 98.6854 226.406 98.8004 226.422C99.1095 226.454 99.1933 226.609 99.2126 226.737C99.3028 227.272 98.1691 228.296 97.6023 228.547L97.5315 228.541ZM98.6909 226.609C98.5461 226.608 98.4061 226.661 98.298 226.757C97.9394 227.165 97.7145 227.673 97.6539 228.212C98.24 227.865 99.0065 227.06 98.9421 226.737C98.9421 226.737 98.9421 226.634 98.7231 226.609H98.6909Z" fill="#A7C2FF" />
      <path d="M97.0321 227.875H91.8793C91.7849 227.875 91.6934 227.907 91.6205 227.967C91.5476 228.027 91.4979 228.111 91.48 228.203L90.5396 232.409C90.5172 232.511 90.5181 232.616 90.5422 232.717C90.5662 232.818 90.6128 232.913 90.6785 232.993C90.7442 233.074 90.8272 233.138 90.9214 233.182C91.0155 233.226 91.1184 233.248 91.2223 233.247C93.0902 233.215 95.7826 233.105 98.1206 233.105C100.865 233.105 103.228 233.26 106.442 233.26C108.375 233.26 108.922 231.327 108.111 231.115C104.407 230.303 101.386 230.22 98.185 228.249C97.8446 228.016 97.4443 227.886 97.0321 227.875Z" fill="#263238" />
      <path d="M93.5539 217.477H98.288L97.2703 225.457L92.6328 224.742L93.5539 217.477Z" fill="#CF6F64" />
      <path d="M95.7303 140.32C95.7303 140.32 99.6915 153.563 106.236 170.593C108.368 176.132 109.192 181.466 107.711 186.155C103.118 200.711 99.1505 222.604 99.1505 222.604L91.2602 221.748C91.2602 221.748 90.9575 199.417 93.7529 187.907C95.1893 182 94.6997 179.849 93.2247 177.897C73.1288 151.161 78.5263 140.34 78.5263 140.34L95.7303 140.32Z" fill="#A7C2FF" />
      <path opacity="0.3" d="M95.7303 140.32C95.7303 140.32 99.6915 153.563 106.236 170.593C108.368 176.132 109.192 181.466 107.711 186.155C103.118 200.711 99.1505 222.604 99.1505 222.604L91.2602 221.748C91.2602 221.748 90.9575 199.417 93.7529 187.907C95.1893 182 94.6997 179.849 93.2247 177.897C73.1288 151.161 78.5263 140.34 78.5263 140.34L95.7303 140.32Z" fill="black" />
      <path d="M100.519 221.268L100.106 224.412L90.7926 222.834L90.5156 219.961L100.519 221.268Z" fill="#A7C2FF" />
      <path opacity="0.1" d="M100.519 221.268L100.106 224.412L90.7926 222.834L90.5156 219.961L100.519 221.268Z" fill="black" />
      <path d="M168.965 60.375H160.914V61.0191H168.965V60.375Z" fill="#A7C2FF" />
      <path opacity="0.2" d="M168.965 60.375H160.914V61.0191H168.965V60.375Z" fill="black" />
      <path d="M145.464 33.8047H189.089C190.252 33.8064 191.367 34.2691 192.189 35.0913C193.011 35.9135 193.474 37.0282 193.476 38.191V54.3837C193.474 55.5465 193.011 56.6612 192.189 57.4835C191.367 58.3057 190.252 58.7684 189.089 58.7701H186.062L187.241 63.53C185.53 63.3743 183.869 62.872 182.358 62.0537C180.848 61.2354 179.52 60.1182 178.455 58.7701H145.464C144.302 58.7667 143.188 58.3034 142.367 57.4816C141.545 56.6597 141.082 55.546 141.078 54.3837V38.191C141.082 37.0287 141.545 35.915 142.367 35.0932C143.188 34.2713 144.302 33.8081 145.464 33.8047Z" fill="#A7C2FF" />
      <path opacity="0.2" d="M145.464 33.8047H189.089C190.252 33.8064 191.367 34.2691 192.189 35.0913C193.011 35.9135 193.474 37.0282 193.476 38.191V54.3837C193.474 55.5465 193.011 56.6612 192.189 57.4835C191.367 58.3057 190.252 58.7684 189.089 58.7701H186.062L187.241 63.53C185.53 63.3743 183.869 62.872 182.358 62.0537C180.848 61.2354 179.52 60.1182 178.455 58.7701H145.464C144.302 58.7667 143.188 58.3034 142.367 57.4816C141.545 56.6597 141.082 55.546 141.078 54.3837V38.191C141.082 37.0287 141.545 35.915 142.367 35.0932C143.188 34.2713 144.302 33.8081 145.464 33.8047Z" fill="black" />
      <path d="M169.535 11.0625H168.891V16.4279H169.535V11.0625Z" fill="#A7C2FF" />
      <path opacity="0.1" d="M169.535 11.0625H168.891V16.4279H169.535V11.0625Z" fill="#FAFAFA" />
      <path d="M162.894 4H119.269C118.109 4.00169 116.996 4.4626 116.174 5.28205C115.352 6.10149 114.888 7.21288 114.883 8.37345V24.579C114.885 25.7419 115.347 26.8565 116.169 27.6788C116.992 28.501 118.106 28.9637 119.269 28.9654H122.296L121.092 33.7253C122.806 33.5754 124.471 33.0777 125.986 32.2627C127.501 31.4476 128.834 30.3322 129.903 28.9847H162.894C164.056 28.9813 165.17 28.5181 165.992 27.6962C166.814 26.8744 167.277 25.7607 167.28 24.5984V8.37345C167.274 7.2134 166.809 6.10299 165.987 5.28391C165.166 4.46483 164.054 4.00338 162.894 4Z" fill="#A7C2FF" />
      <path opacity="0.1" d="M162.894 4H119.269C118.109 4.00169 116.996 4.4626 116.174 5.28205C115.352 6.10149 114.888 7.21288 114.883 8.37345V24.579C114.885 25.7419 115.347 26.8565 116.169 27.6788C116.992 28.501 118.106 28.9637 119.269 28.9654H122.296L121.092 33.7253C122.806 33.5754 124.471 33.0777 125.986 32.2627C127.501 31.4476 128.834 30.3322 129.903 28.9847H162.894C164.056 28.9813 165.17 28.5181 165.992 27.6962C166.814 26.8744 167.277 25.7607 167.28 24.5984V8.37345C167.274 7.2134 166.809 6.10299 165.987 5.28391C165.166 4.46483 164.054 4.00338 162.894 4Z" fill="#FAFAFA" />
    </MuiSvgIcon>
  );
}

